export const LatestLaunch = [
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://i.imgur.com/J1uM5nz.png",
        "large": "https://i.imgur.com/jYYTXwC.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/pc1fq7/inspiration4_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/po651k/rspacex_inspiration4_launch_discussion_updates/",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://youtu.be/3pv01sSq44w",
      "youtube_id": "3pv01sSq44w",
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/Inspiration4"
    },
    "static_fire_date_utc": "2021-09-13T07:07:00.000Z",
    "static_fire_date_unix": 1631516820,
    "net": false,
    "window": 18000,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Inspiration4 is the world’s first all-civilian mission to space. The mission will be commanded by Jared Isaacman, the 37-year-old founder and Chief Executive Officer of Shift4 Payments and an accomplished pilot and adventurer. Inspiration4 will leave Earth from Kennedy Space Center’s historic Launch Complex 39A, the embarkation point for Apollo and Space Shuttle missions, and travel across a low earth orbit on a multi-day journey that will continually eclipse more than 90% of the earth’s population. Named in recognition of the four-person crew that will raise awareness and funds for St. Jude Children’s Research Hospital, this milestone represents a new era for human spaceflight and exploration.",
    "crew": [
      "607a3a5f5a906a44023e0870",
      "607a3ab45a906a44023e0872",
      "607b48375a906a44023e08b8",
      "607b48da5a906a44023e08b9"
    ],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ee68c683c228f36bd5809b5",
      "614251b711a64135defb3654"
    ],
    "capsules": [
      "5f6f99fddcfdf403df379709"
    ],
    "payloads": [
      "607a382f5a906a44023e0867"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 135,
    "name": "Inspiration4",
    "date_utc": "2021-09-16T00:02:00.000Z",
    "date_unix": 1631750520,
    "date_local": "2021-09-15T20:02:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5f57c5440622a633027900a0",
        "flight": 3,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "621d64e6-0513-45dc-8ffa-c9fd56518398",
    "id": "607a37565a906a44023e0866"
  }
]

export const Cores = [
  {
    "block": null,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Engine failure at T+33 seconds resulted in loss of vehicle",
    "launches": [
      "5eb87cd9ffd86e000604b32a"
    ],
    "serial": "Merlin1A",
    "status": "lost",
    "id": "5e9e289df35918033d3b2623"
  },
  {
    "block": null,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Successful first-stage burn and transition to second stage, maximal altitude 289 km. Harmonic oscillation at T+5 minutes Premature engine shutdown at T+7 min 30 s. Failed to reach orbit.",
    "launches": [
      "5eb87cdaffd86e000604b32b"
    ],
    "serial": "Merlin2A",
    "status": "lost",
    "id": "5e9e289ef35918416a3b2624"
  },
  {
    "block": null,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Residual stage-1 thrust led to collision between stage 1 and stage 2.",
    "launches": [
      "5eb87cdbffd86e000604b32c"
    ],
    "serial": "Merlin1C",
    "status": "lost",
    "id": "5e9e289ef3591814873b2625"
  },
  {
    "block": null,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Initially scheduled for 23–25 Sep, carried dummy payload – mass simulator, 165 kg (originally intended to be RazakSAT.",
    "launches": [
      "5eb87cdbffd86e000604b32d"
    ],
    "serial": "Merlin2C",
    "status": "lost",
    "id": "5e9e289ef3591855dc3b2626"
  },
  {
    "block": null,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": null,
    "launches": [
      "5eb87cdcffd86e000604b32e"
    ],
    "serial": "Merlin3C",
    "status": "lost",
    "id": "5e9e289ef359184f103b2627"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87cddffd86e000604b32f"
    ],
    "serial": "B0003",
    "status": "expended",
    "id": "5e9e289ef359185f2b3b2628"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "First flight of Dragon",
    "launches": [
      "5eb87cdeffd86e000604b330"
    ],
    "serial": "B0004",
    "status": "lost",
    "id": "5e9e289ef35918187c3b2629"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": null,
    "launches": [
      "5eb87cdfffd86e000604b331"
    ],
    "serial": "B0005",
    "status": "lost",
    "id": "5e9e289ef35918f39c3b262a"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Suffered engine out at T+1:19 but primary mission successful",
    "launches": [
      "5eb87ce0ffd86e000604b332"
    ],
    "serial": "B0006",
    "status": "lost",
    "id": "5e9e289ff3591821a73b262b"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": null,
    "launches": [
      "5eb87ce1ffd86e000604b333"
    ],
    "serial": "B0007",
    "status": "lost",
    "id": "5e9e289ff3591884e03b262c"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "First flight of Falcon 9 v1.1 upgrade, first Spacex flight from Vandenberg",
    "launches": [
      "5eb87ce1ffd86e000604b334"
    ],
    "serial": "B1003",
    "status": "lost",
    "id": "5e9e289ff359180ae23b262d"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": null,
    "launches": [
      "5eb87ce2ffd86e000604b335"
    ],
    "serial": "B1004",
    "status": "lost",
    "id": "5e9e289ff35918862c3b262e"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": null,
    "launches": [
      "5eb87ce3ffd86e000604b336"
    ],
    "serial": "B1005",
    "status": "lost",
    "id": "5e9e289ff3591878603b262f"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Broke up after sucessful water landing",
    "launches": [
      "5eb87ce4ffd86e000604b337"
    ],
    "serial": "B1006",
    "status": "lost",
    "id": "5e9e289ff3591829343b2630"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Broke up after sucessful water landing",
    "launches": [
      "5eb87ce4ffd86e000604b338"
    ],
    "serial": "B1007",
    "status": "lost",
    "id": "5e9e28a0f3591870a63b2631"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": null,
    "launches": [
      "5eb87ce5ffd86e000604b339"
    ],
    "serial": "B1008",
    "status": "lost",
    "id": "5e9e28a0f359186e2e3b2632"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": null,
    "launches": [
      "5eb87ce6ffd86e000604b33a"
    ],
    "serial": "B1011",
    "status": "lost",
    "id": "5e9e28a0f35918b1bc3b2633"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Broke up after sucessful water landing",
    "launches": [
      "5eb87ce7ffd86e000604b33b"
    ],
    "serial": "B1010",
    "status": "lost",
    "id": "5e9e28a0f359184a683b2634"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Destroyed on impact with droneship, grid fin hydraulic fluid depleted",
    "launches": [
      "5eb87ce8ffd86e000604b33c"
    ],
    "serial": "B1012",
    "status": "lost",
    "id": "5e9e28a0f359187a3c3b2635"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Broke up after sucessful water landing",
    "launches": [
      "5eb87ceaffd86e000604b33d"
    ],
    "serial": "B1013",
    "status": "lost",
    "id": "5e9e28a0f3591885be3b2636"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": null,
    "launches": [
      "5eb87ceaffd86e000604b33e"
    ],
    "serial": "B1014",
    "status": "lost",
    "id": "5e9e28a0f35918c0893b2637"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Destroyed on impact with droneship due to excess lateral velocity - throttle stiction",
    "launches": [
      "5eb87cecffd86e000604b33f"
    ],
    "serial": "B1015",
    "status": "lost",
    "id": "5e9e28a1f359186d533b2638"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": null,
    "launches": [
      "5eb87cedffd86e000604b340"
    ],
    "serial": "B1016",
    "status": "lost",
    "id": "5e9e28a1f35918233f3b2639"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "RUD at T + 139s - second stage overpressure event due to defective COPV strut heim joint",
    "launches": [
      "5eb87ceeffd86e000604b341"
    ],
    "serial": "B1018",
    "status": "lost",
    "id": "5e9e28a1f35918683c3b263a"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 1,
    "rtls_landings": 1,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Retired; permanently displayed at Hawthorne headquarters. ",
    "launches": [
      "5eb87cefffd86e000604b342"
    ],
    "serial": "B1019",
    "status": "inactive",
    "id": "5e9e28a1f3591867753b263b"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Destroyed after drone ship landing due to landing leg failure",
    "launches": [
      "5eb87cf0ffd86e000604b343"
    ],
    "serial": "B1017",
    "status": "lost",
    "id": "5e9e28a1f3591842fa3b263c"
  },
  {
    "block": 1,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Destroyed on Impact with DroneShip (OCISLY) - Excess Velocity, Possible Fuel Exhaustion",
    "launches": [
      "5eb87cf2ffd86e000604b344"
    ],
    "serial": "B1020",
    "status": "lost",
    "id": "5e9e28a1f359188def3b263d"
  },
  {
    "block": 2,
    "reuse_count": 1,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 2,
    "asds_landings": 2,
    "last_update": "Retired; stored in Hangar E at CCAFS until put on permanent display ",
    "launches": [
      "5eb87cf3ffd86e000604b345",
      "5eb87d00ffd86e000604b34f"
    ],
    "serial": "B1021",
    "status": "inactive",
    "id": "5e9e28a2f359182d0b3b263e"
  },
  {
    "block": 2,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 1,
    "asds_landings": 1,
    "last_update": "Removed from active fleet for Δ Qualification Testing. Retired after eight to ten test cycles. Currently partially disassembled at McGregor.",
    "launches": [
      "5eb87cf5ffd86e000604b346"
    ],
    "serial": "B1022",
    "status": "inactive",
    "id": "5e9e28a2f35918077b3b263f"
  },
  {
    "block": 2,
    "reuse_count": 1,
    "rtls_attempts": 1,
    "rtls_landings": 1,
    "asds_attempts": 1,
    "asds_landings": 1,
    "last_update": "*At LZ1 as 2018/02/06 ",
    "launches": [
      "5eb87cf6ffd86e000604b347",
      "5eb87d13ffd86e000604b360"
    ],
    "serial": "B1023",
    "status": "inactive",
    "id": "5e9e28a2f3591845c73b2640"
  },
  {
    "block": 2,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "RUD on deck of droneship (OCISLY)",
    "launches": [
      "5eb87cf8ffd86e000604b348"
    ],
    "serial": "B1024",
    "status": "lost",
    "id": "5e9e28a2f359184f403b2641"
  },
  {
    "block": 2,
    "reuse_count": 1,
    "rtls_attempts": 2,
    "rtls_landings": 2,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "*At LZ2 as 2018/02/06 ",
    "launches": [
      "5eb87cf9ffd86e000604b349",
      "5eb87d13ffd86e000604b360"
    ],
    "serial": "B1025",
    "status": "inactive",
    "id": "5e9e28a2f359187f273b2642"
  },
  {
    "block": 2,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 1,
    "asds_landings": 1,
    "last_update": "Permanently scrapped. ",
    "launches": [
      "5eb87cfaffd86e000604b34a"
    ],
    "serial": "B1026",
    "status": "inactive",
    "id": "5e9e28a2f35918b8243b2643"
  },
  {
    "block": 3,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "---",
    "launches": [
      "5eb87cfbffd86e000604b34b"
    ],
    "serial": "B1028",
    "status": "lost",
    "id": "5e9e28a2f359187ee83b2644"
  },
  {
    "block": 3,
    "reuse_count": 1,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 2,
    "asds_landings": 2,
    "last_update": "Will be given to KSC Visitors Center. ",
    "launches": [
      "5eb87cfdffd86e000604b34c",
      "5eb87d04ffd86e000604b353"
    ],
    "serial": "B1029",
    "status": "inactive",
    "id": "5e9e28a3f359189e3a3b2645"
  },
  {
    "block": 3,
    "reuse_count": 1,
    "rtls_attempts": 1,
    "rtls_landings": 1,
    "asds_attempts": 1,
    "asds_landings": 1,
    "last_update": "Stored outside at McGregor, partially disassembled (missing engines). ",
    "launches": [
      "5eb87cfeffd86e000604b34d",
      "5eb87d0cffd86e000604b35a"
    ],
    "serial": "B1031",
    "status": "inactive",
    "id": "5e9e28a3f3591829dc3b2646"
  },
  {
    "block": 3,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87cfeffd86e000604b34e"
    ],
    "serial": "B1030",
    "status": "expended",
    "id": "5e9e28a3f3591878473b2647"
  },
  {
    "block": 3,
    "reuse_count": 1,
    "rtls_attempts": 1,
    "rtls_landings": 1,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Survived water landing, SpaceX couldn't tug it back to port, so they hired a company to destroy it. ",
    "launches": [
      "5eb87d01ffd86e000604b350",
      "5eb87d11ffd86e000604b35f"
    ],
    "serial": "B1032",
    "status": "lost",
    "id": "5e9e28a3f3591811f83b2648"
  },
  {
    "block": 3,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87d01ffd86e000604b351"
    ],
    "serial": "B1034",
    "status": "expended",
    "id": "5e9e28a3f359186f3f3b2649"
  },
  {
    "block": 3,
    "reuse_count": 1,
    "rtls_attempts": 2,
    "rtls_landings": 2,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Retired; permanently displayed at Space Center Houston. ",
    "launches": [
      "5eb87d03ffd86e000604b352",
      "5eb87d0effd86e000604b35c"
    ],
    "serial": "B1035",
    "status": "inactive",
    "id": "5e9e28a3f3591856803b264a"
  },
  {
    "block": 3,
    "reuse_count": 1,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 1,
    "asds_landings": 1,
    "last_update": "Broke Up After Successful Water Landing",
    "launches": [
      "5eb87d05ffd86e000604b354",
      "5eb87d0fffd86e000604b35d"
    ],
    "serial": "B1036",
    "status": "lost",
    "id": "5e9e28a3f3591801cf3b264b"
  },
  {
    "block": 3,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87d06ffd86e000604b355"
    ],
    "serial": "B1037",
    "status": "expended",
    "id": "5e9e28a4f3591850cc3b264c"
  },
  {
    "block": 4,
    "reuse_count": 1,
    "rtls_attempts": 1,
    "rtls_landings": 1,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87d07ffd86e000604b356",
      "5eb87d16ffd86e000604b364"
    ],
    "serial": "B1039",
    "status": "expended",
    "id": "5e9e28a4f3591884ee3b264d"
  },
  {
    "block": 3,
    "reuse_count": 1,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 1,
    "asds_landings": 1,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87d08ffd86e000604b357",
      "5eb87d14ffd86e000604b361"
    ],
    "serial": "B1038",
    "status": "expended",
    "id": "5e9e28a4f359182d843b264e"
  },
  {
    "block": 4,
    "reuse_count": 1,
    "rtls_attempts": 1,
    "rtls_landings": 1,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87d09ffd86e000604b358",
      "5eb87d1bffd86e000604b368"
    ],
    "serial": "B1040",
    "status": "expended",
    "id": "5e9e28a4f3591845123b264f"
  },
  {
    "block": 4,
    "reuse_count": 1,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 1,
    "asds_landings": 1,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87d0affd86e000604b359",
      "5eb87d16ffd86e000604b363"
    ],
    "serial": "B1041",
    "status": "expended",
    "id": "5e9e28a4f3591843103b2650"
  },
  {
    "block": 4,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 1,
    "asds_landings": 1,
    "last_update": "Retired. ",
    "launches": [
      "5eb87d0dffd86e000604b35b"
    ],
    "serial": "B1042",
    "status": "inactive",
    "id": "5e9e28a4f359185cc03b2651"
  },
  {
    "block": 4,
    "reuse_count": 1,
    "rtls_attempts": 1,
    "rtls_landings": 1,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87d10ffd86e000604b35e",
      "5eb87d1affd86e000604b367"
    ],
    "serial": "B1043",
    "status": "expended",
    "id": "5e9e28a4f35918345e3b2652"
  },
  {
    "block": 3,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Two of the outer engines didn't re-ignite for the landing burn, ran out of TEA/TEB igniters. ",
    "launches": [
      "5eb87d13ffd86e000604b360"
    ],
    "serial": "B1033",
    "status": "lost",
    "id": "5e9e28a5f359187f703b2653"
  },
  {
    "block": 4,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87d15ffd86e000604b362"
    ],
    "serial": "B1044",
    "status": "expended",
    "id": "5e9e28a5f359186cb73b2654"
  },
  {
    "block": 4,
    "reuse_count": 1,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 1,
    "asds_landings": 1,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87d18ffd86e000604b365",
      "5eb87d1cffd86e000604b369"
    ],
    "serial": "B1045",
    "status": "expended",
    "id": "5e9e28a5f35918863d3b2655"
  },
  {
    "block": 5,
    "reuse_count": 3,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 3,
    "asds_landings": 3,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87d19ffd86e000604b366",
      "5eb87d20ffd86e000604b36c",
      "5eb87d25ffd86e000604b370",
      "5eb87d3dffd86e000604b381"
    ],
    "serial": "B1046",
    "status": "expended",
    "id": "5e9e28a5f359182b023b2656"
  },
  {
    "block": 5,
    "reuse_count": 2,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 2,
    "asds_landings": 2,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87d1effd86e000604b36a",
      "5eb87d24ffd86e000604b36f",
      "5eb87d37ffd86e000604b37c"
    ],
    "serial": "B1047",
    "status": "expended",
    "id": "5e9e28a5f359181eed3b2657"
  },
  {
    "block": 5,
    "reuse_count": 4,
    "rtls_attempts": 1,
    "rtls_landings": 1,
    "asds_attempts": 3,
    "asds_landings": 3,
    "last_update": "Landing burn not performed after premature engine shutdown during ascent",
    "launches": [
      "5eb87d1fffd86e000604b36b",
      "5eb87d23ffd86e000604b36e",
      "5eb87d2affd86e000604b374",
      "5eb87d39ffd86e000604b37d",
      "5eb87d43ffd86e000604b385"
    ],
    "serial": "B1048",
    "status": "lost",
    "id": "5e9e28a5f3591809c03b2658"
  },
  {
    "block": 5,
    "reuse_count": 9,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 10,
    "asds_landings": 10,
    "last_update": "Landed on OCISLY as of Sep 14, 2021 ",
    "launches": [
      "5eb87d22ffd86e000604b36d",
      "5eb87d28ffd86e000604b373",
      "5eb87d30ffd86e000604b378",
      "5eb87d3cffd86e000604b380",
      "5eb87d45ffd86e000604b387",
      "5ed981d91f30554030d45c2a",
      "5fb95b3f3a88ae63c954603c",
      "5fbfecfe54ceb10a5664c80b",
      "605b4b7daa5433645e37d040",
      "60e3bf0d73359e1e20335c37"
    ],
    "serial": "B1049",
    "status": "unknown",
    "id": "5e9e28a5f3591833b13b2659"
  },
  {
    "block": 5,
    "reuse_count": 0,
    "rtls_attempts": 1,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Towed to Port of Canaveral; cannibalized for parts to build Starhopper. ",
    "launches": [
      "5eb87d26ffd86e000604b371"
    ],
    "serial": "B1050",
    "status": "inactive",
    "id": "5e9e28a6f359185c603b265a"
  },
  {
    "block": 5,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Stage Expended",
    "launches": [
      "5eb87d27ffd86e000604b372"
    ],
    "serial": "B1054",
    "status": "expended",
    "id": "5e9e28a6f35918513b3b265b"
  },
  {
    "block": 5,
    "reuse_count": 9,
    "rtls_attempts": 1,
    "rtls_landings": 1,
    "asds_attempts": 9,
    "asds_landings": 9,
    "last_update": "landed on JRTI as of May 9, 2021. ",
    "launches": [
      "5eb87d2bffd86e000604b375",
      "5eb87d31ffd86e000604b379",
      "5eb87d3fffd86e000604b382",
      "5eb87d44ffd86e000604b386",
      "5ed9819a1f30554030d45c29",
      "5ef6a2bf0059c33cee4a828c",
      "5eb87d4bffd86e000604b38c",
      "5fbfecce54ceb10a5664c80a",
      "600f9a8d8f798e2a4d5f979e",
      "6079bd1c9a06446e8c61bf76"
    ],
    "serial": "B1051",
    "status": "unknown",
    "id": "5e9e28a6f35918c0803b265c"
  },
  {
    "block": 5,
    "reuse_count": 1,
    "rtls_attempts": 2,
    "rtls_landings": 2,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Landed at LZ-1 as of Jun 25, 2019. ",
    "launches": [
      "5eb87d2dffd86e000604b376",
      "5eb87d35ffd86e000604b37a"
    ],
    "serial": "B1052",
    "status": "unknown",
    "id": "5e9e28a6f359183c413b265d"
  },
  {
    "block": 5,
    "reuse_count": 1,
    "rtls_attempts": 2,
    "rtls_landings": 2,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Landed at LZ-2 as of Jun 25, 2019. ",
    "launches": [
      "5eb87d2dffd86e000604b376",
      "5eb87d35ffd86e000604b37a"
    ],
    "serial": "B1053",
    "status": "unknown",
    "id": "5e9e28a6f359188fd53b265e"
  },
  {
    "block": 5,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 1,
    "asds_landings": 1,
    "last_update": "Toppled by rough seas and broken in two after safely landing aboard OCISLY",
    "launches": [
      "5eb87d2dffd86e000604b376"
    ],
    "serial": "B1055",
    "status": "lost",
    "id": "5e9e28a6f3591897453b265f"
  },
  {
    "block": 5,
    "reuse_count": 3,
    "rtls_attempts": 1,
    "rtls_landings": 1,
    "asds_attempts": 2,
    "asds_landings": 2,
    "last_update": "Missed the droneship and made successful water landing; apparently scuttled at sea afterward. ",
    "launches": [
      "5eb87d2effd86e000604b377",
      "5eb87d36ffd86e000604b37b",
      "5eb87d3bffd86e000604b37f",
      "5eb87d41ffd86e000604b383"
    ],
    "serial": "B1056",
    "status": "lost",
    "id": "5e9e28a7f3591809313b2660"
  },
  {
    "block": 5,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "Exploded upon ocean impact a safe distance from OCISLY",
    "launches": [
      "5eb87d35ffd86e000604b37a"
    ],
    "serial": "B1057",
    "status": "lost",
    "id": "5e9e28a7f3591878063b2661"
  },
  {
    "block": 5,
    "reuse_count": 5,
    "rtls_attempts": 3,
    "rtls_landings": 3,
    "asds_attempts": 2,
    "asds_landings": 2,
    "last_update": "Exploded upon ocean impact a safe distance from OCISLY",
    "launches": [
      "5eb87d39ffd86e000604b37e",
      "5eb87d42ffd86e000604b384",
      "5eb87d46ffd86e000604b389",
      "5eb87d47ffd86e000604b38a",
      "5f8399fb818d8b59f5740d43",
      "600f9a5e8f798e2a4d5f979c"
    ],
    "serial": "B1059",
    "status": "lost",
    "id": "5e9e28a7f359187afd3b2662"
  },
  {
    "block": 5,
    "reuse_count": 7,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 8,
    "asds_landings": 8,
    "last_update": "Landed on OCISLY as of May 15, 2021 ",
    "launches": [
      "5eb87d46ffd86e000604b388",
      "5eb87d50ffd86e000604b394",
      "5ef6a2090059c33cee4a828b",
      "5eb87d4effd86e000604b391",
      "5fd386aa7faea57d297c86c1",
      "600f9a718f798e2a4d5f979d",
      "60428ac4c041c16716f73cd8",
      "605b4b95aa5433645e37d041"
    ],
    "serial": "B1058",
    "status": "unknown",
    "id": "5e9e28a7f3591817f23b2663"
  },
  {
    "block": 5,
    "reuse_count": 7,
    "rtls_attempts": 1,
    "rtls_landings": 1,
    "asds_attempts": 7,
    "asds_landings": 7,
    "last_update": "Landed on LZ-1 as of Jun 30, 2021. ",
    "launches": [
      "5eb87d4affd86e000604b38b",
      "5ef6a1e90059c33cee4a828a",
      "5ef6a2e70059c33cee4a8293",
      "5eb87d4fffd86e000604b393",
      "5ff6554f9257f579ee3a6c5f",
      "60428aafc041c16716f73cd7",
      "605b4b6aaa5433645e37d03f",
      "600f9b6d8f798e2a4d5f979f"
    ],
    "serial": "B1060",
    "status": "unknown",
    "id": "5ef670f10059c33cee4a826c"
  },
  {
    "block": 5,
    "reuse_count": 3,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 4,
    "asds_landings": 4,
    "last_update": "Landed on ASOG as of Aug 29, 2021. ",
    "launches": [
      "5eb87d4dffd86e000604b38e",
      "5fe3af58b3467846b324215f",
      "5fe3af6db3467846b3242160",
      "5fe3b11eb3467846b324216c"
    ],
    "serial": "B1061",
    "status": "unknown",
    "id": "5f57c53d0622a6330279009f"
  },
  {
    "block": 5,
    "reuse_count": 2,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 3,
    "asds_landings": 3,
    "last_update": "landed on JRTI as of Sep 16, 2021. ",
    "launches": [
      "5eb87d4cffd86e000604b38d",
      "5eb87d4effd86e000604b390",
      "607a37565a906a44023e0866"
    ],
    "serial": "B1062",
    "status": "unknown",
    "id": "5f57c5440622a633027900a0"
  },
  {
    "block": 5,
    "reuse_count": 1,
    "rtls_attempts": 1,
    "rtls_landings": 1,
    "asds_attempts": 1,
    "asds_landings": 1,
    "last_update": "Landed on JRTI* as of May 26, 2021 ",
    "launches": [
      "5ed983aa1f30554030d45c31",
      "6079bd399a06446e8c61bf77"
    ],
    "serial": "B1063",
    "status": "unknown",
    "id": "5f57c54a0622a633027900a1"
  },
  {
    "block": 5,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "At McGregor after static-fire test as of Oct 5, 2020.",
    "launches": [],
    "serial": "B1064",
    "status": "active",
    "id": "5fe3b8f2b3467846b3242181"
  },
  {
    "block": 5,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "unknown",
    "launches": [],
    "serial": "B1065",
    "status": "active",
    "id": "5fe3b8fbb3467846b3242182"
  },
  {
    "block": 5,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 0,
    "asds_landings": 0,
    "last_update": "unknown",
    "launches": [],
    "serial": "B1066",
    "status": "active",
    "id": "5fe3b906b3467846b3242183"
  },
  {
    "block": 5,
    "reuse_count": 0,
    "rtls_attempts": 0,
    "rtls_landings": 0,
    "asds_attempts": 1,
    "asds_landings": 1,
    "last_update": "Landed on OCISLY* as of June 3, 2021 ",
    "launches": [
      "5fe3af84b3467846b3242161"
    ],
    "serial": "B1067",
    "status": "unknown",
    "id": "60b800111f83cc1e59f16438"
  }
]

export const AllLaunches = [
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/3c/0e/T8iJcSN3_o.png",
        "large": "https://images2.imgbox.com/40/e3/GypSkayF_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://www.youtube.com/watch?v=0a_00nJ_Y88",
      "youtube_id": "0a_00nJ_Y88",
      "article": "https://www.space.com/2196-spacex-inaugural-falcon-1-rocket-lost-launch.html",
      "wikipedia": "https://en.wikipedia.org/wiki/DemoSat"
    },
    "static_fire_date_utc": "2006-03-17T00:00:00.000Z",
    "static_fire_date_unix": 1142553600,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69955f709d1eb",
    "success": false,
    "failures": [
      {
        "time": 33,
        "altitude": null,
        "reason": "merlin engine failure"
      }
    ],
    "details": "Engine failure at 33 seconds and loss of vehicle",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4b5b6c3bb0006eeb1e1"
    ],
    "launchpad": "5e9e4502f5090995de566f86",
    "flight_number": 1,
    "name": "FalconSat",
    "date_utc": "2006-03-24T22:30:00.000Z",
    "date_unix": 1143239400,
    "date_local": "2006-03-25T10:30:00+12:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289df35918033d3b2623",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cd9ffd86e000604b32a"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/4f/e3/I0lkuJ2e_o.png",
        "large": "https://images2.imgbox.com/be/e7/iNqsqVYM_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://www.youtube.com/watch?v=Lk4zQ2wP-Nc",
      "youtube_id": "Lk4zQ2wP-Nc",
      "article": "https://www.space.com/3590-spacex-falcon-1-rocket-fails-reach-orbit.html",
      "wikipedia": "https://en.wikipedia.org/wiki/DemoSat"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69955f709d1eb",
    "success": false,
    "failures": [
      {
        "time": 301,
        "altitude": 289,
        "reason": "harmonic oscillation leading to premature engine shutdown"
      }
    ],
    "details": "Successful first stage burn and transition to second stage, maximum altitude 289 km, Premature engine shutdown at T+7 min 30 s, Failed to reach orbit, Failed to recover first stage",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4b6b6c3bb0006eeb1e2"
    ],
    "launchpad": "5e9e4502f5090995de566f86",
    "flight_number": 2,
    "name": "DemoSat",
    "date_utc": "2007-03-21T01:10:00.000Z",
    "date_unix": 1174439400,
    "date_local": "2007-03-21T13:10:00+12:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ef35918416a3b2624",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cdaffd86e000604b32b"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/3d/86/cnu0pan8_o.png",
        "large": "https://images2.imgbox.com/4b/bd/d8UxLh4q_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://www.youtube.com/watch?v=v0w9p3U8860",
      "youtube_id": "v0w9p3U8860",
      "article": "http://www.spacex.com/news/2013/02/11/falcon-1-flight-3-mission-summary",
      "wikipedia": "https://en.wikipedia.org/wiki/Trailblazer_(satellite)"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69955f709d1eb",
    "success": false,
    "failures": [
      {
        "time": 140,
        "altitude": 35,
        "reason": "residual stage-1 thrust led to collision between stage 1 and stage 2"
      }
    ],
    "details": "Residual stage 1 thrust led to collision between stage 1 and stage 2",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4b6b6c3bb0006eeb1e3",
      "5eb0e4b6b6c3bb0006eeb1e4"
    ],
    "launchpad": "5e9e4502f5090995de566f86",
    "flight_number": 3,
    "name": "Trailblazer",
    "date_utc": "2008-08-03T03:34:00.000Z",
    "date_unix": 1217734440,
    "date_local": "2008-08-03T15:34:00+12:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ef3591814873b2625",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cdbffd86e000604b32c"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/e9/c9/T8CfiSYb_o.png",
        "large": "https://images2.imgbox.com/e0/a7/FNjvKlXW_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://www.youtube.com/watch?v=dLQ2tZEH6G0",
      "youtube_id": "dLQ2tZEH6G0",
      "article": "https://en.wikipedia.org/wiki/Ratsat",
      "wikipedia": "https://en.wikipedia.org/wiki/Ratsat"
    },
    "static_fire_date_utc": "2008-09-20T00:00:00.000Z",
    "static_fire_date_unix": 1221868800,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69955f709d1eb",
    "success": true,
    "failures": [],
    "details": "Ratsat was carried to orbit on the first successful orbital launch of any privately funded and developed, liquid-propelled carrier rocket, the SpaceX Falcon 1",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4b7b6c3bb0006eeb1e5"
    ],
    "launchpad": "5e9e4502f5090995de566f86",
    "flight_number": 4,
    "name": "RatSat",
    "date_utc": "2008-09-28T23:15:00.000Z",
    "date_unix": 1222643700,
    "date_local": "2008-09-28T11:15:00+12:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ef3591855dc3b2626",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cdbffd86e000604b32d"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/a7/ba/NBZSw3Ho_o.png",
        "large": "https://images2.imgbox.com/8d/fc/0qdZMWWx_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": "http://www.spacex.com/press/2012/12/19/spacexs-falcon-1-successfully-delivers-razaksat-satellite-orbit",
      "webcast": "https://www.youtube.com/watch?v=yTaIDooc8Og",
      "youtube_id": "yTaIDooc8Og",
      "article": "http://www.spacex.com/news/2013/02/12/falcon-1-flight-5",
      "wikipedia": "https://en.wikipedia.org/wiki/RazakSAT"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69955f709d1eb",
    "success": true,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4b7b6c3bb0006eeb1e6"
    ],
    "launchpad": "5e9e4502f5090995de566f86",
    "flight_number": 5,
    "name": "RazakSat",
    "date_utc": "2009-07-13T03:35:00.000Z",
    "date_unix": 1247456100,
    "date_local": "2009-07-13T15:35:00+12:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ef359184f103b2627",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cdcffd86e000604b32e"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/5c/36/gbDKf6Y7_o.png",
        "large": "https://images2.imgbox.com/d6/12/yxne8mMD_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": "http://forum.nasaspaceflight.com/index.php?action=dlattach;topic=21869.0;attach=230821",
      "webcast": "https://www.youtube.com/watch?v=nxSxgBKlYws",
      "youtube_id": "nxSxgBKlYws",
      "article": "http://www.spacex.com/news/2013/02/12/falcon-9-flight-1",
      "wikipedia": "https://en.wikipedia.org/wiki/Dragon_Spacecraft_Qualification_Unit"
    },
    "static_fire_date_utc": "2010-03-13T00:00:00.000Z",
    "static_fire_date_unix": 1268438400,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4b7b6c3bb0006eeb1e7"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 6,
    "name": "Falcon 9 Test Flight",
    "date_utc": "2010-06-04T18:45:00.000Z",
    "date_unix": 1275677100,
    "date_local": "2010-06-04T14:45:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ef359185f2b3b2628",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cddffd86e000604b32f"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/d9/3e/FfrN88ry_o.png",
        "large": "https://images2.imgbox.com/00/2f/FhtEd0nB_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": "http://www.spacex.com/files/downloads/cots1-20101206.pdf",
      "webcast": "https://www.youtube.com/watch?v=cdLITgWKe_0",
      "youtube_id": "cdLITgWKe_0",
      "article": "https://en.wikipedia.org/wiki/SpaceX_COTS_Demo_Flight_1",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_COTS_Demo_Flight_1"
    },
    "static_fire_date_utc": "2010-12-04T00:00:00.000Z",
    "static_fire_date_unix": 1291420800,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [
      "5ea6ed2d080df4000697c901"
    ],
    "capsules": [
      "5e9e2c5bf35918ed873b2664"
    ],
    "payloads": [
      "5eb0e4b9b6c3bb0006eeb1e8",
      "5eb0e4b9b6c3bb0006eeb1e9"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 7,
    "name": "COTS 1",
    "date_utc": "2010-12-08T15:43:00.000Z",
    "date_unix": 1291822980,
    "date_local": "2010-12-08T11:43:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ef35918187c3b2629",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cdeffd86e000604b330"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/fc/7a/r9ITwL12_o.png",
        "large": "https://images2.imgbox.com/2b/8e/MYyHbnd2_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": "https://www.nasa.gov/pdf/649910main_cots2_presskit_051412.pdf",
      "webcast": "https://www.youtube.com/watch?v=tpQzDbAY7yI",
      "youtube_id": "tpQzDbAY7yI",
      "article": "https://en.wikipedia.org/wiki/Dragon_C2%2B",
      "wikipedia": "https://en.wikipedia.org/wiki/Dragon_C2%2B"
    },
    "static_fire_date_utc": "2012-04-30T00:00:00.000Z",
    "static_fire_date_unix": 1335744000,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Launch was scrubbed on first attempt, second launch attempt was successful",
    "crew": [],
    "ships": [
      "5ea6ed2d080df4000697c901"
    ],
    "capsules": [
      "5e9e2c5bf3591882af3b2665"
    ],
    "payloads": [
      "5eb0e4bab6c3bb0006eeb1ea"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 8,
    "name": "COTS 2",
    "date_utc": "2012-05-22T07:44:00.000Z",
    "date_unix": 1335944640,
    "date_local": "2012-05-22T03:44:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ef35918f39c3b262a",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cdfffd86e000604b331"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/0b/33/2eLGEejP_o.png",
        "large": "https://images2.imgbox.com/52/09/eNvilptL_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": "https://www.nasa.gov/pdf/694166main_SpaceXCRS-1PressKit.pdf",
      "webcast": "https://www.youtube.com/watch?v=-Vk3hiV_zXU",
      "youtube_id": "-Vk3hiV_zXU",
      "article": "https://www.nasa.gov/mission_pages/station/main/spacex-crs1-target.html",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-1"
    },
    "static_fire_date_utc": "2012-09-29T00:00:00.000Z",
    "static_fire_date_unix": 1348876800,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "CRS-1 successful, but the secondary payload was inserted into abnormally low orbit and lost due to Falcon 9 boost stage engine failure, ISS visiting vehicle safety rules, and the primary payload owner's contractual right to decline a second ignition of the second stage under some conditions.",
    "crew": [],
    "ships": [
      "5ea6ed2d080df4000697c902"
    ],
    "capsules": [
      "5e9e2c5bf3591835983b2666"
    ],
    "payloads": [
      "5eb0e4bab6c3bb0006eeb1eb",
      "5eb0e4bab6c3bb0006eeb1ec"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 9,
    "name": "CRS-1",
    "date_utc": "2012-10-08T00:35:00.000Z",
    "date_unix": 1349656500,
    "date_local": "2012-10-08T20:35:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ff3591821a73b262b",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ce0ffd86e000604b332"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/1b/b6/Z4oktZeR_o.png",
        "large": "https://images2.imgbox.com/ef/39/FyZRYeOh_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "https://www.reddit.com/r/space/comments/19gm5f/live_coverage_spacex_crs2_launch_to_the_iss/c8nvah4",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": "https://www.nasa.gov/sites/default/files/files/Orb2_PRESS_KIT.pdf",
      "webcast": "https://www.youtube.com/watch?v=ik0ElKl5kW4",
      "youtube_id": "ik0ElKl5kW4",
      "article": "https://en.wikipedia.org/wiki/SpaceX_CRS-2",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-2"
    },
    "static_fire_date_utc": "2013-02-25T18:30:00.000Z",
    "static_fire_date_unix": 1361817000,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Last launch of the original Falcon 9 v1.0 launch vehicle",
    "crew": [],
    "ships": [
      "5ea6ed2d080df4000697c902"
    ],
    "capsules": [
      "5e9e2c5bf359189ef23b2667"
    ],
    "payloads": [
      "5eb0e4bbb6c3bb0006eeb1ed"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 10,
    "name": "CRS-2",
    "date_utc": "2013-03-01T19:10:00.000Z",
    "date_unix": 1362165000,
    "date_local": "2013-03-01T15:10:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ff3591884e03b262c",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ce1ffd86e000604b333"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/91/27/VhC1TTYN_o.png",
        "large": "https://images2.imgbox.com/89/bc/JcbcvuBI_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "http://www.reddit.com/r/spacex/comments/1ndlay",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": "https://spaceflightnow.com/falcon9/006/UpgradedF9DemoMission_PressKit.pdf",
      "webcast": "https://www.youtube.com/watch?v=uFefasS6bhc",
      "youtube_id": "uFefasS6bhc",
      "article": "http://www.parabolicarc.com/2013/09/29/falcon-9-launch-payloads-orbit-vandenberg/",
      "wikipedia": "https://en.wikipedia.org/wiki/CASSIOPE"
    },
    "static_fire_date_utc": "2013-09-19T00:00:00.000Z",
    "static_fire_date_unix": 1379548800,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Commercial mission and first Falcon 9 v1.1 flight, with improved 13-tonne to LEO capacity. Following second-stage separation from the first stage, an attempt was made to perform an ocean touchdown test of the discarded booster vehicle. The test provided good test data on the experiment-its primary objective-but as the booster neared the ocean, aerodynamic forces caused an uncontrollable roll. The center engine, depleted of fuel by centrifugal force, shut down resulting in the impact and destruction of the vehicle.",
    "crew": [],
    "ships": [
      "5ea6ed2d080df4000697c903"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4bbb6c3bb0006eeb1ee"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 11,
    "name": "CASSIOPE",
    "date_utc": "2013-09-29T16:00:00.000Z",
    "date_unix": 1380470400,
    "date_local": "2013-09-29T09:00:00-07:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ff359180ae23b262d",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "Ocean",
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ce1ffd86e000604b334"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/42/b0/vP0sk3d5_o.png",
        "large": "https://images2.imgbox.com/b5/1d/46Eo0yuu_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "http://www.reddit.com/r/spacex/comments/1ryy1n",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/spacex_ses-8launch_presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=aAj5xapImEs",
      "youtube_id": "aAj5xapImEs",
      "article": "https://www.nasaspaceflight.com/2013/12/spacex-falcon-9-v1-1-milestone-ses-8-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/SES-8"
    },
    "static_fire_date_utc": "2013-11-22T06:26:00.000Z",
    "static_fire_date_unix": 1385101560,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "First GTO launch for Falcon 9",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4bbb6c3bb0006eeb1ef"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 12,
    "name": "SES-8",
    "date_utc": "2013-12-03T22:41:00.000Z",
    "date_unix": 1386110460,
    "date_local": "2013-12-03T18:41:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ff35918862c3b262e",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ce2ffd86e000604b335"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/d8/6d/fnqIBEJh_o.png",
        "large": "https://images2.imgbox.com/37/c4/jRAk115c_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "http://www.reddit.com/r/spacex/comments/1ujoc0",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm9.staticflickr.com/8617/16789019815_f99a165dc5_o.jpg",
          "https://farm8.staticflickr.com/7619/16763151866_35a0a4d8e1_o.jpg",
          "https://farm9.staticflickr.com/8569/16169086873_4d8829832e_o.png"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/spacex_thaicom6_presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=AnSNRzMEmCU",
      "youtube_id": "AnSNRzMEmCU",
      "article": "http://spacenews.com/38959spacex-delivers-thaicom-6-satellite-to-orbit/",
      "wikipedia": "https://en.wikipedia.org/wiki/Thaicom_6"
    },
    "static_fire_date_utc": "2013-12-28T00:00:00.000Z",
    "static_fire_date_unix": 1388188800,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Second GTO launch for Falcon 9. The USAF evaluated launch data from this flight as part of a separate certification program for SpaceX to qualify to fly U.S. military payloads and found that the Thaicom 6 launch had \"unacceptable fuel reserves at engine cutoff of the stage 2 second burnoff\"",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4bbb6c3bb0006eeb1f0"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 13,
    "name": "Thaicom 6",
    "date_utc": "2014-01-06T18:06:00.000Z",
    "date_unix": 1389031560,
    "date_local": "2014-01-06T14:06:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ff3591878603b262f",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ce3ffd86e000604b336"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/a0/cb/s1h2RuR0_o.png",
        "large": "https://images2.imgbox.com/ff/81/EOWojaSj_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "http://www.reddit.com/r/spacex/comments/22zo8c",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm8.staticflickr.com/7615/16670240949_8d43db0e36_o.jpg",
          "https://farm9.staticflickr.com/8597/16856369125_e97cd30ef7_o.jpg",
          "https://farm8.staticflickr.com/7586/16166732954_9338dc859c_o.jpg",
          "https://farm8.staticflickr.com/7603/16855223522_462da54e84_o.jpg",
          "https://farm8.staticflickr.com/7618/16234010894_e1210ec300_o.jpg",
          "https://farm8.staticflickr.com/7617/16855338881_69542a2fa9_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/spacexcrs-3_presskit_042014.pdf",
      "webcast": "https://www.youtube.com/watch?v=Od-lON4bTyQ",
      "youtube_id": "Od-lON4bTyQ",
      "article": "https://newatlas.com/crs-3-launch-spacex/31671/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-3"
    },
    "static_fire_date_utc": "2014-03-08T00:00:00.000Z",
    "static_fire_date_unix": 1394236800,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Following second-stage separation, SpaceX conducted a second controlled-descent test of the discarded booster vehicle and achieved the first successful controlled ocean touchdown of a liquid-rocket-engine orbital booster. Following touchdown the first stage tipped over as expected and was destroyed. This was the first Falcon 9 booster to fly with extensible landing legs and the first Dragon mission with the Falcon 9 v1.1 launch vehicle.",
    "crew": [],
    "ships": [
      "5ea6ed2d080df4000697c902"
    ],
    "capsules": [
      "5e9e2c5bf3591859a63b2668"
    ],
    "payloads": [
      "5eb0e4bbb6c3bb0006eeb1f1"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 14,
    "name": "CRS-3",
    "date_utc": "2014-04-18T19:25:00.000Z",
    "date_unix": 1397849100,
    "date_local": "2014-04-18T15:25:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e289ff3591829343b2630",
        "flight": 1,
        "gridfins": false,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "Ocean",
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ce4ffd86e000604b337"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/a7/b4/bcMrHMey_o.png",
        "large": "https://images2.imgbox.com/4d/ed/CHXoRaSP_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "http://www.reddit.com/r/spacex/comments/2aany2",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm8.staticflickr.com/7585/16602893909_1181317089_o.jpg",
          "https://farm9.staticflickr.com/8747/16581738577_83e0690136_o.png",
          "https://farm8.staticflickr.com/7285/16581736047_6fd536ab11_o.jpg",
          "https://farm8.staticflickr.com/7597/16789021675_35f0148f78_o.jpg",
          "https://farm8.staticflickr.com/7631/16236321533_829ae07b42_o.jpg",
          "https://farm9.staticflickr.com/8726/16830422056_26c2265bbc_o.jpg",
          "https://farm9.staticflickr.com/8591/16670149079_33d6cc3631_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/spacex_orbcomm_presskit_final.pdf",
      "webcast": "https://www.youtube.com/watch?v=lbHnSu-DLR4",
      "youtube_id": "lbHnSu-DLR4",
      "article": "https://www.orbcomm.com/en/networks/satellite/orbcomm-og2",
      "wikipedia": "https://en.wikipedia.org/wiki/Falcon_9_flight_10"
    },
    "static_fire_date_utc": "2015-12-19T04:57:00.000Z",
    "static_fire_date_unix": 1450501020,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Total payload mass was 1,316 kg (2,901 lb) : 6 satellites weighing 172 kg each, plus two 142-kg mass simulators. This was the second Falcon 9 booster equipped with landing legs. Following second-stage separation, SpaceX conducted a controlled-descent test of the first stage, which successfully decelerated from hypersonic velocity in the upper atmosphere, made reentry and landing burns, deployed its legs and touched down on the ocean surface. As with the previous mission, the first stage then tipped over as expected and was not recovered.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4bcb6c3bb0006eeb1f2"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 15,
    "name": "OG-2 Mission 1",
    "date_utc": "2014-07-14T15:15:00.000Z",
    "date_unix": 1405350900,
    "date_local": "2014-07-14T11:15:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a0f3591870a63b2631",
        "flight": 1,
        "gridfins": false,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "Ocean",
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ce4ffd86e000604b338"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/bf/12/oSP2EwNz_o.png",
        "large": "https://images2.imgbox.com/5a/ab/8IzvDOzc_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "http://www.reddit.com/r/spacex/comments/2fenrv",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm9.staticflickr.com/8638/16855192031_962f7b1113_o.jpg",
          "https://farm8.staticflickr.com/7603/16648925347_769a6009c7_o.jpg",
          "https://farm9.staticflickr.com/8687/16789027675_cde1bd098a_o.jpg",
          "https://farm8.staticflickr.com/7629/16668638138_7acf13cfb5_o.jpg",
          "https://farm8.staticflickr.com/7281/16668845950_7680146525_o.jpg",
          "https://farm8.staticflickr.com/7626/16233865484_10d9925b5d_o.jpg"
        ]
      },
      "presskit": "https://spaceflightnow.com/falcon9/011/presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=essrkMGlw5s",
      "youtube_id": "essrkMGlw5s",
      "article": "http://spacenews.com/41497spacex-launches-first-of-two-satellites-for-asiasat/",
      "wikipedia": "https://en.wikipedia.org/wiki/AsiaSat_8"
    },
    "static_fire_date_utc": "2014-07-31T23:35:15.000Z",
    "static_fire_date_unix": 1406849715,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4bcb6c3bb0006eeb1f3"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 16,
    "name": "AsiaSat 8",
    "date_utc": "2014-08-05T08:00:00.000Z",
    "date_unix": 1407225600,
    "date_local": "2014-08-05T04:00:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a0f359186e2e3b2632",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ce5ffd86e000604b339"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/6f/c0/D3Owbmpo_o.png",
        "large": "https://images2.imgbox.com/57/6a/upI6gwfq_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "http://www.reddit.com/r/spacex/comments/2fenrv",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm8.staticflickr.com/7604/16169087563_0e3559ab5b_o.jpg",
          "https://farm9.staticflickr.com/8742/16233828644_96738200b2_o.jpg",
          "https://farm8.staticflickr.com/7645/16601443698_e70315d1ed_o.jpg",
          "https://farm9.staticflickr.com/8730/16830335046_5f017c17be_o.jpg",
          "https://farm9.staticflickr.com/8637/16855040322_57671ab8eb_o.jpg"
        ]
      },
      "presskit": "https://www.spaceflightnow.com/falcon9/012/presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=39ninsyTRk8",
      "youtube_id": "39ninsyTRk8",
      "article": "https://www.space.com/27052-spacex-launches-asiasat6-satellite.html",
      "wikipedia": "https://en.wikipedia.org/wiki/AsiaSat_6"
    },
    "static_fire_date_utc": "2014-08-22T23:51:18.000Z",
    "static_fire_date_unix": 1408751478,
    "net": false,
    "window": 7200,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4bcb6c3bb0006eeb1f4"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 17,
    "name": "AsiaSat 6",
    "date_utc": "2014-09-07T05:00:00.000Z",
    "date_unix": 1410066000,
    "date_local": "2014-09-07T01:00:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a0f35918b1bc3b2633",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ce6ffd86e000604b33a"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/b4/28/cQwcs8qz_o.png",
        "large": "https://images2.imgbox.com/0d/e8/tfdeNslS_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "http://www.reddit.com/r/spacex/comments/2grxer",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm8.staticflickr.com/7608/16661753958_9f61f777e7_o.jpg",
          "https://farm9.staticflickr.com/8593/16763199166_38ba2cafc8_o.jpg",
          "https://farm9.staticflickr.com/8655/16789074175_ba03989359_o.png",
          "https://farm9.staticflickr.com/8659/16166761954_ebc2a72b2a_o.jpg",
          "https://farm9.staticflickr.com/8620/16642025217_a6852b9499_o.jpg"
        ]
      },
      "presskit": "https://www.nasa.gov/sites/default/files/files/SpaceX_NASA_CRS-4_PressKit.pdf",
      "webcast": "https://www.youtube.com/watch?v=7YkCh7uOw1Y",
      "youtube_id": "7YkCh7uOw1Y",
      "article": "https://www.nasa.gov/press/2014/september/nasa-cargo-launches-to-space-station-aboard-spacex-resupply-mission-0",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-4"
    },
    "static_fire_date_utc": "2014-09-17T00:00:00.000Z",
    "static_fire_date_unix": 1410912000,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [
      "5ea6ed2d080df4000697c902"
    ],
    "capsules": [
      "5e9e2c5bf3591880643b2669"
    ],
    "payloads": [
      "5eb0e4bcb6c3bb0006eeb1f5"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 18,
    "name": "CRS-4",
    "date_utc": "2014-09-21T05:52:00.000Z",
    "date_unix": 1411278720,
    "date_local": "2014-09-21T01:52:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a0f359184a683b2634",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "Ocean",
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ce7ffd86e000604b33b"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/25/b6/RhNppyL3_o.png",
        "large": "https://images2.imgbox.com/fe/5a/WyQS4MXa_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "http://www.reddit.com/r/spacex/comments/2rrdha",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm9.staticflickr.com/8666/16511391418_bb5cdbbd71_o.jpg",
          "https://farm9.staticflickr.com/8612/16848173281_035bdc6009_o.jpg",
          "https://farm9.staticflickr.com/8571/16699496805_bf39747618_o.jpg",
          "https://farm9.staticflickr.com/8650/16699496705_187e4e53fd_o.jpg",
          "https://farm9.staticflickr.com/8663/16077174554_370937efbe_o.jpg",
          "https://farm9.staticflickr.com/8638/16512101410_83763eb9ea_o.jpg",
          "https://farm9.staticflickr.com/8653/16077173984_17885d4bea_o.jpg",
          "https://farm8.staticflickr.com/7635/16848159582_40c0f9d25f_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/spacex_nasa_crs-5_presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=p7x-SumbynI",
      "youtube_id": "p7x-SumbynI",
      "article": "https://spaceflightnow.com/2015/01/10/dragon-successfully-launched-rocket-recovery-demo-crash-lands/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-5"
    },
    "static_fire_date_utc": "2014-12-19T00:00:00.000Z",
    "static_fire_date_unix": 1418947200,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Following second stage separation, SpaceX performed a test flight which attempted to return the first stage of the Falcon 9 through the atmosphere and land it on an approximately 90-by-50-meter (300 ft x 160 ft) floating platform-called the autonomous spaceport drone ship. Many of the test objectives were achieved, including precision control of the rocket's descent to land on the platform at a specific point in the Atlantic ocean, and a large amount of test data was obtained from the first use of grid fin control surfaces used for more precise reentry positioning. The grid fin control system ran out of hydraulic fluid a minute before landing and the landing itself resulted in a crash.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed2f080df4000697c90f",
      "5ea6ed30080df4000697c912"
    ],
    "capsules": [
      "5e9e2c5bf35918165f3b266a"
    ],
    "payloads": [
      "5eb0e4bdb6c3bb0006eeb1f6"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 19,
    "name": "CRS-5",
    "date_utc": "2015-01-10T09:47:00.000Z",
    "date_unix": 1420883220,
    "date_local": "2015-01-10T05:47:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a0f359187a3c3b2635",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb761634e7cb"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ce8ffd86e000604b33c"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/63/c5/0OIpD59z_o.png",
        "large": "https://images2.imgbox.com/ec/a0/kTPQRyzt_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "http://www.reddit.com/r/spacex/comments/2vjm9e",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm9.staticflickr.com/8619/16511407538_9a25c5d8c6_o.jpg",
          "https://farm9.staticflickr.com/8665/16697946612_1284e952b0_o.jpg",
          "https://farm9.staticflickr.com/8570/16698990475_16524a93de_o.jpg",
          "https://farm9.staticflickr.com/8681/16512864259_e849e496b1_o.jpg",
          "https://farm9.staticflickr.com/8637/16079045013_1f0fab9b54_o.jpg",
          "https://farm9.staticflickr.com/8601/16512864369_2bb896c344_o.jpg",
          "https://farm9.staticflickr.com/8646/16697693861_a038331e0a_o.jpg",
          "https://farm9.staticflickr.com/8680/16511407248_093635a243_o.jpg",
          "https://farm9.staticflickr.com/8654/16511594820_451f194d53_o.jpg",
          "https://farm9.staticflickr.com/8603/16673054016_472fb42a20_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/press/2015/02/11/dscovr-launch-update",
      "webcast": "https://www.youtube.com/watch?v=OvHJSIKP0Hg",
      "youtube_id": "OvHJSIKP0Hg",
      "article": "https://spaceflightnow.com/2015/02/12/space-weather-observatory-blasts-off-after-17-year-wait/",
      "wikipedia": "https://en.wikipedia.org/wiki/Deep_Space_Climate_Observatory"
    },
    "static_fire_date_utc": "2015-01-31T00:00:00.000Z",
    "static_fire_date_unix": 1422662400,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "First launch under USAF's OSP 3 launch contract. First SpaceX launch to put a satellite to an orbit with an orbital altitude many times the distance to the Moon: Sun-Earth libration point L1. The first stage made a test flight descent to an over-ocean landing within 10 m (33 ft) of its intended target.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4bdb6c3bb0006eeb1f7"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 20,
    "name": "DSCOVR",
    "date_utc": "2015-02-11T23:03:00.000Z",
    "date_unix": 1423695780,
    "date_local": "2015-02-11T19:03:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a0f3591885be3b2636",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "Ocean",
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ceaffd86e000604b33d"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/20/10/sqPgZfej_o.png",
        "large": "https://images2.imgbox.com/78/82/H9gthFmK_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "http://www.reddit.com/r/spacex/comments/2x81fc",
        "media": "https://www.reddit.com/r/spacex/comments/2xmumx",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm9.staticflickr.com/8749/16788442562_ed460c2d9e_o.jpg",
          "https://farm9.staticflickr.com/8586/16510243060_48d6a9b1f6_o.jpg",
          "https://farm9.staticflickr.com/8641/16490359747_c043b8c61a_o.jpg",
          "https://farm9.staticflickr.com/8636/16510241270_ca83157509_o.jpg",
          "https://farm8.staticflickr.com/7618/16601658850_13b826e705_o.jpg",
          "https://farm9.staticflickr.com/8617/16510041628_883af57512_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/abs-eutelsatfactsheet.pdf",
      "webcast": "https://www.youtube.com/watch?v=mN7lyaCBzT8",
      "youtube_id": "mN7lyaCBzT8",
      "article": "https://www.space.com/28702-spacex-rocket-launches-satellites-video.html",
      "wikipedia": "https://en.wikipedia.org/wiki/ABS-3A"
    },
    "static_fire_date_utc": "2015-02-25T19:10:00.000Z",
    "static_fire_date_unix": 1424891400,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "The launch was Boeing's first-ever conjoined launch of a lighter-weight dual-commsat stack that was specifically designed to take advantage of the lower-cost SpaceX Falcon 9 launch vehicle. Per satellite, launch costs were less than $30 million. The ABS satellite reached its final destination ahead of schedule and started operations on September 10.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4bdb6c3bb0006eeb1f8",
      "5eb0e4bdb6c3bb0006eeb1f9"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 21,
    "name": "ABS-3A / Eutelsat 115W B",
    "date_utc": "2015-03-02T03:50:00.000Z",
    "date_unix": 1425268200,
    "date_local": "2015-03-02T23:50:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a0f35918c0893b2637",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ceaffd86e000604b33e"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/3d/55/kbVulokl_o.png",
        "large": "https://images2.imgbox.com/e4/9f/GRP89UBo_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "https://www.reddit.com/r/spacex/comments/32jnyd",
        "media": "https://www.reddit.com/r/spacex/comments/32lw5y",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm8.staticflickr.com/7624/17170624642_e5949d160e_o.jpg",
          "https://farm8.staticflickr.com/7708/17170624402_f6de506461_o.jpg",
          "https://farm8.staticflickr.com/7658/17170624462_2efc977fee_o.jpg",
          "https://farm8.staticflickr.com/7611/17171659711_42597fefed_o.jpg",
          "https://farm9.staticflickr.com/8774/17170624412_7091dbd04a_o.jpg"
        ]
      },
      "presskit": "https://www.nasa.gov/sites/default/files/files/SpaceX_NASA_CRS-6_PressKit.pdf",
      "webcast": "https://www.youtube.com/watch?v=csVpa25iqH0",
      "youtube_id": "csVpa25iqH0",
      "article": "https://spaceflightnow.com/2015/04/14/falcon-9-successfully-launches-descends-to-off-balance-landing/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-6"
    },
    "static_fire_date_utc": "2015-04-11T00:00:00.000Z",
    "static_fire_date_unix": 1428710400,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Following the first-stage boost, SpaceX attempted a controlled-descent test of the first stage. The first stage contacted the ship, but soon tipped over due to excess lateral velocity caused by a stuck throttle valve resulting in a later-than-intended downthrottle.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed2f080df4000697c90f",
      "5ea6ed30080df4000697c912"
    ],
    "capsules": [
      "5e9e2c5cf359188bfb3b266b"
    ],
    "payloads": [
      "5eb0e4bdb6c3bb0006eeb1fa"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 22,
    "name": "CRS-6",
    "date_utc": "2015-04-14T20:10:00.000Z",
    "date_unix": 1429042200,
    "date_local": "2015-04-14T16:10:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a1f359186d533b2638",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb761634e7cb"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cecffd86e000604b33f"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/c9/35/VNpbqUPb_o.png",
        "large": "https://images2.imgbox.com/7a/99/RLkM4sNw_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "https://www.reddit.com/r/spacex/comments/33xqcj",
        "media": "https://www.reddit.com/r/spacex/comments/3439s3",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm8.staticflickr.com/7695/17138865668_18dcce7072_o.jpg",
          "https://farm8.staticflickr.com/7677/16706406093_61a8f9c2f8_o.jpg",
          "https://farm8.staticflickr.com/7691/17324793792_2dd13ea3f3_o.jpg",
          "https://farm8.staticflickr.com/7691/17139094400_b94ce1ff56_o.jpg",
          "https://farm9.staticflickr.com/8739/17140415959_38b5ee8bc6_o.jpg",
          "https://farm8.staticflickr.com/7735/16704192574_e3a0a6fac2_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/spacexthalesfactsheet_final.pdf",
      "webcast": "https://www.youtube.com/watch?v=nBwAYT_ogj4",
      "youtube_id": "nBwAYT_ogj4",
      "article": "https://spaceflightnow.com/2015/04/28/falcon-9-rocket-powers-into-space-with-satellite-for-turkmenistan/",
      "wikipedia": "https://en.wikipedia.org/wiki/T%C3%BCrkmen%C3%84lem_52%C2%B0E_/_MonacoSAT"
    },
    "static_fire_date_utc": "2015-04-22T11:11:00.000Z",
    "static_fire_date_unix": 1429701060,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4beb6c3bb0006eeb1fb"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 23,
    "name": "TürkmenÄlem 52°E / MonacoSAT",
    "date_utc": "2015-04-27T23:03:00.000Z",
    "date_unix": 1430175780,
    "date_local": "2015-04-27T19:03:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a1f35918233f3b2639",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cedffd86e000604b340"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/d0/22/gyTVYo21_o.png",
        "large": "https://images2.imgbox.com/47/39/stH98Qy1_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "https://www.reddit.com/r/spacex/comments/3b27hk",
        "media": "https://www.reddit.com/r/spacex/comments/3berj3",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm1.staticflickr.com/344/19045370790_f20f29cd8d_o.jpg",
          "https://farm1.staticflickr.com/287/18999110808_6e153fed64_o.jpg"
        ]
      },
      "presskit": "https://www.nasa.gov/sites/default/files/atoms/files/spacex_nasa_crs-7_presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=PuNymhcTtSQ",
      "youtube_id": "PuNymhcTtSQ",
      "article": "https://spaceflightnow.com/2015/06/28/falcon-9-rocket-destroyed-in-launch-mishap/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-7"
    },
    "static_fire_date_utc": "2015-06-26T05:00:00.000Z",
    "static_fire_date_unix": 1435294800,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": false,
    "failures": [
      {
        "time": 139,
        "altitude": 40,
        "reason": "helium tank overpressure lead to the second stage LOX tank explosion"
      }
    ],
    "details": "Launch performance was nominal until an overpressure incident in the second-stage LOX tank, leading to vehicle breakup at T+150 seconds. The Dragon capsule survived the explosion but was lost upon splashdown because its software did not contain provisions for parachute deployment on launch vehicle failure.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c"
    ],
    "capsules": [
      "5e9e2c5cf35918407d3b266c"
    ],
    "payloads": [
      "5eb0e4beb6c3bb0006eeb1fc"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 24,
    "name": "CRS-7",
    "date_utc": "2015-06-28T14:21:00.000Z",
    "date_unix": 1435501260,
    "date_local": "2015-06-28T10:21:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a1f35918683c3b263a",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": null,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87ceeffd86e000604b341"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/89/e8/5eeThzqZ_o.png",
        "large": "https://images2.imgbox.com/65/a5/8iNE9T6Y_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "https://www.reddit.com/r/spacex/comments/3xgxh5",
        "media": "https://www.reddit.com/r/spacex/comments/3xm83h/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm2.staticflickr.com/1648/23827554109_837b21739e_o.jpg",
          "https://farm1.staticflickr.com/597/23802553412_d41e4dcc64_o.jpg",
          "https://farm6.staticflickr.com/5806/23802550622_9ff8c90098_o.jpg",
          "https://farm1.staticflickr.com/571/23604164970_2a1a2366e4_o.jpg",
          "https://farm6.staticflickr.com/5773/23271687254_5e64d726ba_o.jpg",
          "https://farm6.staticflickr.com/5766/23526044959_5bfe74bc88_o.jpg",
          "https://farm6.staticflickr.com/5723/23785609832_83038751d1_o.jpg",
          "https://farm1.staticflickr.com/715/23833499336_d3fde6a25a_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/spacex_orbcomm_press_kit_final2.pdf",
      "webcast": "https://www.youtube.com/watch?v=O5bTbVbe4e4",
      "youtube_id": "O5bTbVbe4e4",
      "article": "https://spaceflightnow.com/2015/12/22/round-trip-rocket-flight-gives-spacex-a-trifecta-of-successes/",
      "wikipedia": "https://en.wikipedia.org/wiki/Falcon_9_flight_20"
    },
    "static_fire_date_utc": "2015-12-19T00:09:00.000Z",
    "static_fire_date_unix": 1450483740,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Total payload mass was 2,034 kg (4,484 lb) : 11 satellites weighing 172 kg each, plus a 142-kg mass simulator. This was the first launch of the upgraded v1.1 variant (later called Falcon 9 Full Thrust), with a 30 percent power increase. Orbcomm had originally agreed to be the third flight of the enhanced-thrust rocket, but the change to the maiden flight position was announced in October 2015. SpaceX received a permit from the FAA to land the booster on solid ground at Cape Canaveral, and succeeded.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4beb6c3bb0006eeb1fd"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 25,
    "name": "OG-2 Mission 2",
    "date_utc": "2015-12-22T01:29:00.000Z",
    "date_unix": 1450747740,
    "date_local": "2015-12-22T21:29:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a1f3591867753b263b",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cefffd86e000604b342"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/72/f2/uK9vYzvk_o.png",
        "large": "https://images2.imgbox.com/71/59/j489OwAI_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "https://www.reddit.com/r/spacex/comments/417weg",
        "media": "https://www.reddit.com/r/spacex/comments/41cvdm",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm2.staticflickr.com/1460/24382360351_9b1f2fcabc_o.jpg",
          "https://farm2.staticflickr.com/1669/24423604506_27d3c4548b_o.jpg",
          "https://farm2.staticflickr.com/1618/24151425850_1cb6040569_o.jpg",
          "https://farm2.staticflickr.com/1622/24127012370_07edc62046_o.jpg",
          "https://farm2.staticflickr.com/1508/24127011190_92ef932c96_o.jpg",
          "https://farm2.staticflickr.com/1591/23778325594_08231286fc_o.jpg",
          "https://farm2.staticflickr.com/1542/24038722499_34c10216a3_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/spacex_jason3_press_kit.pdf",
      "webcast": "https://www.youtube.com/watch?v=ivdKRJzl6y0",
      "youtube_id": "ivdKRJzl6y0",
      "article": "https://spaceflightnow.com/2016/01/18/satellite-launched-to-measure-motions-of-the-oceans/",
      "wikipedia": "https://en.wikipedia.org/wiki/Jason-3"
    },
    "static_fire_date_utc": "2016-01-11T18:42:00.000Z",
    "static_fire_date_unix": 1452537720,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "First launch of NASA and NOAA joint science mission under the NLS II launch contract (not related to NASA CRS or USAF OSP3 contracts). Last launch of the original Falcon 9 v1.1 launch vehicle. The Jason-3 satellite was successfully deployed to target orbit. SpaceX again attempted a recovery of the first stage booster by landing on an autonomous drone ship; this time located in the Pacific Ocean. The first stage did achieve a soft-landing on the ship, but a lockout on one of the landing legs failed to latch, so that the booster fell over and exploded.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ea6ed30080df4000697c912",
      "5ea6ed30080df4000697c914"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4beb6c3bb0006eeb1fe"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 26,
    "name": "Jason 3",
    "date_utc": "2016-01-17T15:42:00.000Z",
    "date_unix": 1453045320,
    "date_local": "2016-01-17T08:42:00-07:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a1f3591842fa3b263c",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cf0ffd86e000604b343"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/fa/ef/4FBvVReu_o.png",
        "large": "https://images2.imgbox.com/f6/aa/xDtGo0WJ_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "https://www.reddit.com/r/spacex/comments/48u4yq",
        "media": "https://www.reddit.com/r/spacex/comments/472k8c",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm2.staticflickr.com/1623/25395662282_942fd68ba3_o.jpg",
          "https://farm2.staticflickr.com/1458/25395661442_bfd783f18a_o.jpg",
          "https://farm2.staticflickr.com/1641/25421381351_38390bcb8e_o.jpg",
          "https://farm2.staticflickr.com/1616/25514167315_b19b0a4365_o.jpg",
          "https://farm2.staticflickr.com/1482/24883160354_b03cefd416_o.jpg",
          "https://farm2.staticflickr.com/1653/25420915781_8fc648b4a4_o.jpg",
          "https://farm2.staticflickr.com/1610/25486858116_9c06dfea59_o.jpg",
          "https://farm2.staticflickr.com/1617/25168697841_00dfff89bb_o.jpg",
          "https://farm2.staticflickr.com/1533/24631230904_83b1624807_o.jpg",
          "https://farm2.staticflickr.com/1627/25145624551_1b8743116f_o.jpg",
          "https://farm2.staticflickr.com/1622/25120540712_7fc1a5ed72_o.jpg",
          "https://farm2.staticflickr.com/1550/24585667074_aa712b13a8_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/spacex_ses9_press_kit_final.pdf",
      "webcast": "https://www.youtube.com/watch?v=muDPSyO7-A0",
      "youtube_id": "muDPSyO7-A0",
      "article": "https://spaceflightnow.com/2016/03/05/tv-broadcasting-satellite-finally-launched-on-falcon-9/",
      "wikipedia": "https://en.wikipedia.org/wiki/SES-9"
    },
    "static_fire_date_utc": "2016-10-02T14:11:00.000Z",
    "static_fire_date_unix": 1475417460,
    "net": false,
    "window": 5400,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Second launch of the enhanced Falcon 9 Full Thrust launch vehicle. Following the launch, SpaceX attempted an experimental landing test to a drone ship, although a successful landing was not expected because launch mass exceeded previously indicated limit for a GTO there was little fuel left. As predicted, booster recovery failed: the spent first stage \"landed hard\", but the controlled-descent, atmospheric re-entry and navigation to the drone ship were successful and returned significant test data on bringing back high-energy Falcon 9s.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4beb6c3bb0006eeb1ff"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 27,
    "name": "SES-9",
    "date_utc": "2016-03-04T23:35:00.000Z",
    "date_unix": 1457134500,
    "date_local": "2016-03-04T19:35:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a1f359188def3b263d",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cf2ffd86e000604b344"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/49/2a/gkSR50yc_o.png",
        "large": "https://images2.imgbox.com/1b/f0/tyNDMK5j_o.png"
      },
      "reddit": {
        "campaign": null,
        "launch": "https://www.reddit.com/r/spacex/comments/4dtoly",
        "media": "https://www.reddit.com/r/spacex/comments/4dtpxn/",
        "recovery": "https://www.reddit.com/r/spacex/comments/4ee2zy"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm2.staticflickr.com/1633/25788014884_6a3f9ae183_o.jpg",
          "https://farm2.staticflickr.com/1650/26300505022_8b8b9035e8_o.jpg",
          "https://farm2.staticflickr.com/1486/25787998624_3ca213be1e_o.jpg",
          "https://farm2.staticflickr.com/1450/26326628031_e1b08ec0b3_o.jpg",
          "https://farm2.staticflickr.com/1670/26239020092_05e5e4c538_o.jpg",
          "https://farm2.staticflickr.com/1709/26305479266_76b4d01caf_o.jpg",
          "https://farm2.staticflickr.com/1645/26239017922_28c7ac50e0_o.jpg",
          "https://farm2.staticflickr.com/1559/26288402056_6c5997ce66_o.jpg",
          "https://farm2.staticflickr.com/1449/25709481274_60f8c77358_o.jpg",
          "https://farm2.staticflickr.com/1671/26217360302_b66c3e384e_o.jpg",
          "https://farm2.staticflickr.com/1704/26283822056_838c1103b9_o.jpg",
          "https://farm2.staticflickr.com/1508/26217345472_118767c608_o.jpg",
          "https://farm2.staticflickr.com/1495/25916886442_821a152917_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/spacex_crs8_press_kit.pdf",
      "webcast": "https://www.youtube.com/watch?v=7pUAydjne5M",
      "youtube_id": "7pUAydjne5M",
      "article": "https://spaceflightnow.com/2016/04/08/spacex-lands-rocket-on-floating-platform-after-station-resupply-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-8"
    },
    "static_fire_date_utc": "2016-04-05T00:00:00.000Z",
    "static_fire_date_unix": 1459814400,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Dragon carried over 1500 kg of supplies and delivered (stowed in its trunk) the inflatable Bigelow Expandable Activity Module (BEAM) to the ISS for two years of in-orbit tests. The rocket's first stage landed smoothly on SpaceX's autonomous spaceport drone ship 9 minutes after liftoff, making this the first ever successful landing of a rocket booster on a ship at sea as part of an orbital launch. The first stage B1021 was later also the first orbital booster to be used again, when launching SES-10 on March 30, 2017.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed30080df4000697c912",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [
      "5e9e2c5cf3591885d43b266d"
    ],
    "payloads": [
      "5eb0e4bfb6c3bb0006eeb200"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 28,
    "name": "CRS-8",
    "date_utc": "2016-04-08T20:43:00.000Z",
    "date_unix": 1460148180,
    "date_local": "2016-04-08T16:43:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a2f359182d0b3b263e",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cf3ffd86e000604b345"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/87/c9/qViUTdt5_o.png",
        "large": "https://images2.imgbox.com/84/40/ddJiuhNV_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/4gyh8z",
        "launch": "https://www.reddit.com/r/spacex/comments/4htenu",
        "media": "https://www.reddit.com/r/spacex/comments/4htg2g",
        "recovery": "https://www.reddit.com/r/spacex/comments/4ihp1p"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm8.staticflickr.com/7340/27044931232_7b755276ec_o.jpg",
          "https://farm8.staticflickr.com/7444/27028105566_1d3413daa7_o.jpg",
          "https://farm8.staticflickr.com/7597/26778141961_e3bd237942_o.jpg",
          "https://farm8.staticflickr.com/7079/26778141661_559b48ac80_o.jpg",
          "https://farm8.staticflickr.com/7682/26778141401_c437b04b74_o.jpg",
          "https://farm8.staticflickr.com/7706/26751237322_ceb6d56235_o.jpg",
          "https://farm8.staticflickr.com/7677/26809210466_fc55835f3c_o.jpg",
          "https://farm8.staticflickr.com/7085/26809208046_d77bd31fd0_o.jpg",
          "https://farm8.staticflickr.com/7103/26809207316_cdc7d582e6_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/spacex_jcsat_press_kit_final.pdf",
      "webcast": "https://www.youtube.com/watch?v=L0bMeDj76ig",
      "youtube_id": "L0bMeDj76ig",
      "article": "https://spaceflightnow.com/2016/05/06/falcon-9-succeeds-in-middle-of-the-night-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/JCSAT-2B"
    },
    "static_fire_date_utc": "2016-05-01T21:32:00.000Z",
    "static_fire_date_unix": 1462138320,
    "net": false,
    "window": 7200,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Launched the JCSAT 14 communications satellite for Tokyo-based SKY Perfect JSAT Corp. JCSAT 14 will support data networks, television broadcasters and mobile communications users in Japan, East Asia, Russia, Oceania, Hawaii and other Pacific islands. This was the first time a booster successfully landed after a GTO mission.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4bfb6c3bb0006eeb201"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 29,
    "name": "JCSAT-2B",
    "date_utc": "2016-05-06T05:21:00.000Z",
    "date_unix": 1462512060,
    "date_local": "2016-05-06T01:21:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a2f35918077b3b263f",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cf5ffd86e000604b346"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/d1/de/waYRCanq_o.png",
        "large": "https://images2.imgbox.com/b7/ec/5kukvU10_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/4hjz4k",
        "launch": "https://www.reddit.com/r/spacex/comments/4l9uou",
        "media": "https://www.reddit.com/r/spacex/comments/4l4af1",
        "recovery": "https://www.reddit.com/r/spacex/comments/4lz2y6"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm8.staticflickr.com/7420/26814484893_13059e4b39_o.jpg",
          "https://farm8.staticflickr.com/7321/26812794884_bf91665325_o.jpg",
          "https://farm8.staticflickr.com/7337/26812792104_9323121f0b_o.jpg",
          "https://farm8.staticflickr.com/7376/27421461715_5640d2b87a_o.jpg",
          "https://farm8.staticflickr.com/7717/26812758364_74569b4327_o.jpg",
          "https://farm8.staticflickr.com/7742/27294263035_9b43bd141c_o.jpg",
          "https://farm8.staticflickr.com/7252/27294262435_c534cc4351_o.jpg",
          "https://farm8.staticflickr.com/7698/27294261525_82c4b7e604_o.jpg",
          "https://farm8.staticflickr.com/7045/27259828166_9e32061cc9_o.jpg",
          "https://farm8.staticflickr.com/7013/27259827316_c2f7507b3d_o.jpg",
          "https://farm8.staticflickr.com/7211/27182485331_ed2414a947_o.jpg",
          "https://farm8.staticflickr.com/7740/27182481921_0d7a759736_o.jpg",
          "https://farm8.staticflickr.com/7315/26645036414_39736db559_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/spacex_thaicom_8_press_kit.pdf",
      "webcast": "https://www.youtube.com/watch?v=zBYC4f79iXc",
      "youtube_id": "zBYC4f79iXc",
      "article": "https://spaceflightnow.com/2016/05/27/spacex-logs-successful-late-afternoon-launch-for-thaicom/",
      "wikipedia": "https://en.wikipedia.org/wiki/Thaicom_8"
    },
    "static_fire_date_utc": "2016-05-25T00:00:00.000Z",
    "static_fire_date_unix": 1464134400,
    "net": false,
    "window": 7200,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Manufactured by Orbital ATK, the 3,100-kilogram (6,800 lb) Thaicom 8 communications satellite will serve Thailand, India and Africa from the 78.5° East geostationary location. It is equipped with 24 active Ku-band transponders.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4bfb6c3bb0006eeb202"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 30,
    "name": "Thaicom 8",
    "date_utc": "2016-05-27T21:39:00.000Z",
    "date_unix": 1464385140,
    "date_local": "2016-05-27T17:39:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a2f3591845c73b2640",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cf6ffd86e000604b347"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/ae/e9/VTH2y7S5_o.png",
        "large": "https://images2.imgbox.com/07/79/4ajR03l9_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/4ksdy3",
        "launch": "https://www.reddit.com/r/spacex/comments/4o5u6r",
        "media": "https://www.reddit.com/r/spacex/comments/4o5j6o",
        "recovery": "https://www.reddit.com/r/spacex/comments/4on75l"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm8.staticflickr.com/7088/27661326426_ce3c3f320d_o.jpg",
          "https://farm8.staticflickr.com/7698/27661325446_affb08be24_o.jpg",
          "https://farm8.staticflickr.com/7733/27661322976_073466e80c_o.jpg",
          "https://farm8.staticflickr.com/7218/27661320706_4c16f3b76b_o.jpg",
          "https://farm8.staticflickr.com/7340/27661315686_6dcb2ce6f9_o.jpg",
          "https://farm8.staticflickr.com/7656/27661313956_e1ac9650b9_o.jpg",
          "https://farm8.staticflickr.com/7616/27661312516_640764f8fd_o.jpg",
          "https://farm8.staticflickr.com/7413/27078893234_0142dd80f0_o.jpg",
          "https://farm8.staticflickr.com/7334/27078889924_8819fd55ea_o.jpg"
        ]
      },
      "presskit": "https://drive.google.com/open?id=0BwA3a65ef1OvMGpJSlpDNHhjelU",
      "webcast": "https://www.youtube.com/watch?v=gLNmtUEvI5A",
      "youtube_id": "gLNmtUEvI5A",
      "article": "https://spaceflightnow.com/2016/06/15/spacex-successfully-fires-satellites-into-orbit-but-loses-booster-on-landing/",
      "wikipedia": "https://en.wikipedia.org/wiki/ABS_(satellite_operator)"
    },
    "static_fire_date_utc": "2016-06-13T15:03:00.000Z",
    "static_fire_date_unix": 1465830180,
    "net": false,
    "window": 2700,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "One year after pioneering this technique on flight 16, Falcon again launched two Boeing 702SP gridded ion thruster satellites in a dual-stack configuration, with the two customers sharing the rocket and mission costs. First stage landing attempt on drone ship failed on landing due to low thrust on one of the three landing engines.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4bfb6c3bb0006eeb203",
      "5eb0e4bfb6c3bb0006eeb204"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 31,
    "name": "ABS-2A / Eutelsat 117W B",
    "date_utc": "2016-06-15T14:29:00.000Z",
    "date_unix": 1466000940,
    "date_local": "2016-06-15T10:29:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a2f359184f403b2641",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cf8ffd86e000604b348"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/b6/52/p5vdNEJF_o.png",
        "large": "https://images2.imgbox.com/7c/07/rs4MS4HU_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/4ksedl",
        "launch": "https://www.reddit.com/r/spacex/comments/4t2umd/",
        "media": "https://www.reddit.com/r/spacex/comments/4tayth",
        "recovery": "https://www.reddit.com/r/spacex/comments/4znsvo"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm9.staticflickr.com/8819/27776240293_fcbf8c4a0a_o.jpg",
          "https://farm8.staticflickr.com/7720/27776237513_038971797c_o.jpg",
          "https://farm8.staticflickr.com/7594/27776235133_d794ce01f4_o.jpg",
          "https://farm8.staticflickr.com/7759/27776229243_a0674e590f_o.jpg",
          "https://farm8.staticflickr.com/7512/27776228443_6652c6baea_o.jpg",
          "https://farm9.staticflickr.com/8038/27776218453_34112abbc1_o.jpg",
          "https://farm8.staticflickr.com/7636/27776215913_3f9f1b05df_o.jpg",
          "https://farm8.staticflickr.com/7740/28358960896_9785456101_o.jpg",
          "https://farm8.staticflickr.com/7488/27776206663_262526ba5f_o.jpg",
          "https://farm8.staticflickr.com/7656/28358955546_ce55d65e16_o.jpg",
          "https://farm8.staticflickr.com/7467/27776204693_68b4ed82c9_o.jpg",
          "https://farm8.staticflickr.com/7693/28348649546_0a54b1aa44_o.jpg",
          "https://farm8.staticflickr.com/7540/28291786662_5e2e874576_o.jpg"
        ]
      },
      "presskit": "https://drive.google.com/open?id=0BwA3a65ef1OvM0JpSXdDUUJMRVk",
      "webcast": "https://www.youtube.com/watch?v=ThIdCuSsJh8",
      "youtube_id": "ThIdCuSsJh8",
      "article": "https://spaceflightnow.com/2016/07/18/spacex-sends-supplies-to-space-station-lands-another-falcon-rocket/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-9"
    },
    "static_fire_date_utc": "2016-07-16T02:31:47.000Z",
    "static_fire_date_unix": 1468636307,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Among other cargo, an International Docking Adapter (IDA-2) was carried to the ISS. This mission had a successful first-stage landing at Cape Canaveral.*Including the reusable Dragon Capsule, total payload to orbit was 6457 kg.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed30080df4000697c912"
    ],
    "capsules": [
      "5e9e2c5cf359183bb73b266e"
    ],
    "payloads": [
      "5eb0e4c0b6c3bb0006eeb205"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 32,
    "name": "CRS-9",
    "date_utc": "2016-07-18T04:45:00.000Z",
    "date_unix": 1468817100,
    "date_local": "2016-07-18T00:45:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a2f359187f273b2642",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cf9ffd86e000604b349"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/a4/21/eLkeQOl8_o.png",
        "large": "https://images2.imgbox.com/74/fc/KiaMQgym_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/4pv6ws",
        "launch": "https://www.reddit.com/r/spacex/comments/4xi7uq",
        "media": "https://www.reddit.com/r/spacex/comments/4xkdfj",
        "recovery": "https://www.reddit.com/r/spacex/comments/4y5xd1"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm9.staticflickr.com/8699/28965678292_17533229f3_o.jpg",
          "https://farm9.staticflickr.com/8173/28453337463_b9d11eeb4c_o.jpg",
          "https://farm8.staticflickr.com/7793/28453335533_3f5a0a5760_o.jpg",
          "https://farm9.staticflickr.com/8784/28938085496_74b3fd0527_o.jpg",
          "https://farm9.staticflickr.com/8337/28969742675_15f78369a1_o.jpg",
          "https://farm9.staticflickr.com/8691/28353012603_ab83b6f5aa_o.jpg",
          "https://farm9.staticflickr.com/8078/28351782813_58ca783e51_o.jpg"
        ]
      },
      "presskit": "https://drive.google.com/open?id=0BwA3a65ef1Ovb0FkYnE5dElZRlU",
      "webcast": "https://www.youtube.com/watch?v=QZTCEO0gvLo",
      "youtube_id": "QZTCEO0gvLo",
      "article": "https://spaceflightnow.com/2016/08/14/falcon-9-rocket-launches-japanese-satellite-then-nails-bullseye-landing/",
      "wikipedia": "https://en.wikipedia.org/wiki/JCSAT-16"
    },
    "static_fire_date_utc": "2016-08-11T04:01:00.000Z",
    "static_fire_date_unix": 1470888060,
    "net": false,
    "window": 7200,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "First attempt to touch down from a ballistic trajectory using a single-engine landing burn. All previous landings from a ballistic trajectory had fired three engines on the landing-burn, which provided more braking force, but subjected the vehicle to greater structural stresses. The single-engine landing burn takes more time and fuel, but puts less stress on the vehicle.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c1b6c3bb0006eeb206"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 33,
    "name": "JCSAT-16",
    "date_utc": "2016-08-14T05:26:00.000Z",
    "date_unix": 1471152360,
    "date_local": "2016-08-14T01:26:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a2f35918b8243b2643",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cfaffd86e000604b34a"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/OADkTym.png",
        "large": "https://imgur.com/2F5PYz5.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/4pv7jl",
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://www.youtube.com/watch?v=_BgJEXQkjNQ",
      "youtube_id": "_BgJEXQkjNQ",
      "article": "https://spaceflightnow.com/2016/09/01/spacex-rocket-and-israeli-satellite-destroyed-in-launch-pad-explosion/",
      "wikipedia": "https://en.wikipedia.org/wiki/Amos-6"
    },
    "static_fire_date_utc": "2016-09-01T13:07:00.000Z",
    "static_fire_date_unix": 1472735220,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": false,
    "failures": [
      {
        "time": -165180,
        "altitude": 0,
        "reason": "buckled liner in several of the COPV tanks, causing perforations that allowed liquid and/or solid oxygen to accumulate underneath the lining, which was ignited by friction."
      }
    ],
    "details": "The rocket and Amos-6 payload were lost in a launch pad explosion on September 1, 2016 during propellant fill prior to a static fire test. The pad was clear of personnel and there were no injuries.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4c1b6c3bb0006eeb207"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 34,
    "name": "Amos-6",
    "date_utc": "2016-09-01T13:07:00.000Z",
    "date_unix": 1472735220,
    "date_local": "2016-09-01T09:07:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a2f359187ee83b2644",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": null,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cfbffd86e000604b34b"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/a6/e8/5PyY296y_o.png",
        "large": "https://images2.imgbox.com/ab/b8/USCniUHy_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/5dii6z",
        "launch": "https://www.reddit.com/r/spacex/comments/5nsaqm",
        "media": "https://www.reddit.com/r/spacex/comments/5nsico",
        "recovery": "https://www.reddit.com/r/spacex/comments/5oe9kk"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm1.staticflickr.com/658/32394688795_55a9873ea7_o.jpg",
          "https://farm1.staticflickr.com/506/32394688095_a3339f3c6d_o.jpg",
          "https://farm1.staticflickr.com/745/32394687645_63ae2b4740_o.jpg",
          "https://farm1.staticflickr.com/318/31548291014_e3a30abca8_o.jpg",
          "https://farm1.staticflickr.com/670/32351549066_e9cffe8d2b_o.jpg",
          "https://farm6.staticflickr.com/5518/31579784413_83aeac560a_o.jpg",
          "https://farm6.staticflickr.com/5556/32312421135_22c197c156_o.jpg",
          "https://farm1.staticflickr.com/529/32312420015_5d2403a847_o.jpg",
          "https://farm1.staticflickr.com/435/32312417695_19c0e50c4b_o.jpg",
          "https://farm1.staticflickr.com/735/32312416415_b90892af0a_o.jpg",
          "https://farm1.staticflickr.com/293/32312415025_cae16d1994_o.jpg",
          "https://farm1.staticflickr.com/738/31467130724_92e02c9524_o.jpg",
          "https://farm1.staticflickr.com/464/31467130374_9f7a7d380e_o.jpg",
          "https://farm1.staticflickr.com/581/31467129424_bac77d594a_o.jpg",
          "https://farm1.staticflickr.com/380/32308163845_c1731a4b1f_o.jpg",
          "https://farm1.staticflickr.com/447/31450835954_72ed10a19e_o.jpg",
          "https://farm1.staticflickr.com/507/31450834974_b8a3f4aca5_o.jpg"
        ]
      },
      "presskit": "https://drive.google.com/open?id=0BwA3a65ef1OvZC1aU3FuMlQzalE",
      "webcast": "https://www.youtube.com/watch?v=7WimRhydggo",
      "youtube_id": "7WimRhydggo",
      "article": "https://spaceflightnow.com/2017/01/14/spacex-resumes-flights-with-on-target-launch-for-iridium/",
      "wikipedia": "https://en.wikipedia.org/wiki/Iridium_satellite_constellation#Next-generation_constellation"
    },
    "static_fire_date_utc": "2017-01-05T19:40:00.000Z",
    "static_fire_date_unix": 1483645200,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Return-to-flight mission after the loss of Amos-6 in September 2016. Iridium NEXT will replace the original Iridium constellation, launched in the late 1990s. Each Falcon mission will carry 10 satellites, with a goal to complete deployment of the 66 plus 9 spare satellite constellation by mid 2018. The first two Iridium qualification units were supposed to ride a Dnepr rocket in April 2016 but were delayed, so Iridium decided to qualify the first batch of 10 satellites instead.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ea6ed30080df4000697c912",
      "5ea6ed30080df4000697c915"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c2b6c3bb0006eeb208"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 35,
    "name": "Iridium NEXT Mission 1",
    "date_utc": "2017-01-14T17:54:00.000Z",
    "date_unix": 1484416440,
    "date_local": "2017-01-14T10:54:00-07:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a3f359189e3a3b2645",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cfdffd86e000604b34c"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/d3/08/7YmXiSOQ_o.png",
        "large": "https://images2.imgbox.com/02/52/hp8DpyGM_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/5n2eqx",
        "launch": "https://www.reddit.com/r/spacex/comments/5uw4bh",
        "media": "https://www.reddit.com/r/spacex/comments/5uoy8o",
        "recovery": "https://www.reddit.com/r/spacex/comments/609aq4"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm3.staticflickr.com/2815/32761844973_d2e8d76e9c_o.jpg",
          "https://farm4.staticflickr.com/3878/32761843663_8e366494f4_o.jpg",
          "https://farm3.staticflickr.com/2790/32852846842_6f1f7b26b9_o.jpg",
          "https://farm3.staticflickr.com/2295/32852845662_e7ae0daf4a_o.jpg",
          "https://farm4.staticflickr.com/3888/33000639155_2a6e2bb23d_o.jpg",
          "https://farm1.staticflickr.com/405/33000638185_b4ec7c7b93_o.jpg",
          "https://farm1.staticflickr.com/574/32874779241_9f463de901_o.jpg",
          "https://farm4.staticflickr.com/3710/32153433074_96337a54db_o.jpg",
          "https://farm1.staticflickr.com/327/32153432924_09dd1482d8_o.jpg",
          "https://farm3.staticflickr.com/2881/32183025803_36bf976b9e_o.jpg",
          "https://farm3.staticflickr.com/2362/32183025493_2a37b4e22c_o.jpg",
          "https://farm1.staticflickr.com/504/32178458813_ff47f61bb9_o.jpg",
          "https://farm1.staticflickr.com/265/32176806823_879ccc5da0_o.jpg",
          "https://farm1.staticflickr.com/401/32866357531_69c6d289ed_o.jpg",
          "https://farm3.staticflickr.com/2105/32945170805_553d45ca56_o.jpg",
          "https://farm4.staticflickr.com/3865/32945170225_58129f00dc_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/crs10presskitfinal.pdf",
      "webcast": "https://www.youtube.com/watch?v=giNhaEzv_PI",
      "youtube_id": "giNhaEzv_PI",
      "article": "https://spaceflightnow.com/2017/02/19/historic-launch-pad-back-in-service-with-thundering-blastoff-by-spacex/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-10"
    },
    "static_fire_date_utc": "2017-02-12T21:30:00.000Z",
    "static_fire_date_unix": 1486935000,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "First Falcon 9 flight from the historic LC-39A launchpad at Kennedy Space Center, carrying supplies and materials to support dozens of science and research investigations scheduled during ISS Expeditions 50 and 51. The first stage returned to launch site and landed at LZ-1.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c912"
    ],
    "capsules": [
      "5e9e2c5cf359185d753b266f"
    ],
    "payloads": [
      "5eb0e4c3b6c3bb0006eeb209"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 36,
    "name": "CRS-10",
    "date_utc": "2017-02-19T14:39:00.000Z",
    "date_unix": 1487515140,
    "date_local": "2017-02-19T10:39:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a3f3591829dc3b2646",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cfeffd86e000604b34d"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/54/f8/0X2hNhNK_o.png",
        "large": "https://images2.imgbox.com/47/c2/mmiTCLkJ_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/5n2e10/echostar_23_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/5z8dkm/welcome_to_the_rspacex_echostar23_official_launch/",
        "media": "https://www.reddit.com/r/spacex/comments/5z8if6/rspacex_echostar_23_media_thread_videos_images/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm4.staticflickr.com/3819/33094074350_ae56bd5c73_o.jpg",
          "https://farm3.staticflickr.com/2935/33094073720_92234ddaee_o.jpg",
          "https://farm1.staticflickr.com/768/33094072690_31a85e82ba_o.jpg",
          "https://farm3.staticflickr.com/2876/33094072100_546090a4f3_o.jpg",
          "https://farm3.staticflickr.com/2860/32626053254_d702922d87_o.jpg",
          "https://farm3.staticflickr.com/2904/32654666113_ba833971e0_o.jpg",
          "https://farm1.staticflickr.com/677/32654665263_751d29ded1_o.jpg",
          "https://farm3.staticflickr.com/2936/33299697331_09313ac49d_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/echostarxxiiifinal.pdf",
      "webcast": "https://www.youtube.com/watch?v=lZmqbL-hz7U",
      "youtube_id": "lZmqbL-hz7U",
      "article": "http://spacenews.com/spacex-launches-echostar-23/",
      "wikipedia": "https://en.wikipedia.org/wiki/EchoStar#Satellite_fleet"
    },
    "static_fire_date_utc": "2017-03-09T23:00:00.000Z",
    "static_fire_date_unix": 1489100400,
    "net": false,
    "window": 9000,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Communications satellite for EchoStar Corp. EchoStar XXIII, based on a spare platform from the cancelled CMBStar 1 satellite program, will provide direct-to-home television broadcast services over Brazil. There was no attempt at a first-stage recovery so this rocket did not have landing legs or grid fins.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4c3b6c3bb0006eeb20a"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 37,
    "name": "EchoStar 23",
    "date_utc": "2017-03-16T06:00:00.000Z",
    "date_unix": 1489644000,
    "date_local": "2017-03-16T02:00:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a3f3591878473b2647",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87cfeffd86e000604b34e"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/5b/10/dfj7yRG3_o.png",
        "large": "https://images2.imgbox.com/d1/f6/9q2edz2p_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/5sjrzj/ses10_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/62aqi7/rspacex_ses10_official_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/62aqad/rspacex_ses10_media_thread_videos_images_gifs/",
        "recovery": "https://www.reddit.com/r/spacex/comments/634gmr/b1021ses10_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm1.staticflickr.com/601/33026465643_462ef7a2cb_o.jpg",
          "https://farm3.staticflickr.com/2850/32996438264_b79ca3664b_o.jpg",
          "https://farm4.staticflickr.com/3956/32996437434_4dab1ae8e3_o.jpg",
          "https://farm4.staticflickr.com/3831/32996435084_6c5662caca_o.jpg",
          "https://farm4.staticflickr.com/3775/32915200224_b6ecfabd7e_o.jpg",
          "https://farm4.staticflickr.com/3886/32915199874_b826eac153_o.jpg",
          "https://farm3.staticflickr.com/2842/32915199514_6c44178e87_o.jpg",
          "https://farm4.staticflickr.com/3771/32915198904_2df85aed05_o.jpg",
          "https://farm4.staticflickr.com/3668/32915198334_d2fa2f16ab_o.jpg",
          "https://farm4.staticflickr.com/3955/32915197674_24d6e27cf5_o.jpg",
          "https://farm4.staticflickr.com/3830/33616913981_f04b6e2351_o.jpg",
          "https://farm4.staticflickr.com/3819/33616913111_e699b48d66_o.jpg",
          "https://farm4.staticflickr.com/3835/33361035860_c57ed61239_o.jpg",
          "https://farm4.staticflickr.com/3783/33361035200_bfb797d38f_o.jpg",
          "https://farm4.staticflickr.com/3698/33611796351_54d5a6d65a_o.jpg",
          "https://farm3.staticflickr.com/2857/33611795531_82cc2d8789_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/finalses10presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=xsZSXav4wI8",
      "youtube_id": "xsZSXav4wI8",
      "article": "https://spaceflightnow.com/2017/03/31/spacex-flies-rocket-for-second-time-in-historic-test-of-cost-cutting-technology/",
      "wikipedia": "https://en.wikipedia.org/wiki/SES-10"
    },
    "static_fire_date_utc": "2017-03-27T18:00:00.000Z",
    "static_fire_date_unix": 1490637600,
    "net": false,
    "window": 9000,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "First payload to fly on a reused first stage, B1021, previously launched with CRS-8, which also landed a second time. In what is also a first, the payload fairing remained intact after a successful splashdown achieved with thrusters and a steerable parachute.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c3b6c3bb0006eeb20b"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 38,
    "name": "SES-10",
    "date_utc": "2017-03-30T22:27:00.000Z",
    "date_unix": 1490912820,
    "date_local": "2017-03-30T18:27:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a2f359182d0b3b263e",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d00ffd86e000604b34f"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/0d/06/aNPEVF72_o.png",
        "large": "https://images2.imgbox.com/8e/6e/dM1L8DMs_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/601ykx",
        "launch": "https://www.reddit.com/r/spacex/comments/68bn8y/",
        "media": "https://www.reddit.com/r/spacex/comments/68bpii",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm3.staticflickr.com/2922/33578359423_4169ac8f98_o.jpg",
          "https://farm3.staticflickr.com/2900/33578357343_85c247ebce_o.jpg",
          "https://farm5.staticflickr.com/4166/34006001860_8c45f28e69_o.jpg",
          "https://farm5.staticflickr.com/4166/34005999880_77684dba4b_o.jpg",
          "https://farm3.staticflickr.com/2934/34005998140_c77076b6fb_o.jpg",
          "https://farm5.staticflickr.com/4191/34005996220_fe9e4342d3_o.jpg",
          "https://farm3.staticflickr.com/2883/33575654563_699c544776_o.jpg",
          "https://farm3.staticflickr.com/2902/33575652913_0dece34db4_o.jpg",
          "https://farm5.staticflickr.com/4163/33575651063_24e05826c5_o.jpg",
          "https://farm3.staticflickr.com/2876/33994851620_fabd14770f_o.jpg",
          "https://farm3.staticflickr.com/2832/33973172140_b370b79c51_o.jpg",
          "https://farm3.staticflickr.com/2874/34357262105_11b417bea2_o.jpg",
          "https://farm5.staticflickr.com/4158/34357260545_16870a94ba_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/nrol76presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=EzQpkQ1etdA",
      "youtube_id": "EzQpkQ1etdA",
      "article": "https://techcrunch.com/2017/05/01/spacex-successfully-launches-nrol-76-u-s-military-satellite/",
      "wikipedia": "https://en.wikipedia.org/wiki/List_of_NRO_launches"
    },
    "static_fire_date_utc": "2017-04-25T19:02:00.000Z",
    "static_fire_date_unix": 1493146920,
    "net": false,
    "window": 7200,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "First launch under SpaceX's certification for national security space missions, which allows SpaceX to contract launch services for classified payloads. Second-stage speed and altitude telemetry were omitted from the launch webcast, which displayed first-stage telemetry instead, with continuous tracking of the booster from liftoff to landing for the first time.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90c"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c3b6c3bb0006eeb20c"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 39,
    "name": "NROL-76",
    "date_utc": "2017-05-01T11:15:00.000Z",
    "date_unix": 1493637300,
    "date_local": "2017-05-01T07:15:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a3f3591811f83b2648",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d01ffd86e000604b350"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/82/d6/SCoNa79H_o.png",
        "large": "https://images2.imgbox.com/76/0b/bJD0zV02_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/64kguj/",
        "launch": "https://www.reddit.com/r/spacex/comments/6b88hz/",
        "media": "https://www.reddit.com/r/spacex/comments/6bcf8j/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4174/33859521334_d75fa367d5_o.jpg",
          "https://farm5.staticflickr.com/4158/33859520764_5bb7a7daf6_o.jpg",
          "https://farm5.staticflickr.com/4182/33859520404_a9c78c971d_o.jpg",
          "https://farm5.staticflickr.com/4157/34556140711_f404943340_o.jpg",
          "https://farm5.staticflickr.com/4179/34556139821_b2d6255e07_o.jpg",
          "https://farm5.staticflickr.com/4187/34684981395_2f93965492_o.jpg",
          "https://farm5.staticflickr.com/4155/34684980875_77b745158a_o.jpg",
          "https://farm5.staticflickr.com/4183/34296430820_8d3a42c0d7_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/inmarsat5f4presskit_final.pdf",
      "webcast": "https://www.youtube.com/watch?v=ynMYE64IEKs",
      "youtube_id": "ynMYE64IEKs",
      "article": "https://www.space.com/36852-spacex-launches-inmarsat-5-f4-satellite.html",
      "wikipedia": "https://en.wikipedia.org/wiki/Inmarsat#Satellites"
    },
    "static_fire_date_utc": "2017-05-11T16:45:00.000Z",
    "static_fire_date_unix": 1494521100,
    "net": false,
    "window": 2940,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "At 6,070 kg this was the heaviest payload launched to GTO by a Falcon 9 rocket. The launch was originally scheduled for the Falcon Heavy, but performance improvements allowed the mission to be carried out by an expendable Falcon 9 instead.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4c3b6c3bb0006eeb20d"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 40,
    "name": "Inmarsat-5 F4",
    "date_utc": "2017-05-15T23:21:00.000Z",
    "date_unix": 1494890460,
    "date_local": "2017-05-15T19:21:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a3f359186f3f3b2649",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d01ffd86e000604b351"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/e8/33/RV791zv9_o.png",
        "large": "https://images2.imgbox.com/4b/88/4irzX449_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/68ul58/",
        "launch": "https://www.reddit.com/r/spacex/comments/6ektkt/",
        "media": "https://www.reddit.com/r/spacex/comments/6emlzr/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4210/34696326760_cee662ef1f_o.jpg",
          "https://farm5.staticflickr.com/4279/34239858024_64795724c9_o.jpg",
          "https://farm5.staticflickr.com/4250/35043398436_3ceaa0098a_o.jpg",
          "https://farm5.staticflickr.com/4223/34272083563_f52e5bfffe_o.jpg",
          "https://farm5.staticflickr.com/4219/34918571502_7cf66854f7_o.jpg",
          "https://farm5.staticflickr.com/4252/34918568732_4efe0885de_o.jpg",
          "https://farm5.staticflickr.com/4264/34272065153_cfd8899f3e_o.jpg",
          "https://farm5.staticflickr.com/4284/34948230531_e76b7560c9_o.jpg",
          "https://farm5.staticflickr.com/4280/35078830875_afbd41c675_o.jpg",
          "https://farm5.staticflickr.com/4280/34268361083_71fc70ff1a_o.jpg",
          "https://farm5.staticflickr.com/4199/35038651646_93d0339269_o.jpg",
          "https://farm5.staticflickr.com/4227/34223076793_4abe7e74d6_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/crs11presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=JuZBOUMsYws",
      "youtube_id": "JuZBOUMsYws",
      "article": "https://spaceflightnow.com/2017/06/03/reused-dragon-cargo-capsule-launched-on-journey-to-space-station/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-11"
    },
    "static_fire_date_utc": "2017-05-28T16:00:00.000Z",
    "static_fire_date_unix": 1495987200,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission delivered the Neutron Star Interior Composition Explorer (NICER) to the ISS, along with the MUSES Earth imaging platform and ROSA solar array. For the first time, this mission launched a refurbished Dragon capsule, serial number C106 which first flew in September 2014 on the CRS-4 mission. Originally scheduled to launch on June 1, but was scrubbed due to inclement weather.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c912"
    ],
    "capsules": [
      "5e9e2c5bf3591880643b2669"
    ],
    "payloads": [
      "5eb0e4c4b6c3bb0006eeb20e"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 41,
    "name": "CRS-11",
    "date_utc": "2017-06-03T21:07:00.000Z",
    "date_unix": 1496524020,
    "date_local": "2017-06-03T17:07:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a3f3591856803b264a",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d03ffd86e000604b352"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/1b/40/Ouyy9Neh_o.png",
        "large": "https://images2.imgbox.com/3b/6c/d5ulGpoh_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/69hhkm/bulgariasat1_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/6isph2/welcome_to_the_rspacex_bulgariasat1_official/",
        "media": "https://www.reddit.com/r/spacex/comments/6iuj1z/rspacex_bulgariasat1_media_thread_videos_images/",
        "recovery": "https://www.reddit.com/r/spacex/comments/6k3kop/b10292_bulgariasat_1_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4216/35496028185_ac5456195f_o.jpg",
          "https://farm5.staticflickr.com/4278/35496027525_9ab9d90417_o.jpg",
          "https://farm5.staticflickr.com/4277/35496026875_fd25c46934_o.jpg",
          "https://farm5.staticflickr.com/4257/35496026065_02fe65754b_o.jpg",
          "https://farm5.staticflickr.com/4289/35491530485_5a4d0f39ae_o.jpg",
          "https://farm5.staticflickr.com/4279/35491529875_1e35ee0a1e_o.jpg",
          "https://farm5.staticflickr.com/4230/34681559323_53f05581ca_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/bulgariasat1presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=Y8mLi-rRTh8",
      "youtube_id": "Y8mLi-rRTh8",
      "article": "https://en.wikipedia.org/wiki/BulgariaSat-1",
      "wikipedia": "https://en.wikipedia.org/wiki/BulgariaSat-1"
    },
    "static_fire_date_utc": "2017-06-15T22:25:00.000Z",
    "static_fire_date_unix": 1497565500,
    "net": false,
    "window": 7200,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Second time a booster will be reused: Second flight of B1029 after the Iridium mission of January 2017. The satellite will be the first commercial Bulgarian-owned communications satellite and it will provide television broadcasts and other communications services over southeast Europe.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c4b6c3bb0006eeb20f"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 42,
    "name": "BulgariaSat-1",
    "date_utc": "2017-06-23T19:10:00.000Z",
    "date_unix": 1498245000,
    "date_local": "2017-06-23T15:10:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a3f359189e3a3b2645",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d04ffd86e000604b353"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/cd/99/lNWjUnUS_o.png",
        "large": "https://images2.imgbox.com/3f/f0/7zaluW42_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/6bp4fj/",
        "launch": "https://www.reddit.com/r/spacex/comments/6j67ti/",
        "media": "https://www.reddit.com/r/spacex/comments/6j7va6/",
        "recovery": "https://www.reddit.com/r/spacex/comments/6k16ho/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4162/34868729603_c75aa126b5_o.jpg",
          "https://farm5.staticflickr.com/4256/35618496935_5049a27240_o.jpg",
          "https://farm5.staticflickr.com/4138/35231792310_377477e626_o.jpg",
          "https://farm5.staticflickr.com/4005/35231791780_dd15335d5e_o.jpg",
          "https://farm5.staticflickr.com/4289/35371450262_bb9c682ace_o.jpg",
          "https://farm5.staticflickr.com/4263/35499710806_f9179bea0e_o.jpg",
          "https://farm5.staticflickr.com/4256/35533873795_eb04895a60_o.jpg",
          "https://farm5.staticflickr.com/4217/35533872755_900b3e8977_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/iridium2presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=7tIwZg8F9b8",
      "youtube_id": "7tIwZg8F9b8",
      "article": "https://www.space.com/37304-liftoff-spacex-second-launch-three-days.html",
      "wikipedia": "https://en.wikipedia.org/wiki/Iridium_satellite_constellation"
    },
    "static_fire_date_utc": "2017-06-20T22:10:00.000Z",
    "static_fire_date_unix": 1497996600,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "First flight with titanium grid fins to improve control authority and better cope with heat during re-entry.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ea6ed2f080df4000697c911",
      "5ea6ed30080df4000697c912"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c4b6c3bb0006eeb210"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 43,
    "name": "Iridium NEXT Mission 2",
    "date_utc": "2017-06-25T20:25:00.000Z",
    "date_unix": 1498422300,
    "date_local": "2017-06-25T13:25:00-07:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a3f3591801cf3b264b",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d05ffd86e000604b354"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/ab/6f/3l4ib2QW_o.png",
        "large": "https://images2.imgbox.com/94/85/7GzzSMBu_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/6fw4yy/",
        "launch": "https://www.reddit.com/r/spacex/comments/6kt2re/",
        "media": "https://www.reddit.com/r/spacex/comments/6kt3fe/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4063/35758875505_a8559a6226_o.jpg",
          "https://farm5.staticflickr.com/4025/35758874355_5075298440_o.jpg",
          "https://farm5.staticflickr.com/4235/35359372730_df7c79797b_o.jpg",
          "https://farm5.staticflickr.com/4014/35359371840_239a658872_o.jpg",
          "https://farm5.staticflickr.com/4002/35577536822_679c68862d_o.jpg",
          "https://farm5.staticflickr.com/4259/34868730393_b778d81a71_o.jpg",
          "https://farm5.staticflickr.com/4162/34868729603_c75aa126b5_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/intelsat35epresskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=MIHVPCj25Z0",
      "youtube_id": "MIHVPCj25Z0",
      "article": "https://spaceflightnow.com/2017/07/06/spacex-delivers-for-intelsat-on-heavyweight-falcon-9-mission/",
      "wikipedia": "https://en.wikipedia.org/wiki/Intelsat_35e"
    },
    "static_fire_date_utc": "2017-06-29T00:30:00.000Z",
    "static_fire_date_unix": 1498696200,
    "net": false,
    "window": 3480,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Due to the constraints of sending a heavy satellite (~6,000 kg) to GTO, the rocket will fly in its expendable configuration and the first-stage booster will not be recovered.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4c4b6c3bb0006eeb211"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 44,
    "name": "Intelsat 35e",
    "date_utc": "2017-07-05T23:35:00.000Z",
    "date_unix": 1499297700,
    "date_local": "2017-07-05T19:35:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a4f3591850cc3b264c",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d06ffd86e000604b355"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/4e/c6/M7X1WGKk_o.png",
        "large": "https://images2.imgbox.com/95/31/PhgU9kf9_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/6mrga2/crs12_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/6tfcio/welcome_to_the_rspacex_crs12_official_launch/",
        "media": "https://www.reddit.com/r/spacex/comments/6th2nf/rspacex_crs12_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4352/36438808381_733603843d_o.jpg",
          "https://farm5.staticflickr.com/4434/35760634184_f75457493b_o.jpg",
          "https://farm5.staticflickr.com/4418/35741466074_327e9d0a80_o.jpg",
          "https://farm5.staticflickr.com/4414/35741465934_db82541cf3_o.jpg",
          "https://farm5.staticflickr.com/4384/35741465854_e264864537_o.jpg",
          "https://farm5.staticflickr.com/4333/35741465714_d0a8800533_o.jpg",
          "https://farm5.staticflickr.com/4397/35741465464_1d49cc1cae_o.jpg",
          "https://farm5.staticflickr.com/4354/35762350653_d94b2b5b07_o.jpg",
          "https://farm5.staticflickr.com/4353/36571921725_2a0be4ec58_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/crs12presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=vLxWsYx8dbo",
      "youtube_id": "vLxWsYx8dbo",
      "article": "https://spaceflightnow.com/2017/08/17/photos-falcon-9-rocket-soars-into-space-lands-back-at-cape-canaveral/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-12"
    },
    "static_fire_date_utc": "2017-08-10T13:10:00.000Z",
    "static_fire_date_unix": 1502370600,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Dragon is expected to carry 2,349 kg (5,179 lb) of pressurized mass and 961 kg (2,119 lb) unpressurized. The external payload manifested for this flight is the CREAM cosmic-ray detector. First flight of the Falcon 9 Block 4 upgrade. Last flight of a newly-built Dragon capsule; further missions will use refurbished spacecraft.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c912"
    ],
    "capsules": [
      "5e9e2c5cf3591869b63b2670"
    ],
    "payloads": [
      "5eb0e4c4b6c3bb0006eeb212"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 45,
    "name": "CRS-12",
    "date_utc": "2017-08-14T16:31:00.000Z",
    "date_unix": 1502728260,
    "date_local": "2017-08-14T12:31:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a4f3591884ee3b264d",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d07ffd86e000604b356"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/f9/3a/3kH19hlj_o.png",
        "large": "https://images2.imgbox.com/a7/2a/s41i5C9t_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/6o98st",
        "launch": "https://www.reddit.com/r/spacex/comments/6vihsl/welcome_to_the_rspacex_formosat5_official_launch/",
        "media": "https://www.reddit.com/r/spacex/comments/6vhwi1/rspacex_formosat5_media_thread_videos_images_gifs/",
        "recovery": "https://www.reddit.com/r/spacex/comments/6wk653/b1038_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4434/36075361533_54b3b937dd_o.jpg",
          "https://farm5.staticflickr.com/4428/36884090115_ced8a80f14_o.jpg",
          "https://farm5.staticflickr.com/4393/36073897213_6746d2a8b2_o.jpg",
          "https://farm5.staticflickr.com/4341/36073878143_45c3ef0b93_o.jpg",
          "https://farm5.staticflickr.com/4369/35978284213_e12e5743ab_o.jpg",
          "https://farm5.staticflickr.com/4394/35978283413_145ba2ca2f_o.jpg",
          "https://farm5.staticflickr.com/4340/35978282703_5dff70fb19_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/formosat5presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=J4u3ZN2g_MI",
      "youtube_id": "J4u3ZN2g_MI",
      "article": "https://spaceflightnow.com/2017/08/25/taiwanese-satellite-rides-spacex-rocket-into-orbit/",
      "wikipedia": "https://en.wikipedia.org/wiki/Formosat-5"
    },
    "static_fire_date_utc": "2017-08-24T18:50:00.000Z",
    "static_fire_date_unix": 1503600600,
    "net": false,
    "window": 2520,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Formosat-5 is an Earth observation satellite of the Taiwanese space agency. The SHERPA space tug by Spaceflight Industries was removed from the cargo manifest of this mission. The satellite has a mass of only 475 kg.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c905",
      "5ea6ed2f080df4000697c910"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c4b6c3bb0006eeb213"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 46,
    "name": "FormoSat-5",
    "date_utc": "2017-08-24T18:50:00.000Z",
    "date_unix": 1503600600,
    "date_local": "2017-08-24T11:50:00-07:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a4f359182d843b264e",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d08ffd86e000604b357"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/bb/c2/CpO3VtI7_o.png",
        "large": "https://images2.imgbox.com/7e/ad/Q6iDgXq2_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/6u6q1t/x37b_otv5_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/6ygmf1/rspacex_x37b_otv5_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/6yih4g/rspacex_x37b_otv5_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4411/37087809715_08a6d9904d_o.jpg",
          "https://farm5.staticflickr.com/4384/37087808315_4dc9575d1b_o.jpg",
          "https://farm5.staticflickr.com/4363/36251815974_8b996dbbfb_o.jpg",
          "https://farm5.staticflickr.com/4374/36251814644_1a469f63ee_o.jpg",
          "https://farm5.staticflickr.com/4388/36251812554_006501315f_o.jpg",
          "https://farm5.staticflickr.com/4355/36250895284_8c24cb4232_o.jpg",
          "https://farm5.staticflickr.com/4342/36689886890_99709e6934_o.jpg",
          "https://farm5.staticflickr.com/4364/36689885100_c3c427c6bf_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/otv5_presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=9M6Zvi-fFv4",
      "youtube_id": "9M6Zvi-fFv4",
      "article": "https://spaceflightnow.com/2017/09/07/spacex-beats-hurricane-with-smooth-launch-of-militarys-x-37b-spaceplane/",
      "wikipedia": "https://en.wikipedia.org/wiki/Boeing_X-37"
    },
    "static_fire_date_utc": "2017-08-31T20:30:00.000Z",
    "static_fire_date_unix": 1504211400,
    "net": false,
    "window": 18300,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Notable because Boeing is the primary contractor of the X-37B, which has until now been launched by ULA, a SpaceX competitor and Boeing partnership. Second flight of the Falcon 9 Block 4 upgrade.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c906",
      "5ea6ed2f080df4000697c90b"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c5b6c3bb0006eeb214"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 47,
    "name": "Boeing X-37B OTV-5",
    "date_utc": "2017-09-07T13:50:00.000Z",
    "date_unix": 1504792200,
    "date_local": "2017-09-07T09:50:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a4f3591845123b264f",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d09ffd86e000604b358"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/1c/e0/lhGbeqkh_o.png",
        "large": "https://images2.imgbox.com/16/0c/P2REhX5k_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/6ygwxw/iridium_next_constellation_mission_3_launch/",
        "launch": "https://www.reddit.com/r/spacex/comments/753e0m/iridium_next_mission_3_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/755m2z/rspacex_iridium3_media_thread_videos_images_gifs/",
        "recovery": "https://www.reddit.com/r/spacex/comments/75z823/b10411_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4509/37610550066_b56bc5d743_o.jpg",
          "https://farm5.staticflickr.com/4487/37610548356_1b7d30001e_o.jpg",
          "https://farm5.staticflickr.com/4514/37610547696_9114038d60_o.jpg",
          "https://farm5.staticflickr.com/4483/37610547226_01d19395a3_o.jpg",
          "https://farm5.staticflickr.com/4504/36984625383_d7707548ec_o.jpg",
          "https://farm5.staticflickr.com/4505/36984623903_7bb6643649_o.jpg",
          "https://farm5.staticflickr.com/4445/36984622463_6f9b21929c_o.jpg",
          "https://farm5.staticflickr.com/4471/36944884234_92ddc7fb39_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/iridium3presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=SB4N4xF2B2w&feature=youtu.be",
      "youtube_id": "SB4N4xF2B2w",
      "article": "https://spaceflightnow.com/2017/10/09/spacex-launch-adds-another-10-satellites-to-iridium-next-fleet/",
      "wikipedia": "https://en.wikipedia.org/wiki/Iridium_satellite_constellation#Next-generation_constellation"
    },
    "static_fire_date_utc": "2017-10-05T13:31:00.000Z",
    "static_fire_date_unix": 1507210260,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Third of eight missions to launch Iridium's second generation constellation from VAFB",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c905",
      "5ea6ed2f080df4000697c910"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c5b6c3bb0006eeb215"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 48,
    "name": "Iridium NEXT Mission 3",
    "date_utc": "2017-10-09T12:37:00.000Z",
    "date_unix": 1507552620,
    "date_local": "2017-10-09T05:37:00-07:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a4f3591843103b2650",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d0affd86e000604b359"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/e3/b5/UEzC560l_o.png",
        "large": "https://images2.imgbox.com/75/43/F11jelFx_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/6yvn64/ses11echostar_105_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/75bw7p/ses11echostar105_official_launch_discussions/",
        "media": "https://www.reddit.com/r/spacex/comments/75pgu5/rspacex_ses11_media_thread_videos_images_gifs/",
        "recovery": "https://www.reddit.com/r/spacex/comments/76fqz1/b10312_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4471/37388002420_b86680c3af_o.jpg",
          "https://farm5.staticflickr.com/4497/37388002170_a267280534_o.jpg",
          "https://farm5.staticflickr.com/4455/37388001730_0869279a8d_o.jpg",
          "https://farm5.staticflickr.com/4465/36975195443_b98ed0fb24_o.jpg",
          "https://farm5.staticflickr.com/4499/36975194993_8548a53c60_o.jpg",
          "https://farm5.staticflickr.com/4482/36975194613_15bb109059_o.jpg",
          "https://farm5.staticflickr.com/4453/36975194233_5f8f45c686_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/echostar105ses11presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=iv1zeGSvhIw",
      "youtube_id": "iv1zeGSvhIw",
      "article": "https://spaceflightnow.com/2017/10/12/video-falcon-9-rocket-lifts-off-with-joint-satellite-for-ses-echostar/",
      "wikipedia": "https://en.wikipedia.org/wiki/List_of_SES_satellites"
    },
    "static_fire_date_utc": "2017-10-02T20:30:00.000Z",
    "static_fire_date_unix": 1506976200,
    "net": false,
    "window": 7200,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Nineteenth comsat to GTO, also the fourth satellite launched for SES and second for Echostar. Third time a first stage booster will be reused.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90d",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c5b6c3bb0006eeb216"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 49,
    "name": "SES-11 / Echostar 105",
    "date_utc": "2017-10-11T22:53:00.000Z",
    "date_unix": 1507762380,
    "date_local": "2017-10-11T18:53:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a3f3591829dc3b2646",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d0cffd86e000604b35a"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": false,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/02/51/7NLaBm8c_o.png",
        "large": "https://images2.imgbox.com/69/f5/04lBXd2F_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/73ttkd/koreasat_5a_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/79iuvb/rspacex_koreasat_5a_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/79lmdu/rspacex_koreasat5a_media_thread_videos_images/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4477/38056454431_a5f40f9fd7_o.jpg",
          "https://farm5.staticflickr.com/4455/26280153979_b8016a829f_o.jpg",
          "https://farm5.staticflickr.com/4459/38056455051_79ef2b949a_o.jpg",
          "https://farm5.staticflickr.com/4466/26280153539_ecbc2b3fa9_o.jpg",
          "https://farm5.staticflickr.com/4482/26280154209_bf08d76361_o.jpg",
          "https://farm5.staticflickr.com/4493/38056455211_a4565a9cee_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/koreasat5apresskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=RUjH14vhLxA",
      "youtube_id": "RUjH14vhLxA",
      "article": "https://spaceflightnow.com/2017/10/30/spacex-launches-and-lands-third-rocket-in-three-weeks/",
      "wikipedia": "https://en.wikipedia.org/wiki/Koreasat_5A"
    },
    "static_fire_date_utc": "2017-10-26T16:00:00.000Z",
    "static_fire_date_unix": 1509033600,
    "net": false,
    "window": 8640,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "KoreaSat 5A is a Ku-band satellite capable of providing communication services from East Africa and Central Asia to southern India, Southeast Asia, the Philippines, Guam, Korea, and Japan. The satellite will be placed in GEO at 113Â° East Longitude, and will provide services ranging from broadband internet to broadcasting services and maritime communications.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90d",
      "5ea6ed2e080df4000697c908",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c5b6c3bb0006eeb217"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 50,
    "name": "KoreaSat 5A",
    "date_utc": "2017-10-30T19:34:00.000Z",
    "date_unix": 1509392040,
    "date_local": "2017-10-30T15:34:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a4f359185cc03b2651",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d0dffd86e000604b35b"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/ea/12/8vVzlOeL_o.png",
        "large": "https://images2.imgbox.com/1b/30/oP1DBQ6b_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/7bxg5a/crs13_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/7j725w/rspacex_crs13_official_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/7j6oxz/rspacex_crs13_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4591/38372264594_8140bd943d_o.png",
          "https://farm5.staticflickr.com/4546/39051469552_13703e6b2e_o.jpg",
          "https://farm5.staticflickr.com/4682/39051469662_55c55150c0_o.jpg",
          "https://farm5.staticflickr.com/4565/25215551218_2597838c1a_o.jpg",
          "https://farm5.staticflickr.com/4680/39051469812_b6f802fc9d_o.jpg",
          "https://farm5.staticflickr.com/4517/27304331429_59b9d6c1d4_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/crs13presskit12_11.pdf",
      "webcast": "https://www.youtube.com/watch?v=OPHbqY9LHCs",
      "youtube_id": "OPHbqY9LHCs",
      "article": "https://spaceflightnow.com/2017/12/15/spacexs-50th-falcon-rocket-launch-kicks-off-station-resupply-mission/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-13"
    },
    "static_fire_date_utc": "2017-12-06T20:00:00.000Z",
    "static_fire_date_unix": 1512590400,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Will reuse the Dragon capsule previously flown on CRS-6 and will reuse the booster from CRS-11.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c912"
    ],
    "capsules": [
      "5e9e2c5cf359188bfb3b266b"
    ],
    "payloads": [
      "5eb0e4c5b6c3bb0006eeb218"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 51,
    "name": "CRS-13",
    "date_utc": "2017-12-15T15:36:00.000Z",
    "date_unix": 1513352160,
    "date_local": "2017-12-15T10:36:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a3f3591856803b264a",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d0effd86e000604b35c"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/cb/4b/n6GTX4PI_o.png",
        "large": "https://images2.imgbox.com/ee/c2/x8q8XiTg_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/7cgts7/iridium_next_constellation_mission_4_launch/",
        "launch": "https://www.reddit.com/r/spacex/comments/7li8y2/rspacex_iridium_next_4_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/7litv2/rspacex_iridium4_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4695/25557986177_2d315f4c11_o.jpg",
          "https://farm5.staticflickr.com/4735/25377631178_d28e0a9141_o.jpg",
          "https://farm5.staticflickr.com/4733/25377628928_a79bb43a31_o.jpg",
          "https://farm5.staticflickr.com/4732/25377628288_361f551d34_o.jpg",
          "https://farm5.staticflickr.com/4598/39244105581_eeb76c8ed2_o.jpg",
          "https://farm5.staticflickr.com/4728/24381830217_a49ae2100f_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/iridium4presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=wtdjCwo6d3Q",
      "youtube_id": "wtdjCwo6d3Q",
      "article": "https://spaceflightnow.com/2017/12/23/spacex-launch-dazzles-delivering-10-more-satellites-for-iridium/",
      "wikipedia": "https://en.wikipedia.org/wiki/Iridium_satellite_constellation#Next-generation_constellation"
    },
    "static_fire_date_utc": "2017-12-17T21:00:00.000Z",
    "static_fire_date_unix": 1513544400,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Reusing the booster first used on Iridium-2, but will be flying expendable.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c6b6c3bb0006eeb219"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 52,
    "name": "Iridium NEXT Mission 4",
    "date_utc": "2017-12-23T01:27:23.000Z",
    "date_unix": 1513992443,
    "date_local": "2017-12-22T17:27:23-08:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a3f3591801cf3b264b",
        "flight": 2,
        "gridfins": true,
        "legs": false,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "Ocean",
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d0fffd86e000604b35d"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/e8/30/yMNPvCci_o.png",
        "large": "https://images2.imgbox.com/26/99/ppTFXiLw_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/7895bo/zuma_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/7oqjf0/rspacex_zuma_official_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/7orksl/rspacex_zuma_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4751/39557026242_384d287045_o.jpg",
          "https://farm5.staticflickr.com/4674/39556549372_810396618d_o.jpg",
          "https://farm5.staticflickr.com/4661/39556548902_f66c7be90d_o.jpg",
          "https://farm5.staticflickr.com/4607/39585580001_8b21846eab_o.jpg",
          "https://farm5.staticflickr.com/4754/39585578201_a67ab9b9a8_o.jpg",
          "https://farm5.staticflickr.com/4603/39585575631_216cc035f4_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/zumapresskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=0PWu3BRxn60",
      "youtube_id": "0PWu3BRxn60",
      "article": "https://spaceflightnow.com/2018/01/08/spacex-kicks-off-ambitious-2018-schedule-with-launch-for-u-s-government/",
      "wikipedia": "https://en.wikipedia.org/wiki/Zuma_(satellite)"
    },
    "static_fire_date_utc": "2017-11-11T23:00:00.000Z",
    "static_fire_date_unix": 1510441200,
    "net": false,
    "window": 7200,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Originally planned for mid-November 2017, the mission was delayed due to test results from the fairing of another customer. First-stage booster will attempt landing at LZ-1",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4c6b6c3bb0006eeb21a"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 53,
    "name": "ZUMA",
    "date_utc": "2018-01-08T01:00:00.000Z",
    "date_unix": 1515373200,
    "date_local": "2018-01-07T20:00:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a4f35918345e3b2652",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d10ffd86e000604b35e"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/95/ec/FoFpPft0_o.png",
        "large": "https://images2.imgbox.com/42/0a/LAupFe3L_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/7olw86/govsat1_ses16_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/7tvtbh/rspacex_govsat1_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/7tzzwy/rspacex_govsat1_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4721/40026315981_f16a7cd32a_o.jpg",
          "https://farm5.staticflickr.com/4708/40026316291_0b3aef9d8d_o.jpg",
          "https://farm5.staticflickr.com/4652/39128355655_3eefa0d583_o.jpg",
          "https://farm5.staticflickr.com/4741/39128355825_7c4166dbbe_o.jpg",
          "https://farm5.staticflickr.com/4609/39128355355_17381fc00e_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/govsat1presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=ScYUA51-POQ",
      "youtube_id": "ScYUA51-POQ",
      "article": "https://spaceflightnow.com/2018/01/31/spacex-rocket-flies-on-60th-anniversary-of-first-u-s-satellite-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/List_of_SES_satellites#SES_Fleet"
    },
    "static_fire_date_utc": "2018-01-26T15:27:00.000Z",
    "static_fire_date_unix": 1516980420,
    "net": false,
    "window": 8460,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Reused booster from the classified NROL-76 mission in May 2017. Following a successful experimental ocean landing that used three engines, the booster unexpectedly remained intact; Elon Musk stated in a tweet that SpaceX will attempt to tow the booster to shore.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90b"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c6b6c3bb0006eeb21b"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 54,
    "name": "SES-16 / GovSat-1",
    "date_utc": "2018-01-31T21:25:00.000Z",
    "date_unix": 1517433900,
    "date_local": "2018-01-31T16:25:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a3f3591811f83b2648",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "Ocean",
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d11ffd86e000604b35f"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/22/5f/jAAULKc3_o.png",
        "large": "https://images2.imgbox.com/33/1a/ujrnfkna_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/7hjp03/falcon_heavy_demo_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/7vg63x/rspacex_falcon_heavy_test_flight_official_launch/",
        "media": "https://www.reddit.com/r/spacex/comments/7vimtm/rspacex_falcon_heavy_test_flight_media_thread/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4745/40110304192_b0165b7785_o.jpg",
          "https://farm5.staticflickr.com/4676/40110297852_6173e5cae6_o.jpg",
          "https://farm5.staticflickr.com/4615/40143096241_0324643b5e_o.jpg",
          "https://farm5.staticflickr.com/4702/40110298232_4e9c412936_o.jpg",
          "https://farm5.staticflickr.com/4610/39337245575_41d760caef_o.jpg",
          "https://farm5.staticflickr.com/4654/25254688767_59603ff06c_o.jpg",
          "https://farm5.staticflickr.com/4627/40126462801_d54b4f00be_o.jpg",
          "https://farm5.staticflickr.com/4760/40126462231_cdf00ef431_o.jpg",
          "https://farm5.staticflickr.com/4655/40202121122_5d29cfe2ac_o.jpg",
          "https://farm5.staticflickr.com/4631/39337245145_5f5630a66a_o.jpg",
          "https://farm5.staticflickr.com/4650/40126461851_14b93ec9d7_o.jpg",
          "https://farm5.staticflickr.com/4711/40126461411_b1ed283d45_o.jpg",
          "https://farm5.staticflickr.com/4696/40126460511_7b5cc64871_o.jpg",
          "https://farm5.staticflickr.com/4589/38583831555_9ae89f5c10_o.jpg",
          "https://farm5.staticflickr.com/4682/38583829815_e01509d1a7_o.jpg",
          "https://farm5.staticflickr.com/4731/39225582801_80594d5d91_o.jpg",
          "https://farm5.staticflickr.com/4641/39225582421_7aa0c65851_o.jpg",
          "https://farm5.staticflickr.com/4643/27449864329_d2424bc280_o.jpg",
          "https://farm5.staticflickr.com/4681/39225582171_137a4c75e7_o.jpg",
          "https://farm5.staticflickr.com/4644/39225582351_ac6aba2533_o.jpg",
          "https://farm5.staticflickr.com/4587/27449863849_709e135a98_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/falconheavypresskit_v1.pdf",
      "webcast": "https://www.youtube.com/watch?v=wbSwFU6tY1c",
      "youtube_id": "wbSwFU6tY1c",
      "article": "https://spaceflightnow.com/2018/02/07/spacex-debuts-worlds-most-powerful-rocket-sends-tesla-toward-the-asteroid-belt/",
      "wikipedia": "https://en.wikipedia.org/wiki/Elon_Musk%27s_Tesla_Roadster"
    },
    "static_fire_date_utc": "2018-01-24T17:30:00.000Z",
    "static_fire_date_unix": 1516815000,
    "net": false,
    "window": 9000,
    "rocket": "5e9d0d95eda69974db09d1ed",
    "success": true,
    "failures": [],
    "details": "The launch was a success, and the side boosters landed simultaneously at adjacent ground pads. Drone ship landing of the central core failed. Final burn to heliocentric mars-earth orbit was successful after the second stage and payload passed through the Van Allen belts.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90c",
      "5ea6ed2f080df4000697c90d",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c6b6c3bb0006eeb21c"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 55,
    "name": "Falcon Heavy Test Flight",
    "date_utc": "2018-02-06T20:45:00.000Z",
    "date_unix": 1517949900,
    "date_local": "2018-02-06T15:45:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f359187f703b2653",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      },
      {
        "core": "5e9e28a2f359187f273b2642",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb90a834e7c8"
      },
      {
        "core": "5e9e28a2f3591845c73b2640",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d13ffd86e000604b360"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": false,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/f9/05/I9duWQ6v_o.png",
        "large": "https://images2.imgbox.com/f1/b8/HAXSg9rr_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/7qnflk/paz_microsat2a_2b_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/7y0grt/rspacex_paz_official_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/7zdvop/rspacex_paz_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4768/25557986627_f3cc243afb_o.jpg",
          "https://farm5.staticflickr.com/4631/25557986367_6339dd8f1d_o.jpg",
          "https://farm5.staticflickr.com/4650/25557987937_585c15c34d_o.jpg",
          "https://farm5.staticflickr.com/4695/39718494114_6523797470_o.jpg",
          "https://farm5.staticflickr.com/4655/39533211685_5e0ceb78ef_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/paz_press_kit_2.21.pdf",
      "webcast": "https://www.youtube.com/watch?v=-p-PToD2URA",
      "youtube_id": "-p-PToD2URA",
      "article": "https://spaceflightnow.com/2018/02/22/recycled-spacex-rocket-boosts-paz-radar-satellite-first-starlink-testbeds-into-orbit/",
      "wikipedia": "https://en.wikipedia.org/wiki/Paz_(satellite)"
    },
    "static_fire_date_utc": "2018-02-11T18:23:00.000Z",
    "static_fire_date_unix": 1518373380,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "First flight with fairing 2.0. Will also carry two SpaceX test satellites for the upcoming Starlink constellation.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c6b6c3bb0006eeb21d",
      "5eb0e4c6b6c3bb0006eeb21e"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 56,
    "name": "Paz / Starlink Demo",
    "date_utc": "2018-02-22T14:17:00.000Z",
    "date_unix": 1519309020,
    "date_local": "2018-02-22T06:17:00-08:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a4f359182d843b264e",
        "flight": 2,
        "gridfins": true,
        "legs": false,
        "reused": true,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d14ffd86e000604b361"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/87/5d/ZDr6l98A_o.png",
        "large": "https://images2.imgbox.com/86/73/dycVqz0C_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/7r5pyn/hispasat_30w6_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/7r5pyn/hispasat_30w6_launch_campaign_thread/",
        "media": "https://www.reddit.com/r/spacex/comments/825asx/rspacex_hispasat_30w6_media_thread_videos_images/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4753/25790223907_36e7b59efa_o.jpg",
          "https://farm5.staticflickr.com/4666/38850799080_e17426795c_o.jpg",
          "https://farm5.staticflickr.com/4758/40660917561_daa8efea04_o.jpg",
          "https://farm5.staticflickr.com/4622/39951085264_b5deeed6c9_o.jpg",
          "https://farm5.staticflickr.com/4772/39951085474_77be77c227_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/hispasat30w6_presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=Kpfrp-GMKKM",
      "youtube_id": "Kpfrp-GMKKM",
      "article": "https://spaceflightnow.com/2018/03/06/hefty-hispasat-satellite-rides-spacex-rocket-into-orbit/",
      "wikipedia": "https://en.wikipedia.org/wiki/Hispasat_30W-6"
    },
    "static_fire_date_utc": "2018-02-21T03:46:00.000Z",
    "static_fire_date_unix": 1519184760,
    "net": false,
    "window": 7200,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Launched with landing legs and titanium grid fins. Did not attempt a landing due to 'unfavorable weather conditions in the recovery area'.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4c7b6c3bb0006eeb21f"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 57,
    "name": "Hispasat 30W-6",
    "date_utc": "2018-03-06T05:33:00.000Z",
    "date_unix": 1520314380,
    "date_local": "2018-03-06T00:33:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f359186cb73b2654",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d15ffd86e000604b362"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": false,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/2f/36/Bn1RX3aO_o.png",
        "large": "https://images2.imgbox.com/6e/32/3hj6BIWx_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/82njj5/iridium_next_constellation_mission_5_launch/",
        "launch": "https://www.reddit.com/r/spacex/comments/88184i/rspacex_iridium_next_5_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/88114l/rspacex_iridium5_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm1.staticflickr.com/791/40227113515_da97986607_o.jpg",
          "https://farm1.staticflickr.com/788/27248936158_2eaf1a98b3_o.jpg",
          "https://farm1.staticflickr.com/864/40227112595_c34a1cf8d1_o.jpg",
          "https://farm1.staticflickr.com/806/41121608121_8f0b886f9d_o.jpg",
          "https://farm1.staticflickr.com/809/41121608541_cdfec6a849_o.jpg",
          "https://farm1.staticflickr.com/822/40227112875_ec3c5df585_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/iridium-5_press_kit_2018.pdf",
      "webcast": "https://www.youtube.com/watch?v=mp0TW8vkCLg",
      "youtube_id": "mp0TW8vkCLg",
      "article": "https://spaceflightnow.com/2018/03/30/iridium-messaging-network-gets-another-boost-from-spacex/",
      "wikipedia": "https://en.wikipedia.org/wiki/Iridium_satellite_constellation#Next-generation_constellation"
    },
    "static_fire_date_utc": "2018-03-25T12:23:00.000Z",
    "static_fire_date_unix": 1521980580,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Fifth Iridium NEXT mission to deploy ten Iridium NEXT satellites. Reused booster from third Iridium flight, and although controlled descent was performed, the booster was expended into the ocean. SpaceX planned a second recovery attempt of one half of the fairing using the specially modified boat Mr. Steven. However, the fairing's parafoil twisted during the recovery, which led to water impact at high speed",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c7b6c3bb0006eeb220"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 58,
    "name": "Iridium NEXT Mission 5",
    "date_utc": "2018-03-30T14:13:51.000Z",
    "date_unix": 1522419231,
    "date_local": "2018-03-30T07:13:51-08:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a4f3591843103b2650",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d16ffd86e000604b363"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/e7/bf/WzMju1cP_o.png",
        "large": "https://images2.imgbox.com/4c/3a/VGGRo5PT_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/82op7a/crs14_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/88s8a7/rspacex_crs14_official_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/88l52i/rspacex_crs14_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm1.staticflickr.com/819/26326005987_c3aec29db5_o.jpg",
          "https://farm1.staticflickr.com/791/40303273215_4926c917c4_o.jpg",
          "https://farm1.staticflickr.com/867/26326007227_39e71e6775_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/crs-14presskit2018.pdf",
      "webcast": "https://www.youtube.com/watch?v=BPQHG-LevZM",
      "youtube_id": "BPQHG-LevZM",
      "article": "https://spaceflightnow.com/2018/04/02/spacex-supply-ship-departs-cape-canaveral-for-space-station/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-14"
    },
    "static_fire_date_utc": "2018-03-28T15:52:00.000Z",
    "static_fire_date_unix": 1522252320,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "The launch used a refurbished booster (from CRS-12) for the 11th time, and a refurbished capsule (C110 from CRS-8) for the third time. External payloads include a materials research platform MISSE-FF phase 3 of the Robotic Refueling Mission TSIS, heliophysics sensor several crystallization experiments, and the RemoveDebris spacecraft aimed at space junk removal. The booster was expended in order to test a new landing profile.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c912"
    ],
    "capsules": [
      "5e9e2c5cf3591885d43b266d"
    ],
    "payloads": [
      "5eb0e4c7b6c3bb0006eeb221"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 59,
    "name": "CRS-14",
    "date_utc": "2018-04-02T20:30:41.000Z",
    "date_unix": 1522701041,
    "date_local": "2018-04-02T16:30:41-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a4f3591884ee3b264d",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d16ffd86e000604b364"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/ca/54/EEGqRRto_o.png",
        "large": "https://images2.imgbox.com/7d/2c/pYXpOVCz_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/88l46q/tess_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/8cm61o/rspacex_tess_official_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/8cmzop/rspacex_tess_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm1.staticflickr.com/799/27684194488_0d9a703c1c_o.jpg",
          "https://farm1.staticflickr.com/854/41512967372_0c37360126_o.jpg",
          "https://farm1.staticflickr.com/832/41512968122_20c2e31de3_o.jpg",
          "https://farm1.staticflickr.com/803/27684194678_c1ccd0680b_o.jpg",
          "https://farm1.staticflickr.com/902/41512967962_74913ef5b0_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/tesspresskitfinal417.pdf",
      "webcast": "https://www.youtube.com/watch?v=aY-0uBIYYKk",
      "youtube_id": "aY-0uBIYYKk",
      "article": "https://spaceflightnow.com/2018/04/19/all-sky-surveyor-launched-from-cape-canaveral-on-the-hunt-for-exoplanets/",
      "wikipedia": "https://en.wikipedia.org/wiki/Transiting_Exoplanet_Survey_Satellite"
    },
    "static_fire_date_utc": "2018-04-11T18:30:00.000Z",
    "static_fire_date_unix": 1523471400,
    "net": false,
    "window": 30,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Part of the Explorers program, this space telescope is intended for wide-field search of exoplanets transiting nearby stars. It is the first NASA high priority science mission launched by SpaceX. It was the first time SpaceX launched a scientific satellite not primarily intended for Earth observations. The second stage placed it into a high-Earth elliptical orbit, after which the satellite's own booster will perform complex maneuvers including a lunar flyby, and over the course of two months, reach a stable, 2:1 resonant orbit with the Moon. In January 2018, SpaceX received NASA's Launch Services Program Category 2 certification of its Falcon 9 'Full Thrust', certification which is required for launching medium risk missions like TESS. It was the last launch of a new Block 4 booster, and marked the 24th successful recovery of the booster. An experimental water landing was performed in order to attempt fairing recovery.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c90a",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90d",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c7b6c3bb0006eeb222"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 60,
    "name": "TESS",
    "date_utc": "2018-04-18T22:51:00.000Z",
    "date_unix": 1524091860,
    "date_local": "2018-04-18T18:51:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f35918863d3b2655",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d18ffd86e000604b365"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/94/3a/eavaQRYD_o.png",
        "large": "https://images2.imgbox.com/df/cf/wlysigUT_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/8624iq/bangabandhu1_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/8ia091/rspacex_bangabandhu1_official_launch_discussion",
        "media": "https://www.reddit.com/r/spacex/comments/8ia5bu/rspacex_bangabandhu1_media_thread_videos_images/",
        "recovery": "https://www.reddit.com/r/spacex/comments/8j6moa/bangabandhu1_block_5_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm1.staticflickr.com/903/28197547888_dd697d8147_o.jpg",
          "https://farm1.staticflickr.com/823/42025498712_8ec531950f_o.jpg",
          "https://farm1.staticflickr.com/975/28197546158_880e466fb6_o.jpg",
          "https://farm1.staticflickr.com/823/27200014957_940f3720bb_o.jpg",
          "https://farm1.staticflickr.com/945/42025498442_0b7b91d561_o.jpg",
          "https://farm1.staticflickr.com/967/42025498972_8720104d8a_o.jpg",
          "https://farm1.staticflickr.com/954/42025499162_8a0ef7feaa_o.jpg",
          "https://farm1.staticflickr.com/911/42025499722_47d3433d65_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/bangabandhupresskit51118.pdf",
      "webcast": "https://www.youtube.com/watch?v=rQEqKZ7CJlk",
      "youtube_id": "rQEqKZ7CJlk",
      "article": "https://spaceflightnow.com/2018/05/11/spacex-debuts-an-improved-human-rated-model-of-the-falcon-9-rocket/",
      "wikipedia": "https://en.wikipedia.org/wiki/Bangabandhu-1"
    },
    "static_fire_date_utc": "2018-05-04T23:25:00.000Z",
    "static_fire_date_unix": 1525476300,
    "net": false,
    "window": 7620,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "First launch of a Block V first stage.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c90a",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed30080df4000697c913",
      "5ea6ed30080df4000697c916"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c7b6c3bb0006eeb223"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 61,
    "name": "Bangabandhu-1",
    "date_utc": "2018-05-11T20:14:00.000Z",
    "date_unix": 1526069640,
    "date_local": "2018-05-11T16:14:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f359182b023b2656",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d19ffd86e000604b366"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": false,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/f5/da/hz3r2Lni_o.png",
        "large": "https://images2.imgbox.com/3d/f9/IHjBUE1f_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/8ffsgl/iridium6_gracefo_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/8kyk5a/rspacex_iridium_next_6_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/8l9tfz/rspacex_iridium6gracefo_media_thread_videos/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm1.staticflickr.com/897/42290934301_4c6ac431c8_o.jpg",
          "https://farm1.staticflickr.com/831/42290933051_510176c9da_o.jpg",
          "https://farm1.staticflickr.com/882/42290932011_a522b43015_o.jpg",
          "https://farm1.staticflickr.com/947/42290930761_4bf7b607b1_o.jpg",
          "https://farm1.staticflickr.com/982/42290930181_0117ab0dfb_o.jpg",
          "https://farm1.staticflickr.com/955/42244412292_e787538fc5_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/iridium6presskit2018521.pdf",
      "webcast": "https://www.youtube.com/watch?v=I_0GgKfwCSk",
      "youtube_id": "I_0GgKfwCSk",
      "article": "https://spaceflightnow.com/2018/05/22/rideshare-launch-by-spacex-serves-commercial-and-scientific-customers/",
      "wikipedia": "https://en.wikipedia.org/wiki/Gravity_Recovery_and_Climate_Experiment"
    },
    "static_fire_date_utc": "2018-05-18T20:16:00.000Z",
    "static_fire_date_unix": 1526674560,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "GFZ arranged a rideshare of GRACE-FO on a Falcon 9 with Iridium following the cancellation of their Dnepr launch contract in 2015. Iridium CEO Matt Desch disclosed in September 2017 that GRACE-FO would be launched on the sixth Iridium NEXT mission. The booster reuse turnaround was a record 4.5 months between flights.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c7b6c3bb0006eeb224",
      "5eb0e4c8b6c3bb0006eeb225"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 62,
    "name": "Iridium NEXT Mission 6",
    "date_utc": "2018-05-22T19:47:58.000Z",
    "date_unix": 1527018478,
    "date_local": "2018-05-22T12:47:58-08:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a4f35918345e3b2652",
        "flight": 2,
        "gridfins": true,
        "legs": false,
        "reused": true,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d1affd86e000604b367"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/4b/b9/oS8ezl6V_o.png",
        "large": "https://images2.imgbox.com/44/ba/fvMeODet_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/8jv0ed/ses12_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/8o9woj/rspacex_ses12_official_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/8oa3k4/rspacex_ses12_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm2.staticflickr.com/1752/41664024035_14c81a25e3_o.jpg",
          "https://farm2.staticflickr.com/1731/27695627527_d9d5bca0ae_o.jpg",
          "https://farm2.staticflickr.com/1735/27695627327_ed66c7282c_o.jpg",
          "https://farm2.staticflickr.com/1752/27695627417_38ea7d7acf_o.jpg",
          "https://farm2.staticflickr.com/1733/41664023935_e9e8120690_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/ses-12missionpress_kit_6.2.18.pdf",
      "webcast": "https://www.youtube.com/watch?v=2hcM5hqQ45s",
      "youtube_id": "2hcM5hqQ45s",
      "article": "https://spaceflightnow.com/2018/06/04/multi-mission-telecom-craft-launched-by-spacex-for-ses/",
      "wikipedia": "https://en.wikipedia.org/wiki/SES-12"
    },
    "static_fire_date_utc": "2018-05-25T01:48:00.000Z",
    "static_fire_date_unix": 1527212880,
    "net": false,
    "window": 7200,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SES-12, the replacement satellite for NSS-6, was successfully launched and deployed on June 4th, completing SpaceX's eleventh flight of 2018. According to SES Luxembourg, The SES-12 satellite will expand SES’s capabilities to provide direct-to-home (DTH) broadcasting, VSAT, Mobility and High Throughput Satellite (HTS) data connectivity services in the Middle East and the Asia-Pacific region, including rapidly growing markets such as India and Indonesia. [SES-12] will be co-located with SES-8",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c90a"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c8b6c3bb0006eeb226"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 63,
    "name": "SES-12",
    "date_utc": "2018-06-04T04:45:00.000Z",
    "date_unix": 1528087500,
    "date_local": "2018-06-04T00:45:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a4f3591845123b264f",
        "flight": 2,
        "gridfins": false,
        "legs": false,
        "reused": true,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d1bffd86e000604b368"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/11/ec/xng5hAXN_o.png",
        "large": "https://images2.imgbox.com/43/35/0QW7yRsB_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/8pua1m/crs15_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/8ugo3l/rspacex_crs15_official_launch_discussion_updates",
        "media": "https://www.reddit.com/r/spacex/comments/8ujcwo/rspacex_crs15_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm1.staticflickr.com/836/42374725204_dae09db889_o.jpg",
          "https://farm2.staticflickr.com/1781/41281636860_71dca92ab4_o.jpg",
          "https://farm2.staticflickr.com/1829/42374725534_325e676d19_o.jpg",
          "https://farm2.staticflickr.com/1810/42374724974_e50b050403_o.jpg",
          "https://farm1.staticflickr.com/843/41281636620_437528bd1f_o.jpg",
          "https://farm2.staticflickr.com/1790/41281637670_f6a6a2cf6c_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/crs15presskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=ycMagB1s8XM",
      "youtube_id": "ycMagB1s8XM",
      "article": "https://spaceflightnow.com/2018/06/29/spacex-launches-ai-enabled-robot-companion-vegetation-monitor-to-space-station/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-15"
    },
    "static_fire_date_utc": "2018-06-23T21:30:00.000Z",
    "static_fire_date_unix": 1529789400,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Payload included MISSE-FF 2, ECOSTRESS, and a Latching End Effector. The refurbished booster featured a record 2.5 months period turnaround from its original launch of the TESS satellite — the fastest previous was 4.5 months. This was the last commercial flight of a Block 4 booster, which was expended into the Atlantic without landing legs and grid fins.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c912"
    ],
    "capsules": [
      "5e9e2c5cf359183bb73b266e"
    ],
    "payloads": [
      "5eb0e4c8b6c3bb0006eeb227"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 64,
    "name": "CRS-15",
    "date_utc": "2018-06-29T09:42:00.000Z",
    "date_unix": 1530265320,
    "date_local": "2018-06-29T05:42:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f35918863d3b2655",
        "flight": 2,
        "gridfins": false,
        "legs": false,
        "reused": true,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d1cffd86e000604b369"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/12/7c/NiniYxoh_o.png",
        "large": "https://images2.imgbox.com/c5/53/5jklZkPz_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/8w19yg/telstar_19v_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/90p1a6/rspacex_telstar_19v_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/90oxrr/rspacex_telstar_19v_media_thread_videos_images/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm1.staticflickr.com/856/28684550147_49802752b3_o.jpg",
          "https://farm1.staticflickr.com/927/28684552447_956a9744f1_o.jpg",
          "https://farm2.staticflickr.com/1828/29700007298_8ac5891d2c_o.jpg",
          "https://farm1.staticflickr.com/914/29700004918_31ed7b73ef_o.jpg",
          "https://farm1.staticflickr.com/844/29700002748_3047e50a0a_o.jpg",
          "https://farm2.staticflickr.com/1786/29700000688_2514cd3cbb_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/telstar19vantagepresskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=xybp6zLaGx4",
      "youtube_id": "xybp6zLaGx4",
      "article": "https://spaceflightnow.com/2018/07/22/spacex-delivers-for-telesat-with-successful-early-morning-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/Telstar_19V"
    },
    "static_fire_date_utc": "2018-07-18T21:00:00.000Z",
    "static_fire_date_unix": 1531947600,
    "net": false,
    "window": 7200,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SSL-manufactured communications satellite intended to be placed at 63° West over the Americas. At 7,075 kg, it became the heaviest commercial communications satellite ever launched.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c90a",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90d",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c8b6c3bb0006eeb228"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 65,
    "name": "Telstar 19V",
    "date_utc": "2018-07-22T05:50:00.000Z",
    "date_unix": 1532238600,
    "date_local": "2018-07-22T01:50:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f359181eed3b2657",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d1effd86e000604b36a"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": false,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/37/63/NE4EISfK_o.png",
        "large": "https://images2.imgbox.com/90/b5/fS6LMNGd_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/8v4wcm/iridium_next_constellation_mission_7_launch/",
        "launch": "https://www.reddit.com/r/spacex/comments/91i1ru/rspacex_iridium_next_7_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/91gx44/rspacex_iridium_next_constellation_mission_7/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm1.staticflickr.com/934/41868222930_0a850d30dc_o.jpg",
          "https://farm1.staticflickr.com/852/41868222500_2ff5f6e5f9_o.jpg",
          "https://farm1.staticflickr.com/929/28787338307_7c0cfce99a_o.jpg",
          "https://farm1.staticflickr.com/928/28787338507_3be74590d2_o.jpg"
        ]
      },
      "presskit": "http://www.spacex.com/sites/spacex/files/iridium7_press_kit_7_24.pdf",
      "webcast": "https://www.youtube.com/watch?v=vsDknmK30C0",
      "youtube_id": "vsDknmK30C0",
      "article": "https://spaceflightnow.com/2018/07/25/spacexs-second-launch-in-three-days-lofts-10-more-iridium-satellites/",
      "wikipedia": "https://en.wikipedia.org/wiki/Iridium_satellite_constellation#Next-generation_constellation"
    },
    "static_fire_date_utc": "2018-07-20T21:08:00.000Z",
    "static_fire_date_unix": 1532120880,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's fourteenth flight of 2018 and seventh of eight launches in a half-a-billion-dollar contract with Iridium. Will use a Block 5 first stage, to be recovered in the Pacific Ocean. Only one mission will be left for Iridium, with 10 more satellites. First attempt to recover a Fairing with the upgraded net. Fairing recovery was not successful.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ea6ed2e080df4000697c908",
      "5ea6ed30080df4000697c912",
      "5ea6ed30080df4000697c914"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c9b6c3bb0006eeb229"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 66,
    "name": "Iridium NEXT Mission 7",
    "date_utc": "2018-07-25T11:39:26.000Z",
    "date_unix": 1532518766,
    "date_local": "2018-07-25T04:39:26-07:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591809c03b2658",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d1fffd86e000604b36b"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/a7/ec/sbwePzVD_o.png",
        "large": "https://images2.imgbox.com/a8/f5/ZgdsrbqW_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/91gwfg/merah_putih_telkom4_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/9539nr/rspacex_merah_putih_telkom4_official_launch/",
        "media": "https://www.reddit.com/r/spacex/comments/94zr0b/rspacex_merah_putih_media_thread_videos_images/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm2.staticflickr.com/1798/43862495212_8fe1688c4b_o.jpg",
          "https://farm1.staticflickr.com/935/43006330655_f1623a3fa1_o.jpg",
          "https://farm1.staticflickr.com/938/28974313177_d16381ff5f_o.jpg",
          "https://farm2.staticflickr.com/1780/43006334045_fb7b4a8714_o.jpg",
          "https://farm1.staticflickr.com/929/28974335747_ffd87ff274_o.jpg",
          "https://farm1.staticflickr.com/930/30041972208_f735b9690b_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/merahputihpresskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=FjfQNBYv2IY",
      "youtube_id": "FjfQNBYv2IY",
      "article": "https://spaceflightnow.com/2018/08/07/indonesian-communications-satellite-deployed-in-orbit-by-spacex/",
      "wikipedia": "https://en.wikipedia.org/wiki/Telkom_Indonesia"
    },
    "static_fire_date_utc": "2018-08-02T15:53:00.000Z",
    "static_fire_date_unix": 1533225180,
    "net": false,
    "window": 7200,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's fifteenth flight of 2018 launched the Merah Putih (also known as Telkom-4) geostationary communications satellite for Telkom Indonesia. It marked the first reuse of any Block 5 first stage; the booster B1046 had previously launched Bangabandhu-1. The stage was recovered and is expected to become the first Falcon 9 booster to fly three missions.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90d",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c9b6c3bb0006eeb22a"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 67,
    "name": "Merah Putih",
    "date_utc": "2018-08-07T05:18:00.000Z",
    "date_unix": 1533619080,
    "date_local": "2018-08-07T01:18:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f359182b023b2656",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d20ffd86e000604b36c"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/2d/d2/jStsqeLC_o.png",
        "large": "https://images2.imgbox.com/ba/db/3plcm5IB_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/95cte4/telstar_18v_apstar_5c_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/9e7bmq/rspacex_telstar_18v_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/9ebkqw/rspacex_telstar_18v_media_thread_videos_images/",
        "recovery": "https://www.reddit.com/r/spacex/comments/9erxlh/telstar_18_vantage_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm2.staticflickr.com/1878/43690848045_492ef182dd_o.jpg",
          "https://farm2.staticflickr.com/1856/43881229604_6d42e838b6_o.jpg",
          "https://farm2.staticflickr.com/1852/43881223704_93777e34af_o.jpg",
          "https://farm2.staticflickr.com/1841/43881217094_558b7b214e_o.jpg",
          "https://farm2.staticflickr.com/1869/43881193934_423eff8c86_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/telstar18vantagepresskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=Apw3xqwsG1U",
      "youtube_id": "Apw3xqwsG1U",
      "article": "https://spaceflightnow.com/2018/09/10/spacex-telesat-achieve-repeat-success-with-midnight-hour-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/Telstar_18V"
    },
    "static_fire_date_utc": "2018-09-05T07:21:00.000Z",
    "static_fire_date_unix": 1536132060,
    "net": false,
    "window": 14400,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's sixteenth flight of 2018 launched the Telstar 18v GEO communication satellite for Telesat, the second launch for the canadian company in a few months. The first stage was a new Falcon 9 V1.2 Block 5 which was successfully recovered on OCISLY.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90d",
      "5ea6ed2f080df4000697c90b"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c9b6c3bb0006eeb22b"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 68,
    "name": "Telstar 18V",
    "date_utc": "2018-09-10T04:45:00.000Z",
    "date_unix": 1536554700,
    "date_local": "2018-09-10T00:45:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591833b13b2659",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d22ffd86e000604b36d"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/ae/11/H85gskPQ_o.png",
        "large": "https://images2.imgbox.com/66/d2/oVB1ofaZ_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/9fwj9o/saocom_1a_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/9lazvr/rspacex_saocom_1a_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/9m3ly5/rspacex_saocom_1a_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm2.staticflickr.com/1940/44262177535_9582184d3f_o.jpg",
          "https://farm2.staticflickr.com/1917/30234800687_fd94fde151_o.jpg",
          "https://farm2.staticflickr.com/1951/30234801997_b5a65426ca_o.jpg",
          "https://farm2.staticflickr.com/1910/44262169525_e4c6b27299_o.jpg",
          "https://farm2.staticflickr.com/1923/44451125454_8d26929d0b_o.jpg",
          "https://farm2.staticflickr.com/1914/44262170545_22fe55d4bb_o.jpg",
          "https://farm2.staticflickr.com/1934/44262166295_3f84597f09_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/saocom1apresskit.pdf",
      "webcast": "https://www.youtube.com/watch?v=vr_C6LQ7mHc",
      "youtube_id": "vr_C6LQ7mHc",
      "article": "https://spaceflightnow.com/2018/10/08/spacex-aces-first-rocket-landing-in-california-after-launching-argentine-satellite/",
      "wikipedia": "https://en.wikipedia.org/wiki/SAOCOM"
    },
    "static_fire_date_utc": "2018-10-02T21:00:00.000Z",
    "static_fire_date_unix": 1538514000,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's seventeenth flight of 2018 was the first launch of the Saocom Earth observation satellite constellation of the Argentine Space Agency CONAE. The second launch of Saocom 1B will happen in 2019. This flight marked the first RTLS launch out of Vandenberg, with a landing on the concrete pad at SLC-4W, very close to the launch pad.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4c9b6c3bb0006eeb22c"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 69,
    "name": "SAOCOM 1A",
    "date_utc": "2018-10-08T02:22:00.000Z",
    "date_unix": 1538965320,
    "date_local": "2018-10-07T19:22:00-07:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591809c03b2658",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb554034e7c9"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d23ffd86e000604b36e"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/a3/96/WvJsBXuE_o.png",
        "large": "https://images2.imgbox.com/59/c8/HPYpMlux_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/9p82jt/eshail_2_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/9x9w9v/rspacex_eshail_2_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/9xaa76/rspacex_eshail_2_media_thread_videos_images_gifs/",
        "recovery": "https://www.reddit.com/r/spacex/comments/9xmpa7/eshail_2_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4834/32040174268_b71d703417_o.jpg",
          "https://farm5.staticflickr.com/4810/32040174058_a65fa64e85_o.jpg",
          "https://farm5.staticflickr.com/4814/32040173268_0ab571e7bc_o.jpg",
          "https://farm5.staticflickr.com/4899/32040173568_bb5c991565_o.jpg",
          "https://farm5.staticflickr.com/4875/32040173278_b5578ba6be_o.jpg",
          "https://farm5.staticflickr.com/4862/32040173928_afdfb09939_o.jpg",
          "https://farm5.staticflickr.com/4888/32040173048_b2b29c020f_o.jpg",
          "https://farm5.staticflickr.com/4808/32248947038_dd1cf9e8c3_o.jpg",
          "https://farm5.staticflickr.com/4887/31180979107_da6a935c20_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/eshail-2_mission_press_kit_11_14_2018.pdf",
      "webcast": "https://www.youtube.com/watch?v=PhTbzc-BqKs&feature=youtu.be",
      "youtube_id": "PhTbzc-BqKs",
      "article": "https://spaceflightnow.com/2018/11/15/spacex-launches-qatars-eshail-2-communications-satellite/",
      "wikipedia": "https://en.wikipedia.org/wiki/Es%27hailSat"
    },
    "static_fire_date_utc": "2018-11-12T18:13:00.000Z",
    "static_fire_date_unix": 1542046380,
    "net": false,
    "window": 6180,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's eighteenth flight of 2018 was its first for Es'hailSat. Es'hail-2 is a communications satellite delivering television and internet to Qatar and the surrounding region. It was launched into a geostationary transfer orbit from LC-39A at Kennedy Space Center. The booster landed on OCISLY.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90d",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c9b6c3bb0006eeb22d"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 70,
    "name": "Es’hail 2",
    "date_utc": "2018-11-15T20:46:00.000Z",
    "date_unix": 1542314760,
    "date_local": "2018-11-15T15:46:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f359181eed3b2657",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d24ffd86e000604b36f"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": false,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/07/ff/s2SD7HuJ_o.png",
        "large": "https://images2.imgbox.com/c3/88/YprVKOBk_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/9raysi/ssoa_launch_campaign_thread",
        "launch": "https://www.reddit.com/r/spacex/comments/a0vjff/rspacex_ssoa_official_launch_discussion_updates/",
        "media": "https://old.reddit.com/r/spacex/comments/a0wylf/rspacex_ssoa_media_thread_videos_images_gifs/",
        "recovery": "https://www.reddit.com/r/spacex/comments/a2tjoe/ssoa_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4875/45257565145_d53757e0b2_o.jpg",
          "https://farm5.staticflickr.com/4839/45257565835_4fd6f3e895_o.jpg",
          "https://farm5.staticflickr.com/4822/45257566865_9c9d34a7ca_o.jpg",
          "https://farm5.staticflickr.com/4821/45257568225_186c8431cf_o.jpg",
          "https://farm5.staticflickr.com/4885/45257569445_1d74a601df_o.jpg",
          "https://farm5.staticflickr.com/4869/45257570925_8eae9a0888_o.jpg",
          "https://farm5.staticflickr.com/4842/31338804427_2e4dcda6e7_o.jpg",
          "https://farm5.staticflickr.com/4894/46227271292_2eee9af3eb_o.jpg",
          "https://farm5.staticflickr.com/4870/44460659210_de634098ac_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/ssoa_press_kit.pdf",
      "webcast": "https://www.youtube.com/watch?v=Wq8kS6UoOrQ",
      "youtube_id": "Wq8kS6UoOrQ",
      "article": "https://spaceflightnow.com/2018/12/03/spacex-launches-swarm-of-satellites-re-flies-rocket-for-third-time/",
      "wikipedia": "https://en.wikipedia.org/wiki/Spaceflight_Industries"
    },
    "static_fire_date_utc": "2018-11-15T21:55:00.000Z",
    "static_fire_date_unix": 1542318900,
    "net": false,
    "window": 1680,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's nineteenth flight of 2018 will fly SSO-A: SmallSat Express out of Vandenberg SLC-4E for Spaceflight. SSO-A is a rideshare to sun synchronus low earth orbit consisting of 64 individual microsatellites and cubesats. It is also likely to be the third flight of core B1046 which previously flew Bangabandhu-1 and Merah Putih. If this happens it will be the first time a Falcon 9 has flown more than two missions. ",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ea6ed30080df4000697c912",
      "5ea6ed30080df4000697c914",
      "5ea6ed2e080df4000697c908"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4c9b6c3bb0006eeb22e"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 71,
    "name": "SSO-A",
    "date_utc": "2018-12-03T18:34:00.000Z",
    "date_unix": 1543861920,
    "date_local": "2018-12-03T10:34:00-08:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f359182b023b2656",
        "flight": 3,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d25ffd86e000604b370"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/de/47/liJzNMRP_o.png",
        "large": "https://images2.imgbox.com/b6/15/tLQrmwcl_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/9z7i4j/crs16_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/a2oubw/rspacex_crs16_official_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/a2uojp/rspacex_crs16_media_thread_videos_images_gifs/",
        "recovery": "https://www.reddit.com/r/spacex/comments/a3n3vm/crs16_emergency_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4835/45473442624_69ee8bee45_o.jpg",
          "https://farm5.staticflickr.com/4903/45473443604_0d668c31da_o.jpg",
          "https://farm5.staticflickr.com/4858/45473444314_413a344dcb_o.jpg",
          "https://farm5.staticflickr.com/4856/45473445134_d9384878f8_o.jpg",
          "https://farm5.staticflickr.com/4840/45473446114_7d5e5d6fe2_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/crs16_press_kit_12_4.pdf",
      "webcast": "https://www.youtube.com/watch?v=Esh1jHT9oTA",
      "youtube_id": "Esh1jHT9oTA",
      "article": "https://spaceflightnow.com/2018/12/05/spacex-falcon-9-boosts-dragon-cargo-ship-to-orbit-first-stage-misses-landing-target/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-16"
    },
    "static_fire_date_utc": "2018-11-30T19:57:00.000Z",
    "static_fire_date_unix": 1543607820,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's 16th Crew Resupply Mission on behalf of NASA, with a total of 20 contracted flights. This will bring essential supplies to the International Space Station using SpaceX's reusable Dragon spacecraft. The Falcon 9 will launch from SLC-40 at Cape Canaveral Air Force Station. During the landing of the first stage, a grid fin hydraulic pump stalled, causing the core to enter an uncontrolled roll, and resulting in a (succesful) water landing.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90b"
    ],
    "capsules": [
      "5e9e2c5cf359185d753b266f"
    ],
    "payloads": [
      "5eb0e4cab6c3bb0006eeb22f"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 72,
    "name": "CRS-16",
    "date_utc": "2018-12-05T18:16:00.000Z",
    "date_unix": 1544033760,
    "date_local": "2018-12-05T13:16:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f359185c603b265a",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d26ffd86e000604b371"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/b3/24/vKUtLIu9_o.png",
        "large": "https://images2.imgbox.com/e1/cb/cvLgCm0d_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/a4516o/gps_iii2_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/a71wyn/rspacex_gps_iii2_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/a73kz5/rspacex_gps_iii2_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4864/45715171884_f1dd88c058_o.jpg",
          "https://farm8.staticflickr.com/7926/45525648155_32fdab17a5_o.jpg",
          "https://farm8.staticflickr.com/7876/45525649035_ba60162fe0_o.jpg",
          "https://farm8.staticflickr.com/7853/45525649825_e6d35415e1_o.jpg",
          "https://farm5.staticflickr.com/4893/45525650685_02b408c385_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/gps_iii_press_kit.pdf",
      "webcast": "https://youtu.be/yRiLPoy_Mzc",
      "youtube_id": "yRiLPoy_Mzc",
      "article": "https://spaceflightnow.com/2018/12/23/spacex-closes-out-year-with-successful-gps-satellite-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/GPS_Block_IIIA"
    },
    "static_fire_date_utc": "2018-12-13T21:24:00.000Z",
    "static_fire_date_unix": 1544736240,
    "net": false,
    "window": 1560,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's twenty-first flight of 2018 launched the first of the new GPS III satellites (Block IIIA) for the United States Air Force and was SpaceX's first EELV mission. The spacecraft was delivered to a MEO transfer orbit from SLC-40 at Cape Canaveral Air Force Station. This mission was the first to fly with the redesigned COPV on the first stage (B1054) as well as the second. The booster was expended.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4cab6c3bb0006eeb230"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 73,
    "name": "GPS III SV01",
    "date_utc": "2018-12-23T13:51:00.000Z",
    "date_unix": 1545573060,
    "date_local": "2018-12-23T08:51:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f35918513b3b265b",
        "flight": 1,
        "gridfins": false,
        "legs": false,
        "reused": false,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d27ffd86e000604b372"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/11/f0/xPDcIpmS_o.png",
        "large": "https://images2.imgbox.com/80/ae/1JL1ZzXD_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/a699fh/iridium_next_constellation_mission_8_launch/",
        "launch": "https://www.reddit.com/r/spacex/comments/aemq2i/rspacex_iridium_next_8_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/aeoxve/rspacex_iridium_next_8_media_thread_videos_images/",
        "recovery": "https://www.reddit.com/r/spacex/comments/aewp4r/iridium_8_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm5.staticflickr.com/4866/39745612523_14270b4b9d_o.jpg",
          "https://farm8.staticflickr.com/7833/39745612923_21aa442350_o.jpg",
          "https://farm5.staticflickr.com/4881/39745613173_e99b09c000_o.jpg",
          "https://farm8.staticflickr.com/7882/39745613513_6cdd4581af_o.jpg",
          "https://farm8.staticflickr.com/7807/39745613733_1a7b70e54a_o.jpg",
          "https://farm5.staticflickr.com/4891/39745614053_43855205bc_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/iridium8presskit.pdf",
      "webcast": "https://youtu.be/VshdafZvwrg",
      "youtube_id": "VshdafZvwrg",
      "article": "https://spaceflightnow.com/2019/01/11/spacex-begins-2019-with-eighth-and-final-for-upgraded-iridium-network/",
      "wikipedia": "https://en.wikipedia.org/wiki/Iridium_satellite_constellation#Next-generation_constellation"
    },
    "static_fire_date_utc": "2019-01-06T13:51:00.000Z",
    "static_fire_date_unix": 1546782660,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's first flight of 2019 will be the eighth and final launch of its planned Iridium flights. Delivering 10 satellites to low earth orbit, this brings the total up to 75 and completes the Iridium NEXT constellation. This mission launches from SLC-4E at Vandenberg AFB. The booster is expected to land on JRTI.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ea6ed30080df4000697c912",
      "5ea6ed30080df4000697c914"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4cab6c3bb0006eeb231"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 74,
    "name": "Iridium NEXT Mission 8",
    "date_utc": "2019-01-11T15:31:00.000Z",
    "date_unix": 1547220660,
    "date_local": "2019-01-11T07:31:00-08:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591833b13b2659",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d28ffd86e000604b373"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/50/65/wAkWv7k7_o.png",
        "large": "https://images2.imgbox.com/1c/8e/rJ4HAYkk_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/afxyrd/nusantara_satu_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/assxjz/rspacex_psnvi_official_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/at5mu8/rspacex_psn6_media_thread_videos_images_gifs/",
        "recovery": "https://www.reddit.com/r/spacex/comments/atbmp3/psnvi_recovery_discussion_updates_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm8.staticflickr.com/7800/47173936271_b8ddb5bc5b_o.jpg",
          "https://farm8.staticflickr.com/7821/47121969172_37428a280e_o.jpg",
          "https://farm8.staticflickr.com/7923/47173936181_c0bf7a22a6_o.jpg",
          "https://farm8.staticflickr.com/7829/46259779115_8982c2c8c2_o.jpg",
          "https://farm8.staticflickr.com/7889/46259778995_68130be69d_o.jpg",
          "https://farm8.staticflickr.com/7895/47130341432_3772641a68_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/nusantara_satu_press_kit.pdf",
      "webcast": "https://www.youtube.com/watch?v=XS0E35aYJcU",
      "youtube_id": "XS0E35aYJcU",
      "article": "https://spaceflightnow.com/2019/02/22/israeli-moon-lander-hitches-ride-on-spacex-launch-with-indonesian-comsat/",
      "wikipedia": "https://en.wikipedia.org/wiki/PT_Pasifik_Satelit_Nusantara"
    },
    "static_fire_date_utc": "2019-02-18T17:03:00.000Z",
    "static_fire_date_unix": 1550509380,
    "net": false,
    "window": 1920,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch this rideshare to GTO for Space Systems Loral (SSL). The primary payload for this mission is Nusantara Satu, a communications satellite built by SSL for the private Indonesian company PT Pasifik Satelit Nusantara (PSN). Spaceflight Industries' GTO-1 mission consists of two secondary payloads. One of those is Beresheet, the lunar lander built by the Israeli non-profit organization, SpaceIL. Beresheet will make its own way to the moon from GTO. The other secondary is Air Force Research Lab's (Space Situational Awareness) S5 mission, which hitches a ride to GEO aboard Nusantara Satu. This mission launches from SLC-40 at Cape Canaveral AFS. The booster is expected to land on OCISLY.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4cab6c3bb0006eeb232",
      "5eb0e4cab6c3bb0006eeb233",
      "5eb0e4cab6c3bb0006eeb234"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 75,
    "name": "Nusantara Satu (PSN-6) / S5 / Beresheet",
    "date_utc": "2019-02-22T01:45:00.000Z",
    "date_unix": 1550799900,
    "date_local": "2019-02-21T20:45:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591809c03b2658",
        "flight": 3,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d2affd86e000604b374"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/be/7e/gOkzvXPe_o.png",
        "large": "https://images2.imgbox.com/e6/a4/YKd36su1_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/a65clm/dm1_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/av1asz/rspacex_cctcap_demo_mission_1_official_launch/",
        "media": "https://www.reddit.com/r/spacex/comments/aw6g7j/rspacex_cctcap_demo_mission_1_media_thread_videos/",
        "recovery": "https://www.reddit.com/r/spacex/comments/awo5lf/cctcap_demo_mission_1_official_booster_recovery/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://farm8.staticflickr.com/7899/39684491043_f0289164bd_o.jpg",
          "https://farm8.staticflickr.com/7804/39684490433_70337aa4e5_o.jpg",
          "https://farm8.staticflickr.com/7826/32774791628_e2234480db_o.jpg",
          "https://farm5.staticflickr.com/4882/39684490143_7df3838d2c_o.jpg",
          "https://farm8.staticflickr.com/7851/46535572784_7eb295968e_o.jpg",
          "https://farm8.staticflickr.com/7826/46535572564_a022f9c43a_o.jpg",
          "https://farm8.staticflickr.com/7889/40294395933_f429c12e83_o.jpg",
          "https://farm8.staticflickr.com/7914/40294395873_0a328f2d87_o.jpg",
          "https://farm8.staticflickr.com/7866/46535572294_22499c1223_o.jpg",
          "https://farm8.staticflickr.com/7850/46535573034_03da10f899_o.jpg",
          "https://farm8.staticflickr.com/7848/46535572664_316c466742_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/crew_demo-1_press_kit.pdf",
      "webcast": "https://youtu.be/2ZL0tbOZYhE",
      "youtube_id": "2ZL0tbOZYhE",
      "article": "https://spaceflightnow.com/2019/03/02/spacex-launches-first-crew-dragon-ferry-ship/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpX-DM1"
    },
    "static_fire_date_utc": "2019-01-24T19:03:00.000Z",
    "static_fire_date_unix": 1548356580,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Demonstration Mission 1 (DM-1) will launch Dragon 2 as part of NASA's Commercial Crew Transportation Capability program. This mission will demonstrate Dragon 2, and Falcon 9 in its configuration for crewed missions. DM-1 will launch from LC-39A at Kennedy Space Center, likely carrying some cargo to the International Space Station. The booster is expected to land on OCISLY.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [
      "5e9e2c5df35918b1063b2671"
    ],
    "payloads": [
      "5eb0e4cbb6c3bb0006eeb235"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 76,
    "name": "CCtCap Demo Mission 1",
    "date_utc": "2019-03-02T07:45:00.000Z",
    "date_unix": 1551512700,
    "date_local": "2019-03-02T02:45:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f35918c0803b265c",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d2bffd86e000604b375"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2f080df4000697c90c"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/ab/ad/YJDi2l1n_o.png",
        "large": "https://images2.imgbox.com/82/e3/RzQ9nX2V_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/b0kscl/arabsat6a_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/basm9y/rspacex_arabsat6a_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/bbhz9a/rspacex_arabsat6a_media_thread_videos_images_gifs/",
        "recovery": "https://www.reddit.com/r/spacex/comments/bcecao/fh_arabsat_6a_center_core_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/7911/32652060737_4be1171d4a_o.jpg",
          "https://live.staticflickr.com/7807/40628442293_9643eaf670_o.jpg",
          "https://live.staticflickr.com/7804/40628440983_4da5d76cc7_o.jpg",
          "https://live.staticflickr.com/7856/40628439793_27927d11de_o.jpg",
          "https://live.staticflickr.com/7919/40628438523_c597eabff1_o.jpg",
          "https://live.staticflickr.com/7834/40628437283_84088aca75_o.jpg",
          "https://live.staticflickr.com/7856/40628435833_a1bcde59db_o.jpg",
          "https://live.staticflickr.com/7809/40628435153_17c05d3b5e_o.jpg",
          "https://live.staticflickr.com/7885/40628434483_3545598b82_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/arabsat-6a_press_kit.pdf",
      "webcast": "https://youtu.be/TXMGu2d8c8g",
      "youtube_id": "TXMGu2d8c8g",
      "article": "https://spaceflightnow.com/2019/04/11/spacexs-falcon-heavy-successful-in-commercial-debut/",
      "wikipedia": "https://en.wikipedia.org/wiki/Arabsat-6A"
    },
    "static_fire_date_utc": "2019-04-05T09:57:00.000Z",
    "static_fire_date_unix": 1554458220,
    "net": false,
    "window": 7020,
    "rocket": "5e9d0d95eda69974db09d1ed",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch Arabsat 6A to a geostationary transfer orbit from SLC-39A, KSC. The satellite is a geostationary telecommunications satellite built by Lockheed Martin for the Saudi Arabian company Arabsat. This will be the first operational flight of Falcon Heavy, and also the first Block 5 Falcon Heavy. All three cores will be new Block 5 cores. The side cores are expected to land at LZ-1 and LZ-2, and the center core is expected to land on OCISLY.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90e",
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2e080df4000697c909",
      "5ea6ed2f080df4000697c90c"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4cbb6c3bb0006eeb236"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 77,
    "name": "ArabSat 6A",
    "date_utc": "2019-04-11T22:35:00.000Z",
    "date_unix": 1555022100,
    "date_local": "2019-04-11T18:35:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f3591897453b265f",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      },
      {
        "core": "5e9e28a6f359183c413b265d",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      },
      {
        "core": "5e9e28a6f359188fd53b265e",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb90a834e7c8"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d2dffd86e000604b376"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/fc/58/9UErD3ut_o.png",
        "large": "https://images2.imgbox.com/12/47/6uim8L1a_o.png"
      },
      "reddit": {
        "campaign": "https://new.reddit.com/r/spacex/comments/bd2l28/crs17_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/bjsn0v/rspacex_crs17_official_launch_discussion_updates",
        "media": "https://www.reddit.com/r/spacex/comments/bkc4d5/rspacex_crs17_media_thread_videos_images_gifs",
        "recovery": "https://www.reddit.com/r/spacex/comments/bjy7p5/rspacex_crs17_recovery_discussion_updates_thread"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/46856594435_206c773b5a_o.jpg",
          "https://live.staticflickr.com/65535/47720639872_284e49381d_o.jpg",
          "https://live.staticflickr.com/65535/46856594755_88f1b22e50_o.jpg",
          "https://live.staticflickr.com/65535/47720639542_1b7c1a71b0_o.jpg",
          "https://live.staticflickr.com/65535/47720639732_e04b2a9ed7_o.jpg",
          "https://live.staticflickr.com/65535/32829382467_087d024428_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/crs-17_press_kit.pdf",
      "webcast": "https://youtu.be/AQFhX5TvP0M",
      "youtube_id": "AQFhX5TvP0M",
      "article": "https://spaceflightnow.com/2019/05/04/spacex-launches-space-station-resupply-mission-lands-rocket-on-drone-ship/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-17"
    },
    "static_fire_date_utc": "2019-04-27T07:23:00.000Z",
    "static_fire_date_unix": 1556349780,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's 17th Commercial Resupply Services mission for NASA out of a total of 20 contracted flights, this mission brings essential supplies to the International Space Station using SpaceX's reusable Dragon 1 spacecraft. The external payloads for this mission include Orbital Carbon Observatory 3 and Space Test Program-Houston 6. The Falcon 9 launches from SLC-40 at Cape Canaveral AFS. The booster was expected to land at LZ-1, however, due to the ongoing investigation and clean-up following the Crew Dragon testing incident, it is likely to land on OCISLY instead.\n ",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90e",
      "5ea6ed2f080df4000697c90b"
    ],
    "capsules": [
      "5e9e2c5cf3591869b63b2670"
    ],
    "payloads": [
      "5eb0e4cbb6c3bb0006eeb237"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 78,
    "name": "CRS-17",
    "date_utc": "2019-05-04T06:48:00.000Z",
    "date_unix": 1556952480,
    "date_local": "2019-05-04T02:48:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591809313b2660",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d2effd86e000604b377"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2f080df4000697c90c"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/7e/27/MGYJy1JY_o.png",
        "large": "https://images2.imgbox.com/75/9d/jIMV5w8x_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/comments/bjybrl",
        "launch": "https://www.reddit.com/r/spacex/comments/brfbic/rspacex_starlink_official_launch_discussion",
        "media": "https://www.reddit.com/r/spacex/comments/bp0479/rspacex_starlink_media_thread_videos_images_gifs",
        "recovery": "https://www.reddit.com/r/spacex/comments/bsaljm/rspacex_starlink_b10493_recovery_discussion_and"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/47926143711_4a0b2680bf_o.jpg",
          "https://live.staticflickr.com/65535/47926136902_d8ce35223d_o.jpg",
          "https://live.staticflickr.com/65535/47926144123_2a828b66d5_o.jpg",
          "https://live.staticflickr.com/65535/47926137127_ef58152b6b_o.jpg",
          "https://live.staticflickr.com/65535/47926137017_e6d86fa820_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/starlink_press_kit.pdf",
      "webcast": "https://www.youtube.com/watch?v=riBaVeDTEWI",
      "youtube_id": "riBaVeDTEWI",
      "article": "https://spaceflightnow.com/2019/05/24/spacexs-first-60-starlink-broadband-satellites-deployed-in-orbit",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink_(satellite_constellation)"
    },
    "static_fire_date_utc": "2019-05-13T20:06:00.000Z",
    "static_fire_date_unix": 1557777960,
    "net": false,
    "window": 9000,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch dozens of Starlink demonstration satellites from SLC-40, Cape Canaveral AFS. Starlink is a low Earth orbit broadband internet constellation developed and owned by SpaceX which will eventually consist of nearly 12 000 satellites and will provide low latency internet service to ground terminals around the world. Two prototype satellites, Microsats 2a and 2b, were launched from Vandenberg AFB in February 2018. The booster for this mission will land on OCISLY.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed2f080df4000697c90e",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2e080df4000697c909"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4cbb6c3bb0006eeb238"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 79,
    "name": "Starlink v0.9",
    "date_utc": "2019-05-24T02:30:00.000Z",
    "date_unix": 1558665000,
    "date_local": "2019-05-23T22:30:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591833b13b2659",
        "flight": 3,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d30ffd86e000604b378"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": false,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/4e/dd/qsIUVh1j_o.png",
        "large": "https://images2.imgbox.com/c3/06/2irK3PGj_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/buq487/radarsat_constellation_launch_campaign_thread",
        "launch": "https://www.reddit.com/r/spacex/comments/byp69f/rspacex_radarsat_constellation_official_launch",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/48052269657_71764b0fb3_o.jpg",
          "https://live.staticflickr.com/65535/48052269617_34447619f0_o.jpg",
          "https://live.staticflickr.com/65535/48052224858_20ea2a411e_o.jpg",
          "https://live.staticflickr.com/65535/48052269562_325c117b81_o.jpg",
          "https://live.staticflickr.com/65535/48052182461_a419db6b84_o.jpg",
          "https://live.staticflickr.com/65535/48052224733_f89f1dd046_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/radarsat_constellation_mission_press_kit.pdf",
      "webcast": "https://youtu.be/8A2nJd9Urk8",
      "youtube_id": "8A2nJd9Urk8",
      "article": "https://spaceflightnow.com/2019/06/12/three-canadian-radar-surveillance-satellites-ride-spacex-rocket-into-orbit/",
      "wikipedia": "https://en.wikipedia.org/wiki/RADARSAT_Constellation"
    },
    "static_fire_date_utc": "2019-06-08T08:39:00.000Z",
    "static_fire_date_unix": 1559983140,
    "net": false,
    "window": 780,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX is launching the three satellite RADARSAT Constellation Mission into Sun Synchronous orbit from SLC-4E, VAFB. The RCM spacecraft are synthetic aperture radar (SAR) Earth observation satellites built by the Canadian space company, MDA, for the Canadian Space Agency. This mission was delayed when the originally slated booster failed to land after CRS-16. The booster is expected to return to LZ-4.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4ccb6c3bb0006eeb239"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 80,
    "name": "RADARSAT Constellation",
    "date_utc": "2019-06-12T14:17:00.000Z",
    "date_unix": 1560349020,
    "date_local": "2019-06-12T07:17:00-07:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f35918c0803b265c",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb554034e7c9"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d31ffd86e000604b379"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/b0/23/BvwaqoS0_o.png",
        "large": "https://images2.imgbox.com/18/17/gCjLjHbl_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/bw6aa8/stp2_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/c40a29/rspacex_stp2_official_launch_discussion_updates",
        "media": "https://www.reddit.com/r/spacex/comments/c4ng3a/rspacex_stp2_media_thread_videos_images_gifs",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/48129211778_83c1769305_o.jpg",
          "https://live.staticflickr.com/65535/48129211908_8390c775b0_o.jpg",
          "https://live.staticflickr.com/65535/48129182836_fd53e5646b_o.jpg",
          "https://live.staticflickr.com/65535/48129269897_22d854be5c_o.jpg",
          "https://live.staticflickr.com/65535/48129182631_572051790c_o.jpg",
          "https://live.staticflickr.com/65535/48129211693_d23b0287f1_o.jpg",
          "https://live.staticflickr.com/65535/48129269942_eb9b5c25bc_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/stp-2_press_kit.pdf",
      "webcast": "https://youtu.be/WxH4CAlhtiQ",
      "youtube_id": "WxH4CAlhtiQ",
      "article": "https://spaceflightnow.com/2019/06/25/falcon-heavy-launches-on-military-led-rideshare-mission-boat-catches-fairing",
      "wikipedia": "https://en.wikipedia.org/wiki/Space_Test_Program"
    },
    "static_fire_date_utc": "2019-06-19T21:52:00.000Z",
    "static_fire_date_unix": 1560981120,
    "net": false,
    "window": 14400,
    "rocket": "5e9d0d95eda69974db09d1ed",
    "success": true,
    "failures": [],
    "details": "Space Test Program 2 is a rideshare managed by the U.S. Air Force Space and Missile Systems Center (SMC), launching from LC-39A, KSC. Most of the spacecraft will be delivered into low Earth orbit (LEO) in two deployment sequences separated by a second stage burn. These LEO payloads include the six Taiwan and United States owned COSMIC-2 microsatellites, the Planetary Society's LightSail-B demonstrator cubesat, and others. The third and final deployment will be the Air Force Research Lab's DSX spacecraft, which will be delivered to a medium Earth orbit (MEO). This mission will reuse the side cores from Arabsat 6A, which will return to LZ-1, and LZ-2. The new center core will boost back to land on OCISLY less than 40 km from the launch site.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2e080df4000697c909",
      "5ea6ed2e080df4000697c908",
      "5ea6ed2f080df4000697c90e"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4ccb6c3bb0006eeb23a",
      "5eb0e4ccb6c3bb0006eeb23b",
      "5eb0e4ccb6c3bb0006eeb23c",
      "5eb0e4ccb6c3bb0006eeb23d",
      "5eb0e4ccb6c3bb0006eeb23e",
      "5eb0e4cdb6c3bb0006eeb23f",
      "5eb0e4cdb6c3bb0006eeb240",
      "5eb0e4cdb6c3bb0006eeb241",
      "5eb0e4cdb6c3bb0006eeb242",
      "5eb0e4cdb6c3bb0006eeb243",
      "5eb0e4cdb6c3bb0006eeb244",
      "5eb0e4cdb6c3bb0006eeb245",
      "5eb0e4ceb6c3bb0006eeb246",
      "5eb0e4ceb6c3bb0006eeb247",
      "5eb0e4ceb6c3bb0006eeb248",
      "5eb0e4ceb6c3bb0006eeb249"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 81,
    "name": "STP-2",
    "date_utc": "2019-06-25T03:30:00.000Z",
    "date_unix": 1561433400,
    "date_local": "2019-06-24T23:30:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591878063b2661",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      },
      {
        "core": "5e9e28a6f359183c413b265d",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      },
      {
        "core": "5e9e28a6f359188fd53b265e",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb90a834e7c8"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d35ffd86e000604b37a"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/89/54/61VCHZwd_o.png",
        "large": "https://images2.imgbox.com/08/a2/bPpNeIRJ_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/c8k6g5/crs18_launch_campaign_thread",
        "launch": "https://www.reddit.com/r/spacex/comments/ch2ml7/rspacex_crs18_official_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/chbr8i/rspacex_crs18_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/48380511527_190682b573_o.jpg",
          "https://live.staticflickr.com/65535/48380370691_7b0757a4d3_o.jpg",
          "https://live.staticflickr.com/65535/48380511492_51db1bf984_o.jpg",
          "https://live.staticflickr.com/65535/48380370626_a5d264c637_o.jpg",
          "https://live.staticflickr.com/65535/48380511427_97db52a9e3_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/crs-18_press_kit.pdf",
      "webcast": "https://youtu.be/SlgrxVuP5jk",
      "youtube_id": "SlgrxVuP5jk",
      "article": "https://spaceflightnow.com/2019/07/25/new-docking-port-spacesuit-and-supplies-en-route-to-space-station/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-18"
    },
    "static_fire_date_utc": "2019-07-19T15:31:00.000Z",
    "static_fire_date_unix": 1563550260,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's 18th Commercial Resupply Services mission out of a total of 20 such contracted flights for NASA, this launch will deliver essential supplies to the International Space Station using the reusable Dragon 1 cargo spacecraft. The external payload for this mission is International Docking Adapter 3, replacing IDA-1 lost in SpaceX's CRS-7 launch failure. This mission will launch from SLC-40 at Cape Canaveral AFS on a Falcon 9, and the first-stage booster is expected to land back at CCAFS LZ-1.",
    "crew": [],
    "ships": [],
    "capsules": [
      "5e9e2c5cf359188bfb3b266b"
    ],
    "payloads": [
      "5eb0e4ceb6c3bb0006eeb24a"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 82,
    "name": "CRS-18",
    "date_utc": "2019-07-25T22:01:00.000Z",
    "date_unix": 1564092060,
    "date_local": "2019-07-25T18:01:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591809313b2660",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d36ffd86e000604b37b"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/f1/4a/WAkSmKfY_o.png",
        "large": "https://images2.imgbox.com/a0/ab/XUoByiuR_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/cjaawx/amos17_launch_campaign_thread",
        "launch": "https://www.reddit.com/r/spacex/comments/cmedgn/rspacex_amos17_official_launch_discussion_updates",
        "media": "https://www.reddit.com/r/spacex/comments/cmppne/rspacex_amos17_media_thread_videos_images_gifs",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/48478269312_58dd3dc446_o.jpg",
          "https://live.staticflickr.com/65535/48478269747_353dcb2e62_o.jpg",
          "https://live.staticflickr.com/65535/48478119901_2de0441026_o.jpg",
          "https://live.staticflickr.com/65535/48478120646_ab72c2c6c3_o.jpg",
          "https://live.staticflickr.com/65535/48478120031_5aae1f6131_o.jpg",
          "https://live.staticflickr.com/65535/48478269442_08479bed36_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/amos-17_mission_press_kit_8_6_2019.pdf",
      "webcast": "https://youtu.be/fZh82-WcCuo",
      "youtube_id": "fZh82-WcCuo",
      "article": "https://spaceflightnow.com/2019/08/07/spacex-launches-israeli-owned-telecom-satellite/",
      "wikipedia": "https://en.wikipedia.org/wiki/Spacecom"
    },
    "static_fire_date_utc": "2019-08-01T00:00:00.000Z",
    "static_fire_date_unix": 1564617600,
    "net": false,
    "window": 5280,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch Boeing built Amos-17, a geostationary communications satellite for Israeli company Spacecom. The satellite will be delivered to GTO from KSC LC-39A or possibly CCAFS SLC-40, and will replace the defunct Amos-5 at 17° E. Amos-17 carries multi-band high throughput and regional beams servicing Africa, Europe and the Middle East. The cost of this launch is covered for Spacecom by SpaceX credit following the Amos-6 incident. A recovery of the booster for this mission is not expected.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908",
      "5ea6ed2e080df4000697c909"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4cfb6c3bb0006eeb24b"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 83,
    "name": "Amos-17",
    "date_utc": "2019-08-06T22:52:00.000Z",
    "date_unix": 1565131920,
    "date_local": "2019-08-06T18:52:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f359181eed3b2657",
        "flight": 3,
        "gridfins": false,
        "legs": false,
        "reused": true,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d37ffd86e000604b37c"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": false,
      "recovered": false,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/dgqcb6/2nd_starlink_mission_launch_campaign_thread",
        "launch": "https://www.reddit.com/r/spacex/comments/du07rt/rspacex_starlink1_official_launch_discussion",
        "media": "https://www.reddit.com/r/spacex/comments/durx53/rspacex_starlink_1_media_thread_videos_images",
        "recovery": "https://www.reddit.com/r/spacex/comments/du1duu/starlink1_booster_and_fairing_recovery_discussion"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/49051988851_0b422e1603_o.jpg",
          "https://live.staticflickr.com/65535/49051988746_1a97e38ca8_o.jpg",
          "https://live.staticflickr.com/65535/49052201452_c3b01e37f0_o.jpg",
          "https://live.staticflickr.com/65535/49051988636_3714a78787_o.jpg",
          "https://live.staticflickr.com/65535/49051477088_d86104481d_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/starlink_press_kit_nov2019.pdf",
      "webcast": "https://youtu.be/pIDuv0Ta0XQ",
      "youtube_id": "pIDuv0Ta0XQ",
      "article": "https://spaceflightnow.com/2019/11/11/successful-launch-continues-deployment-of-spacexs-starlink-network",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink_(satellite_constellation)"
    },
    "static_fire_date_utc": "2019-11-11T12:08:00.000Z",
    "static_fire_date_unix": 1573474080,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the first batch of Starlink version 1.0 satellites, from SLC-40, Cape Canaveral AFS. They are expected to contribute to the 550 km x 53° shell. It is the second Starlink launch overall. Starlink is a low Earth orbit broadband internet constellation developed and owned by SpaceX which will eventually consist of nearly 12 000 satellites and will provide low latency internet service to ground terminals around the world. The booster for this mission is expected to land on OCISLY.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908",
      "5ea6ed30080df4000697c913",
      "5ea6ed2e080df4000697c909",
      "5ea6ed2f080df4000697c90d"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4cfb6c3bb0006eeb24c"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 84,
    "name": "Starlink-1",
    "date_utc": "2019-11-11T14:56:00.000Z",
    "date_unix": 1573484160,
    "date_local": "2019-11-11T09:56:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591809c03b2658",
        "flight": 4,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d39ffd86e000604b37d"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/05/f9/FQWx8g9k_o.png",
        "large": "https://images2.imgbox.com/1f/40/3mc9OSdH_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/e0upb3/crs19_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/e5r8hj/rspacex_crs19_official_launch_discussion_updates",
        "media": "https://www.reddit.com/r/spacex/comments/e6ln0m/rspacex_crs19_media_thread_videos_images_gifs",
        "recovery": "https://www.reddit.com/r/spacex/comments/e6lbzy/rspacex_crs19_booster_recovery_discussion_updates"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/49178460143_e3ae2bd506_o.jpg",
          "https://live.staticflickr.com/65535/49178954221_8544835325_o.jpg",
          "https://live.staticflickr.com/65535/49179161792_9f1801a963_o.jpg",
          "https://live.staticflickr.com/65535/49178460368_62eb945db8_o.jpg",
          "https://live.staticflickr.com/65535/49184948561_ce20b38bc6_o.jpg",
          "https://live.staticflickr.com/65535/49185149122_00a7fa573d_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/crs-19_mission_press_kit.pdf",
      "webcast": "https://youtu.be/-aoAGdYXp_4",
      "youtube_id": "-aoAGdYXp_4",
      "article": "https://spaceflightnow.com/2019/12/05/dragon-soars-on-research-and-resupply-flight-to-international-space-station",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-19"
    },
    "static_fire_date_utc": "2019-11-26T17:04:00.000Z",
    "static_fire_date_unix": 1574787840,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's 19th Crew Resupply Mission on behalf of NASA with a total of 20 contracted flights, this mission brings essential supplies to the International Space Station using SpaceX's reusable Dragon spacecraft. The external payloads for this mission include the Hyperspectral Imager Suite and a lithium-ion battery. Falcon 9 and Dragon will launch from SLC-40, Cape Canaveral AFS. The mission will be complete with return and recovery of the Dragon capsule and down cargo.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90d"
    ],
    "capsules": [
      "5e9e2c5bf3591880643b2669"
    ],
    "payloads": [
      "5eb0e4cfb6c3bb0006eeb24d"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 85,
    "name": "CRS-19",
    "date_utc": "2019-12-05T17:29:23.000Z",
    "date_unix": 1575566963,
    "date_local": "2019-12-05T12:29:23-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f359187afd3b2662",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d39ffd86e000604b37e"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": false,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/3c/e7/PotxLenG_o.png",
        "large": "https://images2.imgbox.com/49/eb/evB1Wi95_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/e5w6i8/jcsat18kacific1_launch_campaign_thread",
        "launch": "https://www.reddit.com/r/spacex/comments/ebfr9t/rspacex_jcsat18kacific1_official_launch",
        "media": "https://www.reddit.com/r/spacex/comments/ebn4g5/rspacex_jcsat18kacific1_media_thread_videos",
        "recovery": "https://www.reddit.com/r/spacex/comments/ec48p3/jscat_18kacific1_recovery_discussion_and_updates"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/49235364922_e55ceb61be_o.jpg",
          "https://live.staticflickr.com/65535/49235136806_e5a3774904_o.jpg",
          "https://live.staticflickr.com/65535/49235137056_585dc050e7_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/jcsat18kacific1_mission_press_kit.pdf",
      "webcast": "https://youtu.be/sbXgZg9JmkI",
      "youtube_id": "sbXgZg9JmkI",
      "article": "https://spaceflightnow.com/2019/12/17/startup-launches-broadband-satellite-on-spacex-rocket-to-connect-pacific-islands",
      "wikipedia": "https://en.wikipedia.org/wiki/JSAT_(satellite_constellation)"
    },
    "static_fire_date_utc": "2019-12-13T12:34:00.000Z",
    "static_fire_date_unix": 1576240440,
    "net": false,
    "window": 5280,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch the Boeing built dual payload satellite to geostationary transfer orbit from XXXX. JCSat 18 is a mobile broadband communications payload built for Sky Perfect JSAT Corporation of Japan and will service Asia Pacific. Kacific 1 is a high throughput broadband internet payload built for Kacific Broadband Satellites and will service certain high demand areas of Southeast Asia and the Pacific. Both payloads share a single chassis. The booster for this mission is expected to land on OCISLY.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908",
      "5ea6ed2e080df4000697c907",
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90d"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4cfb6c3bb0006eeb24e"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 86,
    "name": "JCSat 18 / Kacific 1",
    "date_utc": "2019-12-17T00:10:00.000Z",
    "date_unix": 1576541400,
    "date_local": "2019-12-16T19:10:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591809313b2660",
        "flight": 3,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d3bffd86e000604b37f"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": false,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/efqnvg/starlink2_launch_campaign_thread",
        "launch": "https://www.reddit.com/r/spacex/comments/eko0hr/rspacex_starlink_2_official_launch_discussion",
        "media": "https://www.reddit.com/r/spacex/comments/ekybzb/rspacex_starlink2_media_thread_videos_images_gifs",
        "recovery": "https://www.reddit.com/r/spacex/comments/elgp5k/rspacex_starlink_l2_recovery_discussion_updates"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/49346907238_b27507e4d9_o.jpg",
          "https://live.staticflickr.com/65535/49347368761_f4e45bd38a_o.jpg",
          "https://live.staticflickr.com/65535/49347368406_8f9acf1e2a_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/starlink_press_kit_jan2020.pdf",
      "webcast": "https://youtu.be/HwyXo6T7jC4",
      "youtube_id": "HwyXo6T7jC4",
      "article": "https://spaceflightnow.com/2020/01/07/spacex-launches-more-starlink-satellites-tests-design-change-for-astronomers",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink_(satellite_constellation)"
    },
    "static_fire_date_utc": "2020-01-04T11:45:00.000Z",
    "static_fire_date_unix": 1578138300,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the second batch of Starlink version 1.0 satellites, from SLC-40, Cape Canaveral AFS. They are expected to contribute to the 550 km x 53° shell. It is the third Starlink launch overall. Starlink is a low Earth orbit broadband internet constellation developed and owned by SpaceX which will eventually consist of nearly 12 000 satellites and will provide low latency internet service to ground terminals around the world. The booster for this mission is expected to land on OCISLY.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908",
      "5ea6ed30080df4000697c913",
      "5ea6ed2e080df4000697c909",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90d"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4cfb6c3bb0006eeb24f"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 87,
    "name": "Starlink-2",
    "date_utc": "2020-01-07T02:19:00.000Z",
    "date_unix": 1578363540,
    "date_local": "2020-01-06T21:19:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591833b13b2659",
        "flight": 4,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d3cffd86e000604b380"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/4f/d2/kTjuhrb0_o.png",
        "large": "https://images2.imgbox.com/9d/04/DNXjbXDY_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/ek7eny/in_flight_abort_test_launch_campaign_thread",
        "launch": "https://www.reddit.com/r/spacex/comments/eq24ap/rspacex_inflight_abort_test_official_launch",
        "media": "https://www.reddit.com/r/spacex/comments/eq7pg4/rspacex_inflight_abort_test_media_thread_videos/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/49421605028_b7ba890f0e_o.jpg",
          "https://live.staticflickr.com/65535/49422067976_cda2b8f021_o.jpg",
          "https://live.staticflickr.com/65535/49422067876_13ed519fe6_o.jpg",
          "https://live.staticflickr.com/65535/49421604803_0093a5d2cb_o.jpg",
          "https://live.staticflickr.com/65535/49422294602_0d5e7d8e82_o.jpg",
          "https://live.staticflickr.com/65535/49422068111_2ed613b19b_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/in-flight_abort_test_press_kit.pdf",
      "webcast": "https://youtu.be/mhrkdHshb3E",
      "youtube_id": "mhrkdHshb3E",
      "article": "https://spaceflightnow.com/2020/01/19/spacex-aces-final-major-test-before-first-crew-mission",
      "wikipedia": "https://en.wikipedia.org/wiki/Commercial_Crew_Development"
    },
    "static_fire_date_utc": "2020-01-11T09:42:00.000Z",
    "static_fire_date_unix": 1578735720,
    "net": false,
    "window": 14400,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch a Crew Dragon capsule from LC-39A, KSC on a fully fueled Falcon 9 rocket and then trigger the launch escape system during the period of maximum dynamic pressure. As part of NASA'a Commercial Crew Integrated Capability program (CCiCap) this test will contribute valuable data to help validate Crew Dragon and its launch abort system. The Crew Dragon will be recovered by GO Searcher after splashdown in the Atlantic Ocean. This flight does not go to orbit. The booster and upper stage are expected to break up following capsule separation and there will be no landing attempt.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90c"
    ],
    "capsules": [
      "5e9e2c5df359184c9a3b2672"
    ],
    "payloads": [
      "5eb0e4d0b6c3bb0006eeb250"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 88,
    "name": "Crew Dragon In Flight Abort Test",
    "date_utc": "2020-01-19T14:00:00.000Z",
    "date_unix": 1579442400,
    "date_local": "2020-01-19T09:00:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f359182b023b2656",
        "flight": 4,
        "gridfins": false,
        "legs": false,
        "reused": true,
        "landing_attempt": false,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d3dffd86e000604b381"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/eof5pr/starlink3_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/eudve3/rspacex_starlink_3_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/evjdws/rspacex_starlink3_media_thread_videos_images_gifs/",
        "recovery": "https://www.reddit.com/r/spacex/comments/evnyij/rspacex_starlink3_recovery_discussion_updates/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/49461673512_f4e01c8b27_o.jpg",
          "https://live.staticflickr.com/65535/49461673792_b1804c2a2b_o.jpg",
          "https://live.staticflickr.com/65535/49461673707_cb7fc4a3a8_o.jpg",
          "https://live.staticflickr.com/65535/49461673552_65cc294f82_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/starlink_press_kit_jan272020.pdf",
      "webcast": "https://youtu.be/1KmBDCiL7MU",
      "youtube_id": "1KmBDCiL7MU",
      "article": "https://spaceflightnow.com/2020/01/29/spacex-boosts-60-more-starlink-satellites-into-orbit-after-weather-delays/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_Starlink"
    },
    "static_fire_date_utc": "2020-01-20T13:17:00.000Z",
    "static_fire_date_unix": 1579526220,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the third batch of Starlink version 1.0 satellites, from SLC-40, Cape Canaveral AFS. It is the fourth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude of 550 km. The booster for this mission is expected to land on OCISLY.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908",
      "5ea6ed2e080df4000697c907",
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90d"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4d0b6c3bb0006eeb251"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 89,
    "name": "Starlink-3",
    "date_utc": "2020-01-29T14:06:00.000Z",
    "date_unix": 1580306760,
    "date_local": "2020-01-29T09:06:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f35918c0803b265c",
        "flight": 3,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d3fffd86e000604b382"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": false,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/ex0ilm/starlink4_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/f4d8sg/rspacex_starlink4_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/f56mb4/rspacex_starlink4_media_thread_videos_images_gifs/",
        "recovery": "https://www.reddit.com/r/spacex/comments/f5es7j/rspacex_starlink4_recovery_discussion_updates/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/49549022017_18738a2552_o.jpg",
          "https://live.staticflickr.com/65535/49548795221_edd6dc7ef6_o.jpg",
          "https://live.staticflickr.com/65535/49548795401_93ef80caf5_o.jpg",
          "https://live.staticflickr.com/65535/49549022057_d4dbd6a492_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/fifth_starlink_press_kit.pdf",
      "webcast": "https://youtu.be/8xeX62mLcf8",
      "youtube_id": "8xeX62mLcf8",
      "article": "https://spaceflightnow.com/2020/02/17/spacex-delivers-more-starlink-satellites-to-orbit-booster-misses-drone-ship-landing/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_Starlink"
    },
    "static_fire_date_utc": "2020-02-14T08:31:00.000Z",
    "static_fire_date_unix": 1581669060,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the fourth batch of Starlink version 1.0 satellites, from SLC-40, Cape Canaveral AFS. It is the fifth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude of 550 km. The booster for this mission is expected to land on OCISLY.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908",
      "5ea6ed2e080df4000697c907",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90d"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4d0b6c3bb0006eeb252"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 90,
    "name": "Starlink-4",
    "date_utc": "2020-02-17T15:05:55.000Z",
    "date_unix": 1581951955,
    "date_local": "2020-02-17T10:05:55-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591809313b2660",
        "flight": 4,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d41ffd86e000604b383"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/53/22/dh0XSLXO_o.png",
        "large": "https://images2.imgbox.com/15/2b/NAcsTEB6_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/ezn6n0/crs20_launch_campaign_thread",
        "launch": "https://www.reddit.com/r/spacex/comments/fe8pcj/rspacex_crs20_official_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/fes64p/rspacex_crs20_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/49635401403_96f9c322dc_o.jpg",
          "https://live.staticflickr.com/65535/49636202657_e81210a3ca_o.jpg",
          "https://live.staticflickr.com/65535/49636202572_8831c5a917_o.jpg",
          "https://live.staticflickr.com/65535/49635401423_e0bef3e82f_o.jpg",
          "https://live.staticflickr.com/65535/49635985086_660be7062f_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/crs-20_mission_press_kit.pdf",
      "webcast": "https://youtu.be/1MkcWK2PnsU",
      "youtube_id": "1MkcWK2PnsU",
      "article": "https://spaceflightnow.com/2020/03/07/late-night-launch-of-spacex-cargo-ship-marks-end-of-an-era/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-20"
    },
    "static_fire_date_utc": "2020-03-01T10:20:00.000Z",
    "static_fire_date_unix": 1583058000,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's 20th and final Crew Resupply Mission under the original NASA CRS contract, this mission brings essential supplies to the International Space Station using SpaceX's reusable Dragon spacecraft. It is the last scheduled flight of a Dragon 1 capsule. (CRS-21 and up under the new Commercial Resupply Services 2 contract will use Dragon 2.) The external payload for this mission is the Bartolomeo ISS external payload hosting platform. Falcon 9 and Dragon will launch from SLC-40, Cape Canaveral Air Force Station and the booster will land at LZ-1. The mission will be complete with return and recovery of the Dragon capsule and down cargo.",
    "crew": [],
    "ships": [],
    "capsules": [
      "5e9e2c5cf359185d753b266f"
    ],
    "payloads": [
      "5eb0e4d0b6c3bb0006eeb253"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 91,
    "name": "CRS-20",
    "date_utc": "2020-03-07T04:50:31.000Z",
    "date_unix": 1583556631,
    "date_local": "2020-03-06T23:50:31-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f359187afd3b2662",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d42ffd86e000604b384"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": false,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/f8awv0/starlink5_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/fhymy3/rspacex_starlink_5_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/fizrn1/rspacex_starlink5_media_thread_videos_images_gifs/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/49673373182_93a517e140_o.jpg",
          "https://live.staticflickr.com/65535/49672551378_fabc17ef6f_o.jpg",
          "https://live.staticflickr.com/65535/49672551303_564ce21658_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/sixth_starlink_press_kit.pdf",
      "webcast": "https://youtu.be/I4sMhHbHYXM",
      "youtube_id": "I4sMhHbHYXM",
      "article": "https://spaceflightnow.com/2020/03/18/falcon-9-rocket-overcomes-engine-failure-to-deploy-starlink-satellites/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2020-03-13T18:37:00.000Z",
    "static_fire_date_unix": 1584124620,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "The sixth Starlink launch overall and the fifth operational batch of Starlink satellites will launch into orbit aboard a Falcon 9 rocket. This mission is expected to deploy all sixty satellites into an elliptical orbit about fifteen minutes into flight. In the weeks following launch the satellites are expected to utilize their onboard ion thrusters to raise their orbits to 550 km in three groups of 20, making use of precession rates to separate themselves into three planes. The booster will land on a drone ship approximately 628 km downrange.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90d"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4d0b6c3bb0006eeb254"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 92,
    "name": "Starlink-5",
    "date_utc": "2020-03-18T12:16:00.000Z",
    "date_unix": 1584533760,
    "date_local": "2020-03-18T08:16:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591809c03b2658",
        "flight": 5,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d43ffd86e000604b385"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": false,
      "recovered": null,
      "ships": [
        "5ea6ed2e080df4000697c908",
        "5ea6ed2f080df4000697c90d"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/fxkc7k/starlink6_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/g5jmx0/rspacex_starlink_6_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/g5fqka/rspacex_starlink6_media_thread_photographer/",
        "recovery": "https://www.reddit.com/r/spacex/comments/g6kztd/rspacex_starlink_v1_l6_recovery_discussion/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/49673373182_93a517e140_o.jpg",
          "https://live.staticflickr.com/65535/49672551378_fabc17ef6f_o.jpg",
          "https://live.staticflickr.com/65535/49672551303_564ce21658_o.jpg",
          "https://live.staticflickr.com/65535/49806771628_fef13c852d_o.jpg",
          "https://live.staticflickr.com/65535/49807633862_e5abcb41a6_o.jpg"
        ]
      },
      "presskit": "https://www.spacex.com/sites/spacex/files/seventh_starlink_mission_overview.pdf",
      "webcast": "https://youtu.be/wSge0I7pwFI",
      "youtube_id": "wSge0I7pwFI",
      "article": "https://spaceflightnow.com/2020/04/22/spacexs-starlink-network-surpasses-400-satellite-mark-after-successful-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2020-04-17T11:48:00.000Z",
    "static_fire_date_unix": 1587687810,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the sixth batch of operational Starlink satellites, which are expected to be version 1.0, from SLC-40, Cape Canaveral AFS. It is the seventh Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude of 550 km. The booster for this mission is expected to land on OCISLY.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ea6ed2e080df4000697c908",
      "5ea6ed2e080df4000697c907",
      "5ee68c683c228f36bd5809b5"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4d1b6c3bb0006eeb255"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 93,
    "name": "Starlink-6",
    "date_utc": "2020-04-22T19:30:00.000Z",
    "date_unix": 1587583800,
    "date_local": "2020-04-22T15:30:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f35918c0803b265c",
        "flight": 4,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d44ffd86e000604b386"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/eb/0f/Vev7xkUX_o.png",
        "large": "https://images2.imgbox.com/ab/79/Wyc9K7fv_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/fjf6rr/dm2_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/glwz6n/rspacex_cctcap_demonstration_mission_2_general",
        "media": "https://www.reddit.com/r/spacex/comments/gp1gf5/rspacex_dm2_media_thread_photographer_contest/",
        "recovery": "https://www.reddit.com/r/spacex/comments/gu5gkd/cctcap_demonstration_mission_2_stage_1_recovery/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/49927519643_b43c6d4c44_o.jpg",
          "https://live.staticflickr.com/65535/49927519588_8a39a3994f_o.jpg",
          "https://live.staticflickr.com/65535/49928343022_6fb33cbd9c_o.jpg",
          "https://live.staticflickr.com/65535/49934168858_cacb00d790_o.jpg",
          "https://live.staticflickr.com/65535/49934682271_fd6a31becc_o.jpg",
          "https://live.staticflickr.com/65535/49956109906_f88d815772_o.jpg",
          "https://live.staticflickr.com/65535/49956109706_cffa847208_o.jpg",
          "https://live.staticflickr.com/65535/49956109671_859b323ede_o.jpg",
          "https://live.staticflickr.com/65535/49955609618_4cca01d581_o.jpg",
          "https://live.staticflickr.com/65535/49956396622_975c116b71_o.jpg",
          "https://live.staticflickr.com/65535/49955609378_9b77e5c771_o.jpg",
          "https://live.staticflickr.com/65535/49956396262_ef41c1d9b0_o.jpg"
        ]
      },
      "presskit": "https://www.nasa.gov/sites/default/files/atoms/files/commercialcrew_press_kit.pdf",
      "webcast": "https://youtu.be/xY96v0OIcK4",
      "youtube_id": "xY96v0OIcK4",
      "article": "https://spaceflightnow.com/2020/05/30/nasa-astronauts-launch-from-us-soil-for-first-time-in-nine-years/",
      "wikipedia": "https://en.wikipedia.org/wiki/Crew_Dragon_Demo-2"
    },
    "static_fire_date_utc": "2020-05-22T17:39:00.000Z",
    "static_fire_date_unix": 1590169140,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch the second demonstration mission of its Crew Dragon vehicle as part of NASA's Commercial Crew Transportation Capability Program (CCtCap), carrying two NASA astronauts to the International Space Station. Barring unexpected developments, this mission will be the first crewed flight to launch from the United States since the end of the Space Shuttle program in 2011. DM-2 demonstrates the Falcon 9 and Crew Dragon's ability to safely transport crew to the space station and back to Earth and it is the last major milestone for certification of Crew Dragon. Initially the mission duration was planned to be no longer than two weeks, however NASA has been considering an extension to as much as six weeks or three months. The astronauts have been undergoing additional training for the possible longer mission.",
    "crew": [
      "5ebf1a6e23a9a60006e03a7a",
      "5ebf1b7323a9a60006e03a7b"
    ],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed2e080df4000697c909",
      "5ea6ed2f080df4000697c90d"
    ],
    "capsules": [
      "5e9e2c5df359188aba3b2676"
    ],
    "payloads": [
      "5eb0e4d1b6c3bb0006eeb257"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 94,
    "name": "CCtCap Demo Mission 2",
    "date_utc": "2020-05-30T19:22:00.000Z",
    "date_unix": 1590866520,
    "date_local": "2020-05-30T15:22:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591817f23b2663",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d46ffd86e000604b388"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": null,
      "ships": [
        "5ea6ed2e080df4000697c908",
        "5ea6ed2e080df4000697c907"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/gamcbr/starlink7_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/gkfe30/rspacex_starlink_7_official_launch_discussion/",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/49971196871_a0462d0084_o.jpg",
          "https://live.staticflickr.com/65535/49970682603_e6333945ee_o.jpg"
        ]
      },
      "presskit": "https://spacextimemachine.com/assets/press_kits/185.pdf",
      "webcast": "https://youtu.be/y4xBFHjkUvw",
      "youtube_id": "y4xBFHjkUvw",
      "article": "https://spaceflightnow.com/2020/06/04/spacex-sets-new-mark-in-rocket-reuse-10-years-after-first-falcon-9-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2020-05-13T11:11:00.000Z",
    "static_fire_date_unix": 1589368260,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the seventh batch of operational Starlink satellites, which are expected to be version 1.0, from SLC-40, Cape Canaveral AFS. It is the eighth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude of 550 km. The booster for this mission is expected to land on JRTI on its first mission since arriving at Port Canaveral.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908",
      "5ea6ed2e080df4000697c907",
      "5ee68c683c228f36bd5809b5"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4d1b6c3bb0006eeb256"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 95,
    "name": "Starlink-7",
    "date_utc": "2020-06-04T01:25:00.000Z",
    "date_unix": 1591233900,
    "date_local": "2020-06-03T21:25:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591833b13b2659",
        "flight": 5,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d45ffd86e000604b387"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": null,
      "ships": [
        "5ea6ed2e080df4000697c908",
        "5ea6ed2e080df4000697c907"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/gwbr4t/starlink8_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/h7gqlc/rspacex_starlink_8_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/h842qk/rspacex_starlink8_media_thread_photographer/",
        "recovery": "https://www.reddit.com/r/spacex/comments/h8sx6q/starlink8_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50009748327_93e52a451f_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/8riKQXChPGg",
      "youtube_id": "8riKQXChPGg",
      "article": "https://spaceflightnow.com/2020/06/13/starlink-satellite-deployments-continue-with-successful-falcon-9-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the eighth batch of operational Starlink satellites, which are expected to be version 1.0, from SLC-40, Cape Canaveral AFS. It is the ninth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude of 550 km. This mission is includes rideshare payloads, SkySats 16-18, on top of the Starlink stack. The booster for this mission is expected to land an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908",
      "5ea6ed2e080df4000697c907",
      "5ea6ed2f080df4000697c90b"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4d1b6c3bb0006eeb258"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 96,
    "name": "Starlink-8 & SkySat 16-18",
    "date_utc": "2020-06-13T09:21:00.000Z",
    "date_unix": 1592040060,
    "date_local": "2020-06-13T05:21:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f359187afd3b2662",
        "flight": 3,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d46ffd86e000604b389"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": true,
      "recovered": true,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/yBTgcQH.png",
        "large": "https://imgur.com/vwfiNU7.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/gzeshn/gps_iii_sv03_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/hi5hit/rspacex_gps_iii_sv03_columbus_official_launch/",
        "media": "https://www.reddit.com/r/spacex/comments/hiq0vd/rspacex_gps_iii_sv03_media_thread_photographer/",
        "recovery": "https://www.reddit.com/r/spacex/comments/hjendd/gps_iii_svo3_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50065947228_804efe6117_o.jpg",
          "https://live.staticflickr.com/65535/50065947263_e1a6ea1e22_o.jpg",
          "https://live.staticflickr.com/65535/50065947218_88ef29951a_o.jpg",
          "https://live.staticflickr.com/65535/50066762457_8c92090037_o.jpg",
          "https://live.staticflickr.com/65535/50085443052_9f6b843a02_o.jpg",
          "https://live.staticflickr.com/65535/50085211776_588bed76f0_o.jpg",
          "https://live.staticflickr.com/65535/50084627433_89d8915596_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/6zr0nfG3Xy4",
      "youtube_id": "6zr0nfG3Xy4",
      "article": "https://spaceflightnow.com/2020/06/30/spacex-launches-its-first-mission-for-u-s-space-force/",
      "wikipedia": "https://en.wikipedia.org/wiki/GPS_Block_III"
    },
    "static_fire_date_utc": "2020-06-25T09:48:00.000Z",
    "static_fire_date_unix": 1593078480,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch GPS Block III Space Vehicle 03 from SLC-40, Cape Canaveral AFS aboard a Falcon 9. GPS III is owned and operated by the US Air Force and produced by Lockheed Martin. This is the third GPS III satellite and the second launched by SpaceX. The satellite will be delivered into a MEO transfer orbit. The booster for this mission is expected to land on an ASDS.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5eb0e4d2b6c3bb0006eeb25c"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 97,
    "name": "GPS III SV03 (Columbus)",
    "date_utc": "2020-06-30T19:55:00.000Z",
    "date_unix": 1593546900,
    "date_local": "2020-06-30T15:55:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5ef670f10059c33cee4a826c",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d4affd86e000604b38b"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c908",
        "5ea6ed2e080df4000697c907"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/e7/01/lB9VKSwG_o.png",
        "large": "https://images2.imgbox.com/ad/77/CDzoMWTH_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/hkbhqo/anasisii_launch_campaign_thread",
        "launch": "https://www.reddit.com/r/spacex/comments/hu6sci/rspacex_anasisii_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/hun4pv/rspacex_anasisii_media_thread_photographer_contest/",
        "recovery": "https://www.reddit.com/r/spacex/comments/hvgjk9/anasisii_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50136967628_eda99b6353_o.jpg",
          "https://live.staticflickr.com/65535/50137510881_4618ba6c84_o.jpg",
          "https://live.staticflickr.com/65535/50136967553_e1ac93fab0_o.jpg",
          "https://live.staticflickr.com/65535/50136967658_9347d7c575_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/TshvZlQ7le8",
      "youtube_id": "TshvZlQ7le8",
      "article": "https://spaceflightnow.com/2020/07/20/spacex-delivers-south-koreas-first-military-satellite-into-on-target-orbit/",
      "wikipedia": null
    },
    "static_fire_date_utc": "2020-07-11T17:58:00.000Z",
    "static_fire_date_unix": 1594490280,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch ANASIS-II, a South Korean geostationary military communication satellite from LC-39A, Kennedy Space Center. It will be South Korea's first dedicated military communications satellite. Falcon 9 will deliver the satellite to a geostationary transfer orbit. The booster is expected to land downrange on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908",
      "5ea6ed2e080df4000697c907",
      "5ea6ed2f080df4000697c90b"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4d2b6c3bb0006eeb25b"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 98,
    "name": "ANASIS-II",
    "date_utc": "2020-07-20T21:30:00.000Z",
    "date_unix": 1595280600,
    "date_local": "2020-07-20T17:30:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591817f23b2663",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d50ffd86e000604b394"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c908",
        "5ea6ed2e080df4000697c907"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/h8mold/starlink9_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/i4ozw3/rspacex_starlink9_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/hg499n/rspacex_starlink9_media_thread_photographer/",
        "recovery": "https://www.reddit.com/r/spacex/comments/i5smhk/starlink_9blacksky_recovery_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50198901143_0bb53a499e_o.jpg",
          "https://live.staticflickr.com/65535/50199448011_35d0e9c8bf_o.jpg",
          "https://live.staticflickr.com/65535/50199715777_eca6f41d25_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/KU6KogxG5BE",
      "youtube_id": "KU6KogxG5BE",
      "article": "https://spaceflightnow.com/2020/08/07/spacex-closes-out-busy-week-with-launch-of-more-starlink-satellites/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2020-06-24T18:18:00.000Z",
    "static_fire_date_unix": 1593022680,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the ninth batch of operational Starlink satellites, which are expected to be version 1.0, from LC-39A, Kennedy Space Center. It is the tenth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude of 550 km. This mission is includes a rideshare of two BlackSky satellites on top of the Starlink stack. The booster for this mission is expected to land an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908",
      "5ea6ed2e080df4000697c907",
      "5ea6ed30080df4000697c913",
      "5ee68c683c228f36bd5809b5"
    ],
    "capsules": [],
    "payloads": [
      "5ed9858b1f30554030d45c3e",
      "5ee522e32f1f3d474c758123"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 99,
    "name": "Starlink-9 (v1.0) & BlackSky Global 5-6",
    "date_utc": "2020-08-07T05:12:00.000Z",
    "date_unix": 1596777120,
    "date_local": "2020-08-07T01:12:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f35918c0803b265c",
        "flight": 5,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5ed9819a1f30554030d45c29"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c908",
        "5ea6ed2e080df4000697c907"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/i63bst/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/ibacxz/rspacex_starlink10_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/ic46fw/starlink10_recovery_updates_discussion_thread/",
        "recovery": "https://www.reddit.com/r/spacex/comments/ic46fw/starlink10_recovery_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50241845831_9a7412e81d_o.jpg",
          "https://live.staticflickr.com/65535/50242057637_ea4f98d517_o.jpg",
          "https://live.staticflickr.com/65535/50242057682_6084977bf7_o.jpg",
          "https://live.staticflickr.com/65535/50242057677_e96fbd46e6_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/jTMJK7wb0rM",
      "youtube_id": "jTMJK7wb0rM",
      "article": "https://spaceflightnow.com/2020/08/18/spacex-adds-more-satellites-to-ever-growing-starlink-network/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2020-08-17T10:00:00.000Z",
    "static_fire_date_unix": 1597658400,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the tenth batch of operational Starlink satellites, which are expected to be version 1.0, from LC-39A, Kennedy Space Center. It is the eleventh Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude of 550 km. This mission is includes rideshare payloads, SkySats 19-21, on top of the Starlink stack. The booster for this mission is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908",
      "5ea6ed2e080df4000697c907",
      "5ee68c683c228f36bd5809b5",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5ed9859f1f30554030d45c3f"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 100,
    "name": "Starlink-10 (v1.0) & SkySat 19-21",
    "date_utc": "2020-08-18T14:31:00.000Z",
    "date_unix": 1597761060,
    "date_local": "2020-08-18T10:31:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591833b13b2659",
        "flight": 6,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5ed981d91f30554030d45c2a"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c907"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/e7/f6/v0zFOhZE_o.png",
        "large": "https://images2.imgbox.com/43/33/36WPntCu_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/ffoz5r/saocom_1b_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/iiwlch/rspacex_saocom_1b_launch_discussion_updates_thread/",
        "media": "https://www.reddit.com/r/spacex/comments/ij8mxf/rspacex_starlink11_saocom_1b_media_thread/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50291453997_aa715950e7_o.jpg",
          "https://live.staticflickr.com/65535/50291306296_85b6ff12a2_o.jpg",
          "https://live.staticflickr.com/65535/50291306061_2f9e350a85_o.jpg",
          "https://live.staticflickr.com/65535/50291306216_4fd44c261e_o.jpg",
          "https://live.staticflickr.com/65535/50291306346_136d3dce7b_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/P-gLOsDjE3E",
      "youtube_id": "P-gLOsDjE3E",
      "article": "https://spaceflightnow.com/2020/08/31/spacex-launches-first-polar-orbit-mission-from-florida-in-decades/",
      "wikipedia": "https://en.wikipedia.org/wiki/SAOCOM"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's Falcon 9 will launch the second of the two satellite SAOCOM 1 satellites into a sun-synchronous polar orbit from SLC-40, Cape Canaveral AFS. SAOCOM 1B is a synthetic aperture radar Earth observation satellite to support disaster management. The SAOCOM spacecraft are operated by CONAE, the Argentinian National Space Activities Commission, and are built by INVAP. This mission is also expected to include rideshare payloads Sequoia, and GNOMES-1. This will be the first polar launch from the Space Coast in 60 years. The launch azimuth will be southward and the booster will land at LZ-1.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c907"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4d1b6c3bb0006eeb259"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 101,
    "name": "SAOCOM 1B, GNOMES-1, Tyvak-0172",
    "date_utc": "2020-08-30T23:18:00.000Z",
    "date_unix": 1598829480,
    "date_local": "2020-08-30T19:18:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f359187afd3b2662",
        "flight": 4,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d47ffd86e000604b38a"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": true,
      "recovered": null,
      "ships": [
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/i63bst/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/iip8h3/rspacex_starlink11_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/ij8mxf/rspacex_starlink11_saocom_1b_media_thread/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://youtu.be/_j4xR7LMCGY",
      "youtube_id": "_j4xR7LMCGY",
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the eleventh batch of operational Starlink satellites, which are expected to be version 1.0, from SLC-40, Cape Canaveral Air Force Station. It is the twelfth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude of 550 km. The booster for this mission is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c908",
      "5ea6ed2f080df4000697c90b",
      "5ee68c683c228f36bd5809b5"
    ],
    "capsules": [],
    "payloads": [
      "5ef6a4600059c33cee4a829e"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 102,
    "name": "Starlink-11 (v1.0)",
    "date_utc": "2020-09-03T12:46:00.000Z",
    "date_unix": 1599137160,
    "date_local": "2020-09-03T08:46:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5ef670f10059c33cee4a826c",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5ef6a1e90059c33cee4a828a"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c907",
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/i63bst/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/iu0vtg/rspacex_starlink12_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/iudifm/rspacex_starlink12_media_thread_photographer/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50428228397_6151927733_o.jpg",
          "https://live.staticflickr.com/65535/50427359318_67b3397892_o.jpg",
          "https://live.staticflickr.com/65535/50428050591_36defbe958_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/UZkaE_9zwQQ",
      "youtube_id": "UZkaE_9zwQQ",
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the twelfth batch of operational Starlink satellites, which are expected to be version 1.0, from SLC-40, Cape Canaveral Air Force Station. It is the thirteenth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude of 550 km. The booster for this mission is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c910",
      "5ea6ed2e080df4000697c907",
      "5ea6ed2e080df4000697c908",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5ef6a48e0059c33cee4a829f"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 103,
    "name": "Starlink-12 (v1.0)",
    "date_utc": "2020-10-06T11:29:00.000Z",
    "date_unix": 1601983740,
    "date_local": "2020-10-06T07:29:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591817f23b2663",
        "flight": 3,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5ef6a2090059c33cee4a828b"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": null,
      "ships": [
        "5ea6ed2e080df4000697c907",
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/i63bst/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/jctqq9/rspacex_starlink13_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/jdgsm2/rspacex_starlink13_media_thread_photographer/",
        "recovery": "https://www.reddit.com/r/spacex/comments/jdgpgl/starlink13_recovery_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50500804918_eb1187e1b2_o.jpg",
          "https://live.staticflickr.com/65535/50501674637_f16f528728_o.jpg",
          "https://live.staticflickr.com/65535/50501515611_2a3753bed1_o.jpg",
          "https://live.staticflickr.com/65535/50501674632_0d5276b1b5_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/UM8CDDAmp98",
      "youtube_id": "UM8CDDAmp98",
      "article": "https://spaceflightnow.com/2020/10/18/spacex-launches-another-batch-of-starlink-satellites/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2020-10-17T05:23:00.000Z",
    "static_fire_date_unix": 1602912180,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the thirteenth batch of operational Starlink satellites, which are expected to be version 1.0, from LC-39A, Kennedy Space Center. It is the fourteenth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude of 550 km. The booster for this mission is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90b",
      "5ee68c683c228f36bd5809b5",
      "5ea6ed2e080df4000697c907",
      "5ea6ed2e080df4000697c908"
    ],
    "capsules": [],
    "payloads": [
      "5ef6a4d50059c33cee4a82a1"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 104,
    "name": "Starlink-13 (v1.0)",
    "date_utc": "2020-10-18T12:25:00.000Z",
    "date_unix": 1603023900,
    "date_local": "2020-10-18T08:25:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f35918c0803b265c",
        "flight": 6,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5ef6a2bf0059c33cee4a828c"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": null,
      "ships": [
        "5ea6ed2e080df4000697c907",
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/i63bst/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/jetth8/rspacex_starlink14_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/jhcwun/rspacex_starlink14_media_thread_photographer/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://youtu.be/2gbVgTxLgN0",
      "youtube_id": "2gbVgTxLgN0",
      "article": "https://spaceflightnow.com/2020/10/24/spacex-adds-another-60-satellites-to-starlink-network/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2020-10-21T12:55:00.000Z",
    "static_fire_date_unix": 1603284900,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the fourteenth batch of operational Starlink satellites, which are expected to be version 1.0, from SLC-40, Kennedy Space Center. It is the fifteenth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude of 550 km. The booster for this mission is expected to land on JRTI.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2e080df4000697c907",
      "5ea6ed2e080df4000697c908"
    ],
    "capsules": [],
    "payloads": [
      "5ef6a4ea0059c33cee4a82a2"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 105,
    "name": "Starlink-14 (v1.0)",
    "date_utc": "2020-10-24T15:31:00.000Z",
    "date_unix": 1603553460,
    "date_local": "2020-10-24T11:31:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5ef670f10059c33cee4a826c",
        "flight": 3,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5ef6a2e70059c33cee4a8293"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": true,
      "recovered": null,
      "ships": [
        "5ea6ed2e080df4000697c907"
      ]
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/ed/27/HV6rc52t_o.png",
        "large": "https://images2.imgbox.com/73/8f/kKV6cyQO_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/io0swm/gps_iii_sv04_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/jobxn2/rspacex_gps_iii_sv04_sacagawea_official_launch/",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50611865511_2299e11860_o.jpg",
          "https://live.staticflickr.com/65535/50611118958_448d239fe1_o.jpg",
          "https://live.staticflickr.com/65535/50611979827_48811d2ea6_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/wufXF5YKR1M",
      "youtube_id": "wufXF5YKR1M",
      "article": "https://spaceflightnow.com/2020/11/06/spacex-launches-gps-navigation-satellite-from-cape-canaveral/",
      "wikipedia": "https://en.wikipedia.org/wiki/GPS_Block_III"
    },
    "static_fire_date_utc": "2020-09-25T05:42:00.000Z",
    "static_fire_date_unix": 1601012520,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch GPS Block III Space Vehicle 04 from SLC-40, Cape Canaveral AFS aboard a Falcon 9. GPS III is owned and operated by the US Air Force and produced by Lockheed Martin. This will be the fourth GPS III satellite launched and the third launched by SpaceX. The satellite will be delivered into a MEO transfer orbit. The booster for this mission will land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ee68c683c228f36bd5809b5",
      "5ea6ed2e080df4000697c907"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4d2b6c3bb0006eeb25e"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 106,
    "name": "GPS III SV04 (Sacagawea)",
    "date_utc": "2020-11-05T23:24:00.000Z",
    "date_unix": 1604618640,
    "date_local": "2020-11-05T18:24:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5f57c5440622a633027900a0",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d4cffd86e000604b38d"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://imgur.com/6RnqgLW.png",
        "large": "https://imgur.com/2XsSLUM.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/iwb8bl/crew1_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/ju7fxv/rspacex_crew1_official_launch_coast_docking/",
        "media": "https://www.reddit.com/r/spacex/comments/judv0r/rspacex_crew1_media_thread_photographer_contest/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50618376646_8f52c31fc4_o.jpg",
          "https://live.staticflickr.com/65535/50618376731_43ddaab1b8_o.jpg",
          "https://live.staticflickr.com/65535/50618376671_ba4e60af7c_o.jpg",
          "https://live.staticflickr.com/65535/50618376351_ecfdee4ab2_o.jpg",
          "https://live.staticflickr.com/65535/50618727917_01e579c4d9_o.jpg",
          "https://live.staticflickr.com/65535/50618355216_2872d1fe98_o.jpg",
          "https://live.staticflickr.com/65535/50618354801_ff3e722884_o.jpg",
          "https://live.staticflickr.com/65535/50618463487_41642939a4_o.jpg",
          "https://live.staticflickr.com/65535/50617619613_5630422345_o.jpg",
          "https://live.staticflickr.com/65535/50617619668_d680d7319c_o.jpg",
          "https://live.staticflickr.com/65535/50617625523_a7484e0abf_o.jpg",
          "https://live.staticflickr.com/65535/50618469202_fa86f88ab3_o.jpg",
          "https://live.staticflickr.com/65535/50617625183_8554412cee_o.jpg",
          "https://live.staticflickr.com/65535/50618470472_fb8e6507d7_o.jpg",
          "https://live.staticflickr.com/65535/50617626838_c0c71de1f7_o.jpg",
          "https://live.staticflickr.com/65535/50617626738_aa3997aaea_o.jpg",
          "https://live.staticflickr.com/65535/50617626408_fb0bba0f89_o.jpg",
          "https://live.staticflickr.com/65535/51158778650_9b8d555c1e_o.jpg",
          "https://live.staticflickr.com/65535/51158458619_9b74f6a3d0_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/bnChQbxLkkI",
      "youtube_id": "bnChQbxLkkI",
      "article": "https://spaceflightnow.com/2020/11/16/astronauts-ride-spacex-crew-capsule-in-landmark-launch-for-commercial-spaceflight/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_Crew-1"
    },
    "static_fire_date_utc": "2020-11-11T16:17:00.000Z",
    "static_fire_date_unix": 1605111420,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch the first operational mission of its Crew Dragon vehicle as part of NASA's Commercial Crew Transportation Capability Program (CCtCap), carrying 3 NASA astronauts and 1 JAXA astronaut to the International Space Station. This mission will be the second crewed flight to launch from the United States since the end of the Space Shuttle program in 2011.",
    "crew": [
      "5f7f1543bf32c864a529b23e",
      "5f7f158bbf32c864a529b23f",
      "5f7f15d5bf32c864a529b240",
      "5f7f1614bf32c864a529b241"
    ],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ee68c683c228f36bd5809b5",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed2e080df4000697c909",
      "5ea6ed2f080df4000697c90b"
    ],
    "capsules": [
      "5f6f99fddcfdf403df379709"
    ],
    "payloads": [
      "5eb0e4d2b6c3bb0006eeb25f"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 107,
    "name": "Crew-1",
    "date_utc": "2020-11-16T00:27:00.000Z",
    "date_unix": 1605486420,
    "date_local": "2020-11-15T19:27:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5f57c53d0622a6330279009f",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d4dffd86e000604b38e"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://images2.imgbox.com/8d/11/r6FulTZd_o.png",
        "large": "https://images2.imgbox.com/cc/23/YWTPxp4N_o.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jkk93v/sentinel6_michael_freilich_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/jxsche/rspacex_sentinel6_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/jyd67q/rspacex_sentinel6_media_thread_photographer/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50630802488_8cc373728e_o.jpg",
          "https://live.staticflickr.com/65535/50631642722_3af8131c6f_o.jpg",
          "https://live.staticflickr.com/65535/50631544171_66bd43eaa9_o.jpg",
          "https://live.staticflickr.com/65535/50631543966_e8035d5cca_o.jpg",
          "https://live.staticflickr.com/65535/50631643257_c214ceee7b_o.jpg",
          "https://live.staticflickr.com/65535/50631643917_cb7db291d0_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/aVFPzTDCihQ",
      "youtube_id": "aVFPzTDCihQ",
      "article": "https://spaceflightnow.com/2020/11/21/international-satellite-launches-to-extend-measurements-of-sea-level-rise/",
      "wikipedia": "https://en.wikipedia.org/wiki/Copernicus_Sentinel-6"
    },
    "static_fire_date_utc": "2020-11-17T13:17:00.000Z",
    "static_fire_date_unix": 1605619020,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch Sentinel-6 Michael Freilich into low Earth orbit for NASA, NOAA, ESA, and the European Organization for the Exploitation of Meteorological Satellites aboard a Falcon 9 from SLC-4E, Vandenberg Air Force Station. Sentinel-6(A) is an ocean observation satellite providing radar ocean surface altimetry data and also atmospheric temperature profiles as a secondary mission. The booster for this mission is will land at LZ-4.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5ed9867c1f30554030d45c40"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 108,
    "name": "Sentinel-6 Michael Freilich",
    "date_utc": "2020-11-21T17:17:00.000Z",
    "date_unix": 1605979020,
    "date_local": "2020-11-21T09:17:00-08:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5f57c54a0622a633027900a1",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb554034e7c9"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5ed983aa1f30554030d45c31"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": null,
      "ships": [
        "5ea6ed2e080df4000697c907"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/jxyodz/rspacex_starlink15_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/k0mom0/starlink15_media_thread_photographer_contest/",
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50644831893_bb40b60827_o.jpg",
          "https://live.staticflickr.com/65535/50645580736_44af27257f_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/J442-ti-Dhg",
      "youtube_id": "J442-ti-Dhg",
      "article": "https://spaceflightnow.com/2020/11/25/spacex-launches-60-more-starlink-satellites-on-100th-falcon-9-flight/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2020-11-21T16:31:00.000Z",
    "static_fire_date_unix": 1605976260,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission will launch the fifteenth batch of operational Starlink satellites, which are version 1.0, from SLC-40, Cape Canaveral Air Force Station. It will be the sixteenth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude of 550 km. The booster for this mission is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90d",
      "5ea6ed2e080df4000697c907"
    ],
    "capsules": [],
    "payloads": [
      "5fb95c263a88ae63c9546044"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 109,
    "name": "Starlink-15 (v1.0)",
    "date_utc": "2020-11-25T02:13:00.000Z",
    "date_unix": 1606270380,
    "date_local": "2020-11-24T21:13:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591833b13b2659",
        "flight": 7,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5fb95b3f3a88ae63c954603c"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://imgur.com/5Oz6Hnq.png",
        "large": "https://imgur.com/uTeUcbN.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jw8bfe/crs21_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/k6my16/rspacex_crs21_official_launch_discussion_updates/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50689254612_db8bc87d2c_o.jpg",
          "https://live.staticflickr.com/65535/50689254712_98ef758c81_o.jpg",
          "https://live.staticflickr.com/65535/50689254512_bb44826694_o.jpg",
          "https://live.staticflickr.com/65535/50689254642_ba6b08d142_o.jpg",
          "https://live.staticflickr.com/65535/50689254552_1d9f91a963_o.jpg"
        ]
      },
      "presskit": "https://www.nasa.gov/sites/default/files/atoms/files/spacex_crs-21_mision_overview_high_res.pdf",
      "webcast": "https://youtu.be/4xJAGFR_N-c",
      "youtube_id": "4xJAGFR_N-c",
      "article": "https://spaceflightnow.com/2020/12/06/spacex-launches-first-in-new-line-of-upgraded-space-station-cargo-ships/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-21"
    },
    "static_fire_date_utc": "2020-12-03T13:45:00.000Z",
    "static_fire_date_unix": 1607003100,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's 21st ISS resupply mission on behalf of NASA and the first under the CRS-2 contract, this mission brings essential supplies to the International Space Station using the cargo variant of SpaceX's Dragon 2 spacecraft. The external payload for this mission is the Nanoracks Bishop Airlock. Falcon 9 and Dragon launch from LC-39A, Kennedy Space Center and the booster is expected to land on an ASDS. The mission will be complete with return and recovery of the Dragon capsule and down cargo.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2f080df4000697c90d"
    ],
    "capsules": [
      "5fbb0f8fec55b34eb9f35c14"
    ],
    "payloads": [
      "5eb0e4d3b6c3bb0006eeb262"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 110,
    "name": "CRS-21",
    "date_utc": "2020-12-06T16:17:00.000Z",
    "date_unix": 1607271420,
    "date_local": "2020-12-06T11:17:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591817f23b2663",
        "flight": 4,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d4effd86e000604b391"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://i.imgur.com/UaMwIqw.png",
        "large": "https://i.imgur.com/qGOxE3r.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/k51p7b/sxm7_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/kaizok/rspacex_sxm7_official_launch_discussion_updates/",
        "media": "https://www.reddit.com/r/spacex/comments/kcev8p/sxm7_media_thread_photographer_contest/",
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50715254423_3cb2a8ff9c_o.jpg",
          "https://live.staticflickr.com/65535/50715992426_bf43a8f872_o.jpg",
          "https://live.staticflickr.com/65535/50716071077_5a5bc00af9_o.jpg",
          "https://live.staticflickr.com/65535/50716071167_100d6f7092_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/COraGXFb1lo",
      "youtube_id": "COraGXFb1lo",
      "article": "https://spaceflightnow.com/2020/12/13/siriusxm-satellite-rides-spacex-rocket-into-orbit/",
      "wikipedia": "https://en.wikipedia.org/wiki/Sirius_XM#Satellites"
    },
    "static_fire_date_utc": "2020-12-07T23:00:00.000Z",
    "static_fire_date_unix": 1607382000,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch the first of two next generation high power S-band broadcast satellites for SiriusXM. The spacecraft will be delivered into a geostationary transfer orbit and the booster will be recovered downrange. The spacecraft is built by Space Systems Loral (SSL) on the SSL 1300 platform and includes two solar arrays producing 20kW, and an unfurlable antenna dish. SXM-7 will replace XM-3 in geostationary orbit.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ee68c683c228f36bd5809b5",
      "5ea6ed2f080df4000697c90c"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4d2b6c3bb0006eeb25d"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 111,
    "name": "SXM-7",
    "date_utc": "2020-12-13T17:30:00.000Z",
    "date_unix": 1607880600,
    "date_local": "2020-12-13T12:30:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f35918c0803b265c",
        "flight": 7,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d4bffd86e000604b38c"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c908",
        "5ea6ed2f080df4000697c90c"
      ]
    },
    "links": {
      "patch": {
        "small": "https://i.imgur.com/t9j2kJg.png",
        "large": "https://i.imgur.com/lSpAmBB.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/j7qqbg/nrol108_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/ke9pmg/rspacex_nrol108_official_launch_discussion/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50740257483_0f550f6a25_o.jpg",
          "https://live.staticflickr.com/65535/50740993291_57ef3f881b_o.jpg",
          "https://live.staticflickr.com/65535/50740257263_b41b843e85_o.jpg",
          "https://live.staticflickr.com/65535/50740993211_dc00af6dbb_o.jpg",
          "https://live.staticflickr.com/65535/50740257078_e46a6462df_o.jpg",
          "https://live.staticflickr.com/65535/50741096702_2a152bdf13_o.jpg",
          "https://live.staticflickr.com/65535/50740257323_e3e49fa2c6_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/9OeVwaFBkfE",
      "youtube_id": "9OeVwaFBkfE",
      "article": "https://spaceflightnow.com/2020/12/19/spacex-closes-out-record-year-of-launches-from-floridas-space-coast/",
      "wikipedia": "https://en.wikipedia.org/wiki/National_Reconnaissance_Office"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch NROL-108 for the National Reconnaissance Office aboard a Falcon 9 from SLC-40, Cape Canaveral Air Force Station. The booster for this mission is expected to land at LZ-1.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90c",
      "5ea6ed2e080df4000697c908"
    ],
    "capsules": [],
    "payloads": [
      "5f839ac7818d8b59f5740d48"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 112,
    "name": "NROL-108",
    "date_utc": "2020-12-19T14:00:00.000Z",
    "date_unix": 1608386400,
    "date_local": "2020-12-19T09:00:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f359187afd3b2662",
        "flight": 5,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5f8399fb818d8b59f5740d43"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": null,
      "ships": [
        "5ea6ed2e080df4000697c907",
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/xdKmm6T.png",
        "large": "https://imgur.com/cqGBC29.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/kawyb4/t%C3%BCrksat_5a_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/ksagr9/rspacex_t%C3%BCrksat_5a_official_launch_discussion/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50814482042_476d87b020_o.jpg",
          "https://live.staticflickr.com/65535/50813630408_d98c2215f8_o.jpg",
          "https://live.staticflickr.com/65535/50814379121_8834b5362d_o.jpg",
          "https://live.staticflickr.com/65535/50814379056_f032a23955_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/9I0UYXVqIn8",
      "youtube_id": "9I0UYXVqIn8",
      "article": "https://spaceflightnow.com/2021/01/08/spacex-deploys-turkish-satellite-in-first-launch-of-2021/",
      "wikipedia": "https://en.wikipedia.org/wiki/T%C3%BCrksat_5A"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": 17820,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch the first of two next generation satellites on contract for Türksat. Türksat 5A is a Ku-band broadcast satellite built by Airbus Defense and Space and based on the Electric Orbit Raising version of the Eurostar E3000 platform. This spacecraft will be delivered into a transfer orbit and will then raise itself to its operational 31° East geostationary orbit to serve Turkey, the Middle East, Europe, North Africa and South Africa. The booster for this mission will be recovered downrange via ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90d",
      "5ea6ed2f080df4000697c910",
      "5ea6ed2e080df4000697c907",
      "5ea6ed2e080df4000697c908"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4d3b6c3bb0006eeb264"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 113,
    "name": "Turksat 5A",
    "date_utc": "2021-01-08T02:15:00.000Z",
    "date_unix": 1610072100,
    "date_local": "2021-01-07T21:15:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5ef670f10059c33cee4a826c",
        "flight": 4,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5eb87d4fffd86e000604b393"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": null,
      "ships": [
        "5ea6ed2e080df4000697c907",
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/kz969o/rspacex_starlink16_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/l1b5q8/starlink16_media_thread_photographer_contest/",
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50855737853_4d290519b4_o.jpg",
          "https://live.staticflickr.com/65535/50856457401_5fd05cddd1_o.jpg",
          "https://live.staticflickr.com/65535/50855737933_bcc65bdf8b_o.jpg",
          "https://live.staticflickr.com/65535/50856551642_5190c59ec1_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/84Nct_Q9Lqw",
      "youtube_id": "84Nct_Q9Lqw",
      "article": "https://spaceflightnow.com/2021/01/20/spacex-sets-new-rocket-reuse-records-with-successful-starlink-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the sixteenth batch of operational Starlink satellites, which are version 1.0, from SLC-40 or LC-39A. It is the seventeenth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c907",
      "5ea6ed2e080df4000697c908",
      "5ea6ed2f080df4000697c910",
      "5ea6ed2f080df4000697c90d",
      "5ea6ed2f080df4000697c90b"
    ],
    "capsules": [],
    "payloads": [
      "5fbfedba54ceb10a5664c813"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 114,
    "name": "Starlink-16 (v1.0)",
    "date_utc": "2021-01-20T13:02:00.000Z",
    "date_unix": 1611147720,
    "date_local": "2021-01-20T08:02:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f35918c0803b265c",
        "flight": 8,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5fbfecce54ceb10a5664c80a"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c908",
        "5ea6ed2e080df4000697c907"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/IJWn9pK.png",
        "large": "https://imgur.com/u49XVx4.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/kt5gds/transporter1_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/l210i3/rspacex_transporter1_official_launch_discussion/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50870343533_e815eb30c4_o.jpg",
          "https://live.staticflickr.com/65535/50871151292_af114a3f9e_o.jpg",
          "https://live.staticflickr.com/65535/50871053741_59a1dbb6cc_o.jpg",
          "https://live.staticflickr.com/65535/50871053696_cd01a7e092_o.jpg",
          "https://live.staticflickr.com/65535/50870343763_1b1ac55eae_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/ScHI1cbkUv4",
      "youtube_id": "ScHI1cbkUv4",
      "article": "https://spaceflightnow.com/2021/01/24/spacex-launches-record-setting-rideshare-mission-with-143-small-satellites/",
      "wikipedia": null
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": 2520,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX will launch a dedicated rideshare mission from SLC-40 or LC-39A. The spacecraft will be delivered into a sun-synchronous orbit. The booster for this mission is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed2e080df4000697c908",
      "5ea6ed2e080df4000697c907"
    ],
    "capsules": [],
    "payloads": [
      "5fd3871a7faea57d297c86c6"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 115,
    "name": "Transporter-1",
    "date_utc": "2021-01-24T15:00:00.000Z",
    "date_unix": 1611500400,
    "date_local": "2021-01-24T10:00:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591817f23b2663",
        "flight": 5,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5fd386aa7faea57d297c86c1"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": null,
      "ships": [
        "5ea6ed2e080df4000697c908",
        "5ea6ed2e080df4000697c907"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/lbjuok/rspacex_starlink18_official_launch_discussion/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50908787351_5733229c09_o.jpg",
          "https://live.staticflickr.com/65535/50908092893_d254477be0_o.jpg",
          "https://live.staticflickr.com/65535/50908092833_4cb5833fb9_o.jpg",
          "https://live.staticflickr.com/65535/50908787221_9cf383a2b4_o.jpg",
          "https://live.staticflickr.com/65535/50908787166_8dde2e29bd_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/fe6HBw1y6bA",
      "youtube_id": "fe6HBw1y6bA",
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the eighteenth batch of operational Starlink satellites, which are version 1.0, from SLC-40. It is the nineteenth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "601742b20c87b90be7bb7e86",
      "5ea6ed2e080df4000697c908",
      "5ea6ed2e080df4000697c907",
      "5ea6ed2f080df4000697c90b"
    ],
    "capsules": [],
    "payloads": [
      "5ff655769257f579ee3a6c64"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 116,
    "name": "Starlink-18 (v1.0)",
    "date_utc": "2021-02-04T06:19:00.000Z",
    "date_unix": 1612419540,
    "date_local": "2021-02-04T01:19:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5ef670f10059c33cee4a826c",
        "flight": 5,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "f31702e8-6353-4c9a-932c-5bd104717500",
    "id": "5ff6554f9257f579ee3a6c5f"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c908",
        "5ea6ed2e080df4000697c907"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/ljkh7l/rspacex_starlink19_official_launch_discussion/",
        "media": "https://www.reddit.com/r/spacex/comments/lkwllg/starlink19_media_thread_photographer_contest/",
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/50949943433_87e3002307_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/L0dkyV09Zso",
      "youtube_id": "L0dkyV09Zso",
      "article": "https://spaceflightnow.com/2021/02/16/spacex-successfully-deploys-60-more-starlink-satellites-but-loses-booster-on-descent/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2021-02-13T18:17:00.000Z",
    "static_fire_date_unix": 1613240220,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the eighteenth batch of operational Starlink satellites, which are version 1.0, from SLC-40. It is the nineteenth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "600f9bc08f798e2a4d5f97a4"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 117,
    "name": "Starlink-19 (v1.0)",
    "date_utc": "2021-02-16T03:59:00.000Z",
    "date_unix": 1613447940,
    "date_local": "2021-02-15T22:59:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f359187afd3b2662",
        "flight": 6,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": false,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "985f1cc1-82c1-4a89-b2cc-e9dc91829a0e",
    "id": "600f9a5e8f798e2a4d5f979c"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/l8qsz3/rspacex_starlink17_official_launch_discussion/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51004598206_9779f08338_o.jpg",
          "https://live.staticflickr.com/65535/51004598196_b2059799f4_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/d5DzoKuhdNk",
      "youtube_id": "d5DzoKuhdNk",
      "article": "https://spaceflightnow.com/2021/03/04/spacex-sticks-75th-falcon-rocket-landing-after-launching-60-more-starlink-satellites/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2021-02-24T12:25:00.000Z",
    "static_fire_date_unix": 1614169500,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the sixteenth batch of operational Starlink satellites, which are version 1.0, from LC-39A. It is the eighteenth Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90d",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "5fbfedc654ceb10a5664c814"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 118,
    "name": "Starlink-17 (v1.0)",
    "date_utc": "2021-03-04T08:24:00.000Z",
    "date_unix": 1614846240,
    "date_local": "2021-03-04T03:24:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591833b13b2659",
        "flight": 8,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "dfd4f0e0-0ab4-494d-bd88-1b93b934b269",
    "id": "5fbfecfe54ceb10a5664c80b"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c909",
        "5ea6ed2f080df4000697c90c"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/m0yww5/rspacex_starlink20_official_launch_discussion/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51027544097_799f5baccc_o.jpg",
          "https://live.staticflickr.com/65535/51027443336_3e7486be6f_o.jpg",
          "https://live.staticflickr.com/65535/51027443321_9a59458d39_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/U4sWbTfrzj8",
      "youtube_id": "U4sWbTfrzj8",
      "article": "https://spaceflightnow.com/2021/03/11/spacex-adds-more-satellites-to-starlink-internet-fleet/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2021-03-09T23:00:00.000Z",
    "static_fire_date_unix": 1615330800,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the 20th batch of operational Starlink satellites, which are version 1.0, from LC-39A or SLC-40. It is the 21st Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ee68c683c228f36bd5809b5",
      "5ea6ed2e080df4000697c909",
      "5ea6ed2f080df4000697c90c"
    ],
    "capsules": [],
    "payloads": [
      "600f9bcb8f798e2a4d5f97a5"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 119,
    "name": "Starlink-20 (v1.0)",
    "date_utc": "2021-03-11T08:13:00.000Z",
    "date_unix": 1615450380,
    "date_local": "2021-03-11T03:13:00-05:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591817f23b2663",
        "flight": 6,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "134eb787-244e-4131-8b03-c9fbd0a11efc",
    "id": "600f9a718f798e2a4d5f979d"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c909",
        "5ea6ed2f080df4000697c90c"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/m4e377/rspacex_starlink21_launch_discussion_updates/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51036945097_9fc94fa9a9_o.jpg",
          "https://live.staticflickr.com/65535/51036945067_ce0d5b3c0b_o.jpg",
          "https://live.staticflickr.com/65535/51036945027_47c96d71d1_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/JKf45ATgATc",
      "youtube_id": "JKf45ATgATc",
      "article": "https://spaceflightnow.com/2021/03/14/spacex-extends-its-own-rocket-reuse-record-on-starlink-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the 21st batch of operational Starlink satellites, which are version 1.0, from LC-39A or SLC-40. It is the 22nd Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed2e080df4000697c909",
      "5ea6ed2f080df4000697c90c",
      "5ea6ed2f080df4000697c90d",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "600f9bd88f798e2a4d5f97a6"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 120,
    "name": "Starlink-21 (v1.0)",
    "date_utc": "2021-03-14T10:01:00.000Z",
    "date_unix": 1615716060,
    "date_local": "2021-03-14T06:01:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f35918c0803b265c",
        "flight": 9,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "896d876d-e834-4810-8a5e-44d6b6a42630",
    "id": "600f9a8d8f798e2a4d5f979e"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "6059166413f40e27e8af34b6",
        "5ea6ed2f080df4000697c90b"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/maqmd0/rspacex_starlink22_launch_discussion_updates/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://youtu.be/a15czI9B91c",
      "youtube_id": "a15czI9B91c",
      "article": "https://spaceflightnow.com/2021/03/24/spacex-launches-25th-mission-to-build-out-starlink-internet-network/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the 22nd batch of operational Starlink satellites, which are version 1.0, from or SLC-40. It is the 23rd Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ee68c683c228f36bd5809b5",
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90b",
      "6059166413f40e27e8af34b6"
    ],
    "capsules": [],
    "payloads": [
      "60428afbc041c16716f73cdd"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 121,
    "name": "Starlink-22 (v1.0)",
    "date_utc": "2021-03-24T08:28:00.000Z",
    "date_unix": 1616574480,
    "date_local": "2021-03-24T04:28:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5ef670f10059c33cee4a826c",
        "flight": 6,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "ec03fe36-fe2a-4e43-8e10-d07d5349f1de",
    "id": "60428aafc041c16716f73cd7"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": null,
      "ships": [
        "6059166413f40e27e8af34b6",
        "5ea6ed2f080df4000697c90b",
        "5ea6ed2e080df4000697c908"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/mlitqf/rspacex_starlink23_launch_discussion_updates/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51101836837_8671b88722_o.jpg",
          "https://live.staticflickr.com/65535/51101836832_e151d33d66_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/Uy9Jn-3vuPs",
      "youtube_id": "Uy9Jn-3vuPs",
      "article": "https://spaceflightnow.com/2021/04/07/spacex-launches-its-100th-mission-from-floridas-space-coast/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the 23rd batch of operational Starlink satellites, which are version 1.0, from or SLC-40 or LC-39A. It is the 24th Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ee68c683c228f36bd5809b5",
      "5ea6ed2f080df4000697c90b"
    ],
    "capsules": [],
    "payloads": [
      "60428b02c041c16716f73cde"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 122,
    "name": "Starlink-23 (v1.0)",
    "date_utc": "2021-04-07T16:34:00.000Z",
    "date_unix": 1617813240,
    "date_local": "2021-04-07T12:34:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591817f23b2663",
        "flight": 7,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "385455f4-067e-4c24-9937-ca8283ed3307",
    "id": "60428ac4c041c16716f73cd8"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://imgur.com/SS92zpG.png",
        "large": "https://imgur.com/OvSAk3K.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/lrx7ez/crew2_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/mvcst9/rspacex_crew2_launch_discussion_updates_thread/",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51136761295_edb4d3ba1d_o.jpg",
          "https://live.staticflickr.com/65535/51135652706_3e8448193d_o.jpg",
          "https://live.staticflickr.com/65535/51135865043_3ee9818a56_o.jpg",
          "https://live.staticflickr.com/65535/51136428854_4723547f5a_o.jpg",
          "https://live.staticflickr.com/65535/51134975562_ca678d7e2f_o.jpg",
          "https://live.staticflickr.com/65535/51135650561_0bd04e5a56_o.jpg",
          "https://live.staticflickr.com/65535/51135650711_f65e45739d_o.jpg",
          "https://live.staticflickr.com/65535/51136428874_30a1912bc6_o.jpg",
          "https://live.staticflickr.com/65535/51135650696_80bb4d0047_o.jpg",
          "https://live.staticflickr.com/65535/51135650641_f8c77b5420_o.jpg",
          "https://live.staticflickr.com/65535/51136428829_2b995a79bc_o.jpg",
          "https://live.staticflickr.com/65535/51135650621_187bc9fa5b_o.jpg",
          "https://live.staticflickr.com/65535/51135324597_816d0bc217_o.jpg",
          "https://live.staticflickr.com/65535/51135997286_1b5a4452f0_o.jpg",
          "https://live.staticflickr.com/65535/51136428899_eb329865d1_o.jpg",
          "https://live.staticflickr.com/65535/51136428909_d4d6cf76ae_o.jpg",
          "https://live.staticflickr.com/65535/51136761220_9a2e6dbaf6_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/lW07SN3YoLI",
      "youtube_id": "lW07SN3YoLI",
      "article": "https://spaceflightnow.com/2021/04/23/spacex-launches-astronauts-on-refurbished-capsule-and-flight-proven-rocket/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_Crew-2"
    },
    "static_fire_date_utc": "2021-04-17T11:01:00.000Z",
    "static_fire_date_unix": 1618657260,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX launches the second operational mission of its Crew Dragon vehicle as part of NASA's Commercial Crew Program, carrying NASA astronauts Shane Kimbrough, Megan McArthur, Thomas Pesquet, and Akihiko Hoshide to the International Space Station. The Falcon 9 and Crew Dragon lift off from LC-39A, Kennedy Space Center. Both the booster and the capsule have flown previously, each a first for a commercial crew flight. The booster for this mission is expected to land on an ASDS. The mission will be complete with the safe return of the astronauts to Earth.",
    "crew": [
      "5fe3ba5fb3467846b3242188",
      "5fe3bb01b3467846b3242189",
      "5fe3bc3db3467846b324218b",
      "5fe3bc8ab3467846b324218c"
    ],
    "ships": [
      "5ea6ed2e080df4000697c909",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [
      "5e9e2c5df359188aba3b2676"
    ],
    "payloads": [
      "5fe3b3adb3467846b3242173"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 123,
    "name": "Crew-2",
    "date_utc": "2021-04-23T09:49:00.000Z",
    "date_unix": 1619171340,
    "date_local": "2021-04-23T05:49:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5f57c53d0622a6330279009f",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "32dcb5ad-7609-4fc0-8094-768ee5c2ebe0",
    "id": "5fe3af58b3467846b324215f"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "6059166413f40e27e8af34b6"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/mzol0k/rspacex_starlink24_launch_discussion_updates/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51146838376_4667d78231_o.jpg",
          "https://live.staticflickr.com/65535/51147622479_d027e09727_o.jpg",
          "https://live.staticflickr.com/65535/51147949685_975bd6b4ee_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/RBxkRKZ34yo",
      "youtube_id": "RBxkRKZ34yo",
      "article": "https://spaceflightnow.com/2021/04/29/spacex-launches-60-more-starlink-spacecraft-fcc-clears-spacex-to-fly-satellites-at-lower-altitudes/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the 24th batch of operational Starlink satellites, which are version 1.0, from LC-39A or SLC-40. It is the 25th Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ea6ed2f080df4000697c90d",
      "5ee68c683c228f36bd5809b5",
      "6059166413f40e27e8af34b6"
    ],
    "capsules": [],
    "payloads": [
      "605b4be3aa5433645e37d046"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 124,
    "name": "Starlink-24 (v1.0)",
    "date_utc": "2021-04-29T03:44:00.000Z",
    "date_unix": 1619667840,
    "date_local": "2021-04-28T23:44:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5ef670f10059c33cee4a826c",
        "flight": 7,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "fbd23c86-89d0-4d3f-b5fb-5d7165d05cca",
    "id": "605b4b6aaa5433645e37d03f"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "6059166413f40e27e8af34b6"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/n3z0aa/rspacex_starlink25_launch_discussion_updates/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://youtu.be/xpl_JnG7rcg",
      "youtube_id": "xpl_JnG7rcg",
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2021-05-03T05:00:00.000Z",
    "static_fire_date_unix": 1620018000,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the 25th batch of operational Starlink satellites, which are version 1.0, from LC-39A. It is the 26th Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on OCISLY.",
    "crew": [],
    "ships": [
      "608c1a06cf7f3d6152666ad4",
      "5ea6ed30080df4000697c913",
      "6059166413f40e27e8af34b6"
    ],
    "capsules": [],
    "payloads": [
      "605b4befaa5433645e37d047"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 125,
    "name": "Starlink-25 (v1.0)",
    "date_utc": "2021-05-04T19:01:00.000Z",
    "date_unix": 1620154860,
    "date_local": "2021-05-04T15:01:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591833b13b2659",
        "flight": 9,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "1ecc82c0-c5c8-41f0-aa58-b50a3b839ae0",
    "id": "605b4b7daa5433645e37d040"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "6059166413f40e27e8af34b6"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/n7ju15/rspacex_starlink27_launch_discussion_updates/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://youtu.be/J71s2KmkSrc",
      "youtube_id": "J71s2KmkSrc",
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the 26th batch of operational Starlink satellites, which are version 1.0, from SLC-40. It is the 27th Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ee68c683c228f36bd5809b5",
      "6059166413f40e27e8af34b6"
    ],
    "capsules": [],
    "payloads": [
      "6079bd5e9a06446e8c61bf7c"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 126,
    "name": "Starlink-27 (v1.0)",
    "date_utc": "2021-05-09T06:42:00.000Z",
    "date_unix": 1620542520,
    "date_local": "2021-05-09T02:42:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a6f35918c0803b265c",
        "flight": 10,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "e5085f22-208b-4b28-b66c-fd4bd9df90e7",
    "id": "6079bd1c9a06446e8c61bf76"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": null,
      "ships": [
        "6059166413f40e27e8af34b6"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/ncfexu/rspacex_starlink26_launch_discussion_updates/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51171344450_6a3f0e08b9_o.jpg",
          "https://live.staticflickr.com/65535/51170251791_9b36fba5b7_o.jpg",
          "https://live.staticflickr.com/65535/51185653708_86840b1672_o.jpg",
          "https://live.staticflickr.com/65535/51185653723_7bd9ecab87_o.jpg",
          "https://live.staticflickr.com/65535/51186506630_1a47a43787_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/tdgg_qwj-hI",
      "youtube_id": "tdgg_qwj-hI",
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the 27th batch of operational Starlink satellites, which are version 1.0, from LC-39A or SLC-40. It is the 28th Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on an ASDS.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "6059166413f40e27e8af34b6",
      "608c1a06cf7f3d6152666ad4",
      "5ea6ed2f080df4000697c90b"
    ],
    "capsules": [],
    "payloads": [
      "605b4bfcaa5433645e37d048",
      "609f48374a12e4692eae4667",
      "609f49c64a12e4692eae4668"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 127,
    "name": "Starlink-26 (v1.0) + Capella-6 + Tyvak-0130",
    "date_utc": "2021-05-15T22:54:00.000Z",
    "date_unix": 1621119240,
    "date_local": "2021-05-15T18:54:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a7f3591817f23b2663",
        "flight": 8,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "c32d1f5e-2dd9-4b55-ac8b-3eb8c4a4e955",
    "id": "605b4b95aa5433645e37d041"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2e080df4000697c909",
        "5ea6ed2f080df4000697c90c"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/nkxg4s/rspacex_starlink28_launch_discussion_and_updates/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51225270061_42bc3abb43_o.jpg",
          "https://live.staticflickr.com/65535/51226036719_584d141279_o.jpg",
          "https://live.staticflickr.com/65535/51225480623_5ef7d3957a_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/xRu-ekesDyY",
      "youtube_id": "xRu-ekesDyY",
      "article": "https://spaceflightnow.com/2021/05/26/first-phase-of-spacexs-starlink-network-nears-completion-with-falcon-9-launch/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "This mission launches the 28th batch of operational Starlink satellites, which were version 1.0, from SLC-40. It was the 29th Starlink launch overall. The satellites plan to be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on ASDS JRTI.",
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913",
      "5ea6ed2f080df4000697c90c",
      "5ee68c683c228f36bd5809b5",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2e080df4000697c909"
    ],
    "capsules": [],
    "payloads": [
      "6079bd679a06446e8c61bf7d"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 128,
    "name": "Starlink-28 (v1.0)",
    "date_utc": "2021-05-26T18:59:00.000Z",
    "date_unix": 1622055540,
    "date_local": "2021-05-26T14:59:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5f57c54a0622a633027900a1",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "fb25ecf0-fb51-4b5e-b678-105f6ba4c06e",
    "id": "6079bd399a06446e8c61bf77"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://imgur.com/o6zaoex.png",
        "large": "https://imgur.com/klt5qq2.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/nhztq5/crs22_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/nqqojc/rspacex_crs22_launch_docking_discussion_updates/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51225482033_086576f2cd_o.jpg",
          "https://live.staticflickr.com/65535/51226340205_9c3ac87b8e_o.jpg",
          "https://live.staticflickr.com/65535/51224563112_61d493b775_o.jpg",
          "https://live.staticflickr.com/65535/51224563062_95bf029b80_o.jpg",
          "https://live.staticflickr.com/65535/51225271661_49315dc688_o.jpg",
          "https://live.staticflickr.com/65535/51226340225_27df994080_o.jpg",
          "https://live.staticflickr.com/65535/51224563102_d07c630ef5_o.jpg",
          "https://live.staticflickr.com/65535/51225482053_1fe7157f74_o.jpg",
          "https://live.staticflickr.com/65535/51226038164_304c347347_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/QXf9mRWbXDM",
      "youtube_id": "QXf9mRWbXDM",
      "article": "https://spaceflightnow.com/2021/06/03/spacex-supply-ship-launches-on-mission-to-begin-upgrading-space-station-electrical-grid/",
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-22"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's 22nd ISS resupply mission on behalf of NASA, this mission sends essential supplies to the International Space Station using the cargo variant of SpaceX's Dragon 2 spacecraft. The external payload for this mission is the first pair of ISS Roll Out Solar Arrays. Falcon 9 and Dragon launch from LC-39A, Kennedy Space Center and the booster is expected to land on an ASDS. The mission will be complete with splashdown and recovery of the capsule and down cargo.",
    "crew": [],
    "ships": [
      "5ea6ed2f080df4000697c90b",
      "608c1a06cf7f3d6152666ad4",
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [
      "60b803421f83cc1e59f1644d"
    ],
    "payloads": [
      "5fe3b642b3467846b324217b"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 129,
    "name": "CRS-22 & IROSA",
    "date_utc": "2021-06-03T17:29:00.000Z",
    "date_unix": 1622741340,
    "date_local": "2021-06-03T13:29:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "60b800111f83cc1e59f16438",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "89a150ea-6e4b-489f-853c-3603ae684611",
    "id": "5fe3af84b3467846b3242161"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "5ea6ed2f080df4000697c90b",
        "5ea6ed2e080df4000697c909"
      ]
    },
    "links": {
      "patch": {
        "small": "https://i.imgur.com/Iphd7Aj.png",
        "large": "https://i.imgur.com/X9q44xx.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/n9llxw/sxm8_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/nss9br/rspacex_sxm8_launch_discussion_and_updates_thread/",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://youtu.be/bgtDRR2F2wA",
      "youtube_id": "bgtDRR2F2wA",
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/Sirius_XM#Satellites"
    },
    "static_fire_date_utc": "2021-06-03T06:32:00.000Z",
    "static_fire_date_unix": 1622701920,
    "net": false,
    "window": 5940,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX launches the second of two next generation satellites for SiriusXM from SLC-40, Cape Canaveral Space Force Station. The spacecraft will be delivered into a sub-synchronous geostationary transfer orbit and will replace XM-4 in geostationary orbit. The booster for this mission will land on an ASDS.",
    "crew": [],
    "ships": [
      "5ee68c683c228f36bd5809b5",
      "5ea6ed2f080df4000697c910",
      "5ea6ed2f080df4000697c90b",
      "5ea6ed2e080df4000697c909"
    ],
    "capsules": [],
    "payloads": [
      "5fe3b57db3467846b324217a"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 130,
    "name": "SXM-8",
    "date_utc": "2021-06-06T04:26:00.000Z",
    "date_unix": 1622953560,
    "date_local": "2021-06-06T00:26:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5f57c53d0622a6330279009f",
        "flight": 3,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "edaf9a8d-d67c-4e0e-8452-a37b111581d5",
    "id": "5fe3af6db3467846b3242160"
  },
  {
    "fairings": {
      "reused": false,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "60c8c7a45d4819007ea69871"
      ]
    },
    "links": {
      "patch": {
        "small": "https://i.imgur.com/sZIYIsl.png",
        "large": "https://i.imgur.com/n4PN2ko.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/nuud0l/gps_iii_sv05_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/o0gcnq/rspacex_gps_iii_sv05_launch_discussion_and/",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51254829184_e6e1d0d79c_o.jpg",
          "https://live.staticflickr.com/65535/51253353892_de82b01e23_o.jpg",
          "https://live.staticflickr.com/65535/51254285968_288383ce6e_o.jpg",
          "https://live.staticflickr.com/65535/51254829154_3c5980c086_o.jpg",
          "https://live.staticflickr.com/65535/51253353882_e59ea4df4f_o.jpg",
          "https://live.staticflickr.com/65535/51254829139_ca68c19689_o.jpg",
          "https://live.staticflickr.com/65535/51262926489_9fbce20e9c_o.jpg",
          "https://live.staticflickr.com/65535/51262926469_974292477d_o.jpg",
          "https://live.staticflickr.com/65535/51262179176_e4302db116_o.jpg",
          "https://live.staticflickr.com/65535/51263224735_3210fb7499_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/QJXxVtp3KqI",
      "youtube_id": "QJXxVtp3KqI",
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/GPS_Block_III"
    },
    "static_fire_date_utc": "2021-06-13T19:30:00.000Z",
    "static_fire_date_unix": 1623612600,
    "net": false,
    "window": 900,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's fourth GPS III launch will use the first stage from the previous GPS mission. This will be the first time a National Security Space Launch has flown on a flight proven booster. Falcon 9 will launch from SLC-40, Cape Canaveral and the booster will land downrange on a drone ship. GPS III is the third generation of the U.S. Space Force's NAVSTAR Global Positioning System satellites, developed by Lockheed Martin. The GPS III constellation will feature a cross-linked command and control architecture, allowing the entire GPS constellation to be updated simultaneously from a single ground station. A new spot beam capability for enhanced military coverage and increased resistance to hostile jamming will be incorporated.",
    "crew": [],
    "ships": [
      "60c8c7a45d4819007ea69871",
      "5ee68c683c228f36bd5809b5",
      "5ea6ed2f080df4000697c910"
    ],
    "capsules": [],
    "payloads": [
      "5eb0e4d2b6c3bb0006eeb261"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 131,
    "name": "GPS III SV05",
    "date_utc": "2021-06-17T16:09:00.000Z",
    "date_unix": 1623946140,
    "date_local": "2021-06-17T12:09:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5f57c5440622a633027900a0",
        "flight": 2,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "110c808a-a091-47ab-8532-4fa058c1de7a",
    "id": "5eb87d4effd86e000604b390"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": true,
      "recovered": true,
      "ships": [
        "60c8c7a45d4819007ea69871"
      ]
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/IJWn9pK.png",
        "large": "https://imgur.com/u49XVx4.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/nz7rai/transporter2_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/o9ki7u/rspacex_transporter2_launch_discussion_and/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51283430951_a9e5a41141_o.jpg",
          "https://live.staticflickr.com/65535/51283430936_3852120bbe_o.jpg",
          "https://live.staticflickr.com/65535/51283604493_d1a088b7c9_o.jpg",
          "https://live.staticflickr.com/65535/51284454795_591717faee_o.jpg",
          "https://live.staticflickr.com/65535/51284454810_9fdd0e8db4_o.jpg",
          "https://live.staticflickr.com/65535/51283604443_6d92fe1231_o.jpg",
          "https://live.staticflickr.com/65535/51283604428_b24ebf1b5f_o.jpg",
          "https://live.staticflickr.com/65535/51283604438_7202e2a388_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/sSiuW1HcGjA",
      "youtube_id": "sSiuW1HcGjA",
      "article": null,
      "wikipedia": null
    },
    "static_fire_date_utc": "2021-06-22T15:24:00.000Z",
    "static_fire_date_unix": 1624375440,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Falcon 9 launches to sun-synchronous polar orbit from Florida as part of SpaceX's Rideshare program dedicated to smallsat customers. The mission lifts off from SLC-40, Cape Canaveral on a southward azimuth and performs a dogleg maneuver. The booster for this mission is expected to return to LZ-1 based on FCC communications filings. This rideshare takes approximately 90 satellites and hosted payloads into orbit on a variety of deployers including three free-flying spacecraft which dispense their customers' satellites after separation from the SpaceX stack.",
    "crew": [],
    "ships": [
      "60c8c7a45d4819007ea69871"
    ],
    "capsules": [],
    "payloads": [
      "608ac397eb3e50044e3630e7"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 132,
    "name": "Transporter-2",
    "date_utc": "2021-06-30T19:31:00.000Z",
    "date_unix": 1625081460,
    "date_local": "2021-06-30T15:31:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5ef670f10059c33cee4a826c",
        "flight": 8,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "RTLS",
        "landpad": "5e9e3032383ecb267a34e7c7"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "5d248abe-17ef-43ce-9c04-aef33af40520",
    "id": "600f9b6d8f798e2a4d5f979f"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://i.imgur.com/ZBUSrcD.png",
        "large": "https://i.imgur.com/yPv13SR.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/p67i27/crs23_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/pcj0ao/rspacex_crs23_launch_docking_discussion_updates/",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51411435986_82d7088b61_o.jpg",
          "https://live.staticflickr.com/65535/51411702583_fe67991413_o.jpg",
          "https://live.staticflickr.com/65535/51411702573_de10cdbc06_o.jpg",
          "https://live.staticflickr.com/65535/51411435116_ac7b3cc3d1_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/x-KiDqxAMU0",
      "youtube_id": "x-KiDqxAMU0",
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/SpaceX_CRS-23"
    },
    "static_fire_date_utc": "2021-08-26T02:49:00.000Z",
    "static_fire_date_unix": 1629946140,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "SpaceX's 23rd ISS resupply mission on behalf of NASA, this mission brings essential supplies to the International Space Station using the cargo variant of SpaceX's Dragon 2 spacecraft. Cargo includes several science experiments. The booster for this mission is expected to land on an ASDS. The mission will be complete with return and recovery of the Dragon capsule and down cargo.",
    "crew": [],
    "ships": [
      "5ea6ed2d080df4000697c904"
    ],
    "capsules": [],
    "payloads": [
      "5fe3c4f2b3467846b3242193"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 133,
    "name": "CRS-23",
    "date_utc": "2021-08-29T07:14:00.000Z",
    "date_unix": 1630221240,
    "date_local": "2021-08-29T03:14:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5f57c53d0622a6330279009f",
        "flight": 4,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecb075134e7cd"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "13386512-85bb-4c93-a9b0-f5eac05fbe4f",
    "id": "5fe3b11eb3467846b324216c"
  },
  {
    "fairings": {
      "reused": true,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/pmn0xm/rspacex_starlink21_launch_discussion_and_updates/",
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": [
          "https://live.staticflickr.com/65535/51474853666_be4615e186_o.jpg",
          "https://live.staticflickr.com/65535/51475097383_dcf9002e9c_o.jpg"
        ]
      },
      "presskit": null,
      "webcast": "https://youtu.be/4372QYiPZB4",
      "youtube_id": "4372QYiPZB4",
      "article": "https://spaceflightnow.com/2021/09/14/spacex-launches-first-full-batch-of-laser-equipped-starlink-satellites/",
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": "2021-09-02T17:29:00.000Z",
    "static_fire_date_unix": 1630603740,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [
      "5ea6ed30080df4000697c913"
    ],
    "capsules": [],
    "payloads": [
      "60e3bf3373359e1e20335c3c"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 134,
    "name": "Starlink-2.1",
    "date_utc": "2021-09-14T03:55:00.000Z",
    "date_unix": 1631591700,
    "date_local": "2021-09-13T20:55:00-07:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5e9e28a5f3591833b13b2659",
        "flight": 10,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3032383ecb6bb234e7ca"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "6b9f9fe6-7f94-498b-a664-7c9e42dbe76d",
    "id": "60e3bf0d73359e1e20335c37"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://i.imgur.com/J1uM5nz.png",
        "large": "https://i.imgur.com/jYYTXwC.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/pc1fq7/inspiration4_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/po651k/rspacex_inspiration4_launch_discussion_updates/",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://youtu.be/3pv01sSq44w",
      "youtube_id": "3pv01sSq44w",
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/Inspiration4"
    },
    "static_fire_date_utc": "2021-09-13T07:07:00.000Z",
    "static_fire_date_unix": 1631516820,
    "net": false,
    "window": 18000,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Inspiration4 is the world’s first all-civilian mission to space. The mission will be commanded by Jared Isaacman, the 37-year-old founder and Chief Executive Officer of Shift4 Payments and an accomplished pilot and adventurer. Inspiration4 will leave Earth from Kennedy Space Center’s historic Launch Complex 39A, the embarkation point for Apollo and Space Shuttle missions, and travel across a low earth orbit on a multi-day journey that will continually eclipse more than 90% of the earth’s population. Named in recognition of the four-person crew that will raise awareness and funds for St. Jude Children’s Research Hospital, this milestone represents a new era for human spaceflight and exploration.",
    "crew": [
      "607a3a5f5a906a44023e0870",
      "607a3ab45a906a44023e0872",
      "607b48375a906a44023e08b8",
      "607b48da5a906a44023e08b9"
    ],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ee68c683c228f36bd5809b5",
      "614251b711a64135defb3654"
    ],
    "capsules": [
      "5f6f99fddcfdf403df379709"
    ],
    "payloads": [
      "607a382f5a906a44023e0867"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 135,
    "name": "Inspiration4",
    "date_utc": "2021-09-16T00:02:00.000Z",
    "date_unix": 1631750520,
    "date_local": "2021-09-15T20:02:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5f57c5440622a633027900a0",
        "flight": 3,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "621d64e6-0513-45dc-8ffa-c9fd56518398",
    "id": "607a37565a906a44023e0866"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": null,
        "large": null
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": null,
      "youtube_id": null,
      "article": null,
      "wikipedia": null
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69974db09d1ed",
    "success": null,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5fe3b86eb3467846b324217c"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 136,
    "name": "USSF-44",
    "date_utc": "2021-10-09T00:00:00.000Z",
    "date_unix": 1633737600,
    "date_local": "2021-10-08T20:00:00-04:00",
    "date_precision": "day",
    "upcoming": true,
    "cores": [
      {
        "core": "5fe3b8f2b3467846b3242181",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": null,
        "landing_type": "ASDS",
        "landpad": null
      },
      {
        "core": "5fe3b8fbb3467846b3242182",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": null,
        "landing_type": "RTLS",
        "landpad": null
      },
      {
        "core": "5fe3b906b3467846b3242183",
        "flight": 1,
        "gridfins": true,
        "legs": true,
        "reused": false,
        "landing_attempt": true,
        "landing_success": null,
        "landing_type": "RTLS",
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "16d0c02e-0bb1-45d5-a3f5-7c4ff6cf6de1",
    "id": "5fe3af99b3467846b3242162"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": null,
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": null,
      "youtube_id": null,
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": null,
    "failures": [],
    "details": "This mission launches the 29th batch of operational Starlink satellites, which are version 1.0, from LC-39A or SLC-40. It is the 30th Starlink launch overall. The satellites will be delivered to low Earth orbit and will spend a few weeks maneuvering to their operational altitude. The booster is expected to land on an ASDS.",
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "60b3b89e998a020e76e32851"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 137,
    "name": "Starlink-29 (v1.0)",
    "date_utc": "2021-10-01T00:00:00.000Z",
    "date_unix": 1633046400,
    "date_local": "2021-09-30T20:00:00-04:00",
    "date_precision": "month",
    "upcoming": true,
    "cores": [
      {
        "core": null,
        "flight": null,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": null,
        "landing_type": "ASDS",
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "e4200e5c-2726-43f2-8439-36bd1be59821",
    "id": "60b3b843998a020e76e3284b"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": "https://imgur.com/BrW201S.png",
        "large": "https://imgur.com/573IfGk.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/jhu37i/starlink_general_discussion_and_deployment_thread/",
        "launch": null,
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": null,
      "youtube_id": null,
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/Starlink"
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": null,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "60b3b8ab998a020e76e32852"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 138,
    "name": "Starlink-30 (v1.0)",
    "date_utc": "2021-10-01T00:00:00.000Z",
    "date_unix": 1633046400,
    "date_local": "2021-09-30T20:00:00-04:00",
    "date_precision": "month",
    "upcoming": true,
    "cores": [
      {
        "core": null,
        "flight": null,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": null,
        "landing_type": "ASDS",
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "60b3b85a998a020e76e3284c"
  },
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://i.imgur.com/KhQ11oo.png",
        "large": "https://i.imgur.com/M6GvRVe.png"
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": null,
      "youtube_id": null,
      "article": null,
      "wikipedia": null
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": 0,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": null,
    "failures": [],
    "details": null,
    "crew": [
      "5fe3c587b3467846b3242198",
      "5fe3c5beb3467846b3242199",
      "5fe3c5f6b3467846b324219a",
      "60c4b5ad4e041c0b356db393"
    ],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5fe3b3bab3467846b3242174"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 139,
    "name": "Crew-3",
    "date_utc": "2021-10-31T06:37:00.000Z",
    "date_unix": 1635662220,
    "date_local": "2021-10-31T02:37:00-04:00",
    "date_precision": "hour",
    "upcoming": true,
    "cores": [
      {
        "core": null,
        "flight": null,
        "gridfins": null,
        "legs": null,
        "reused": null,
        "landing_attempt": null,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5fe3b15eb3467846b324216d"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": null,
        "large": null
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": "https://www.reddit.com/r/spacex/comments/k2ts1q/rspacex_fleet_updates_discussion_thread/"
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": null,
      "youtube_id": null,
      "article": null,
      "wikipedia": null
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": null,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5fe3b2abb3467846b3242172"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 140,
    "name": "SARah 1",
    "date_utc": "2021-10-01T00:00:00.000Z",
    "date_unix": 1633046400,
    "date_local": "2021-09-30T17:00:00-07:00",
    "date_precision": "month",
    "upcoming": true,
    "cores": [
      {
        "core": null,
        "flight": null,
        "gridfins": null,
        "legs": null,
        "reused": null,
        "landing_attempt": null,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5fe3af43b3467846b324215e"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": null,
        "large": null
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": null,
      "youtube_id": null,
      "article": null,
      "wikipedia": null
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": null,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5fe3c4a6b3467846b3242192"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 143,
    "name": "DART",
    "date_utc": "2021-11-24T00:00:00.000Z",
    "date_unix": 1637712000,
    "date_local": "2021-11-23T16:00:00-08:00",
    "date_precision": "day",
    "upcoming": true,
    "cores": [
      {
        "core": "5f57c54a0622a633027900a1",
        "flight": 2,
        "gridfins": null,
        "legs": null,
        "reused": true,
        "landing_attempt": null,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5fe3b107b3467846b324216b"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": null,
        "large": null
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": null,
      "youtube_id": null,
      "article": null,
      "wikipedia": null
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": null,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "5fe3c080b3467846b3242190"
    ],
    "launchpad": "5e9e4501f509094ba4566f84",
    "flight_number": 148,
    "name": "Turksat 5B",
    "date_utc": "2021-10-01T00:00:00.000Z",
    "date_unix": 1633046400,
    "date_local": "2021-09-30T20:00:00-04:00",
    "date_precision": "quarter",
    "upcoming": true,
    "cores": [
      {
        "core": null,
        "flight": null,
        "gridfins": null,
        "legs": null,
        "reused": null,
        "landing_attempt": null,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "5fe3afc1b3467846b3242164"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": null,
        "large": null
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": null,
      "youtube_id": null,
      "article": null,
      "wikipedia": null
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": null,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "607a35435a906a44023e0863"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 151,
    "name": "NROL-87",
    "date_utc": "2022-02-02T00:00:00.000Z",
    "date_unix": 1643760000,
    "date_local": "2022-02-01T16:00:00-08:00",
    "date_precision": "day",
    "upcoming": true,
    "cores": [
      {
        "core": null,
        "flight": null,
        "gridfins": null,
        "legs": null,
        "reused": null,
        "landing_attempt": null,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "607a34e35a906a44023e085e"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": null,
        "large": null
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": null,
      "youtube_id": null,
      "article": null,
      "wikipedia": null
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": null,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "607a364e5a906a44023e0865"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 153,
    "name": "WorldView Legion 1-2",
    "date_utc": "2022-03-01T00:00:00.000Z",
    "date_unix": 1646092800,
    "date_local": "2022-02-28T16:00:00-08:00",
    "date_precision": "month",
    "upcoming": true,
    "cores": [
      {
        "core": null,
        "flight": null,
        "gridfins": null,
        "legs": null,
        "reused": null,
        "landing_attempt": null,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "607a35b55a906a44023e0864"
  },
  {
    "fairings": {
      "reused": null,
      "recovery_attempt": null,
      "recovered": null,
      "ships": []
    },
    "links": {
      "patch": {
        "small": null,
        "large": null
      },
      "reddit": {
        "campaign": null,
        "launch": null,
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": null,
      "youtube_id": null,
      "article": null,
      "wikipedia": null
    },
    "static_fire_date_utc": null,
    "static_fire_date_unix": null,
    "net": false,
    "window": null,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": null,
    "failures": [],
    "details": null,
    "crew": [],
    "ships": [],
    "capsules": [],
    "payloads": [
      "608d3d7fffcee803616cbde7"
    ],
    "launchpad": "5e9e4502f509092b78566f87",
    "flight_number": 157,
    "name": "NROL-85",
    "date_utc": "2022-01-01T00:00:00.000Z",
    "date_unix": 1640995200,
    "date_local": "2021-12-31T16:00:00-08:00",
    "date_precision": "quarter",
    "upcoming": true,
    "cores": [
      {
        "core": null,
        "flight": null,
        "gridfins": null,
        "legs": null,
        "reused": null,
        "landing_attempt": null,
        "landing_success": null,
        "landing_type": null,
        "landpad": null
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": null,
    "id": "608d3d23ffcee803616cbde2"
  }
]

export const LandingPads = [
  {
    "images": {
      "large": [
        "https://i.imgur.com/KHBk6jO.png"
      ]
    },
    "name": "LZ-1",
    "full_name": "Landing Zone 1",
    "status": "active",
    "type": "RTLS",
    "locality": "Cape Canaveral",
    "region": "Florida",
    "latitude": 28.485833,
    "longitude": -80.544444,
    "landing_attempts": 18,
    "landing_successes": 17,
    "wikipedia": "https://en.wikipedia.org/wiki/Landing_Zones_1_and_2",
    "details": "SpaceX's first east coast landing pad is Landing Zone 1, where the historic first Falcon 9 landing occurred in December 2015. LC-13 was originally used as a launch pad for early Atlas missiles and rockets from Lockheed Martin. LC-1 was later expanded to include Landing Zone 2 for side booster RTLS Falcon Heavy missions, and it was first used in February 2018 for that purpose.",
    "launches": [
      "5eb87cefffd86e000604b342",
      "5eb87cf9ffd86e000604b349",
      "5eb87cfeffd86e000604b34d",
      "5eb87d01ffd86e000604b350",
      "5eb87d03ffd86e000604b352",
      "5eb87d07ffd86e000604b356",
      "5eb87d09ffd86e000604b358",
      "5eb87d0effd86e000604b35c",
      "5eb87d10ffd86e000604b35e",
      "5eb87d13ffd86e000604b360",
      "5eb87d26ffd86e000604b371",
      "5eb87d2dffd86e000604b376",
      "5eb87d35ffd86e000604b37a",
      "5eb87d36ffd86e000604b37b",
      "5eb87d42ffd86e000604b384",
      "5eb87d47ffd86e000604b38a",
      "5f8399fb818d8b59f5740d43",
      "600f9b6d8f798e2a4d5f979f"
    ],
    "id": "5e9e3032383ecb267a34e7c7"
  },
  {
    "images": {
      "large": [
        "https://i.imgur.com/YE8PMYX.png"
      ]
    },
    "name": "LZ-2",
    "full_name": "Landing Zone 2",
    "status": "active",
    "type": "RTLS",
    "locality": "Cape Canaveral",
    "region": "Florida",
    "latitude": 28.485833,
    "longitude": -80.544444,
    "landing_attempts": 3,
    "landing_successes": 3,
    "wikipedia": "https://en.wikipedia.org/wiki/Landing_Zones_1_and_2",
    "details": "SpaceX's first east coast landing pad is Landing Zone 1, where the historic first Falcon 9 landing occurred in December 2015. LC-13 was originally used as a launch pad for early Atlas missiles and rockets from Lockheed Martin. LC-1 was later expanded to include Landing Zone 2 for side booster RTLS Falcon Heavy missions, and it was first used in February 2018 for that purpose.",
    "launches": [
      "5eb87d13ffd86e000604b360",
      "5eb87d2dffd86e000604b376",
      "5eb87d35ffd86e000604b37a"
    ],
    "id": "5e9e3032383ecb90a834e7c8"
  },
  {
    "images": {
      "large": [
        "https://i.imgur.com/647XbH6.png"
      ]
    },
    "name": "LZ-4",
    "full_name": "Landing Zone 4",
    "status": "active",
    "type": "RTLS",
    "locality": "Vandenberg Air Force Base",
    "region": "California",
    "latitude": 34.632989,
    "longitude": -120.615167,
    "landing_attempts": 3,
    "landing_successes": 3,
    "wikipedia": "https://en.wikipedia.org/wiki/Vandenberg_AFB_Space_Launch_Complex_4#LZ-4_landing_history",
    "details": "SpaceX's west coast landing pad. The pad is adjacent to SLC-4E, SpaceX's west coast launch site. The pad was under construction for about a year starting in 2016. After concerns with seal mating season, this pad was first used for the SAOCOM 1A mission in October 2018. Officially referred to as LZ-4 in FCC filings.",
    "launches": [
      "5eb87d23ffd86e000604b36e",
      "5eb87d31ffd86e000604b379",
      "5ed983aa1f30554030d45c31"
    ],
    "id": "5e9e3032383ecb554034e7c9"
  },
  {
    "images": {
      "large": [
        "https://i.imgur.com/rbpkg01.png"
      ]
    },
    "name": "OCISLY",
    "full_name": "Of Course I Still Love You",
    "status": "active",
    "type": "ASDS",
    "locality": "Port Canaveral",
    "region": "Florida",
    "latitude": 33.7291858,
    "longitude": -118.262015,
    "landing_attempts": 54,
    "landing_successes": 47,
    "wikipedia": "https://en.wikipedia.org/wiki/Autonomous_spaceport_drone_ship",
    "details": "The second ASDS barge, Of Course I Still Love You (OCISLY), had been under construction in a Louisiana shipyard since early 2015 using a different hull—Marmac 304—in order to service launches on the east coast. It was built as a replacement for the first Just Read the Instructions and entered operational service for Falcon 9 Flight 19 in late June 2015. As of June 2015, its home port was Jacksonville, Florida, but after December 2015, it was transferred 160 miles (260 km) further south, at Port Canaveral. While the dimensions of the ship are nearly identical to the first ASDS, several enhancements were made including a steel blast wall erected between the aft containers and the landing deck. The ship was in place for a first-stage landing test on the CRS-7 mission, which failed on launch on 28 June 2015. On 8 April 2016 the first stage, which launched the Dragon CRS-8 spacecraft, successfully landed for the first time ever on OCISLY, which is also the first ever drone ship landing. In February 2018, the Falcon Heavy Test Flight's central core exploded upon impact next to OCISLY that damaged two of the four thrusters on the drone ship. Two thrusters were removed from the Marmac 303 barge in order to repair OCISLY.",
    "launches": [
      "5eb87ceeffd86e000604b341",
      "5eb87cf2ffd86e000604b344",
      "5eb87cf3ffd86e000604b345",
      "5eb87cf5ffd86e000604b346",
      "5eb87cf6ffd86e000604b347",
      "5eb87cf8ffd86e000604b348",
      "5eb87cfaffd86e000604b34a",
      "5eb87cfbffd86e000604b34b",
      "5eb87d00ffd86e000604b34f",
      "5eb87d04ffd86e000604b353",
      "5eb87d0cffd86e000604b35a",
      "5eb87d0dffd86e000604b35b",
      "5eb87d13ffd86e000604b360",
      "5eb87d18ffd86e000604b365",
      "5eb87d19ffd86e000604b366",
      "5eb87d1effd86e000604b36a",
      "5eb87d20ffd86e000604b36c",
      "5eb87d22ffd86e000604b36d",
      "5eb87d24ffd86e000604b36f",
      "5eb87d2affd86e000604b374",
      "5eb87d2bffd86e000604b375",
      "5eb87d2dffd86e000604b376",
      "5eb87d2effd86e000604b377",
      "5eb87d30ffd86e000604b378",
      "5eb87d35ffd86e000604b37a",
      "5eb87d39ffd86e000604b37d",
      "5eb87d39ffd86e000604b37e",
      "5eb87d3bffd86e000604b37f",
      "5eb87d3cffd86e000604b380",
      "5eb87d3fffd86e000604b382",
      "5eb87d41ffd86e000604b383",
      "5eb87d43ffd86e000604b385",
      "5eb87d44ffd86e000604b386",
      "5eb87d46ffd86e000604b388",
      "5eb87d46ffd86e000604b389",
      "5ed9819a1f30554030d45c29",
      "5ed981d91f30554030d45c2a",
      "5ef6a1e90059c33cee4a828a",
      "5ef6a2090059c33cee4a828b",
      "5ef6a2bf0059c33cee4a828c",
      "5eb87d4cffd86e000604b38d",
      "5fb95b3f3a88ae63c954603c",
      "5eb87d4effd86e000604b391",
      "5fd386aa7faea57d297c86c1",
      "5ff6554f9257f579ee3a6c5f",
      "600f9a5e8f798e2a4d5f979c",
      "5fbfecfe54ceb10a5664c80b",
      "600f9a8d8f798e2a4d5f979e",
      "60428aafc041c16716f73cd7",
      "60428ac4c041c16716f73cd8",
      "5fe3af58b3467846b324215f",
      "605b4b7daa5433645e37d040",
      "6079bd1c9a06446e8c61bf76",
      "605b4b95aa5433645e37d041",
      "5fe3af84b3467846b3242161",
      "60e3bf0d73359e1e20335c37"
    ],
    "id": "5e9e3032383ecb6bb234e7ca"
  },
  {
    "images": {
      "large": [
        "https://i.imgur.com/gZUJ04V.png"
      ]
    },
    "name": "JRTI-1",
    "full_name": "Just Read The Instructions V1",
    "status": "retired",
    "type": "ASDS",
    "locality": "Port Canaveral",
    "region": "Florida",
    "latitude": 28.4104,
    "longitude": -80.6188,
    "landing_attempts": 2,
    "landing_successes": 0,
    "wikipedia": "https://en.wikipedia.org/wiki/Autonomous_spaceport_drone_ship",
    "details": "The ASDS landing location for the first landing test was in the Atlantic approximately 200 miles (320 km) northeast of the launch location at Cape Canaveral, and 165 miles (266 km) southeast of Charleston, South Carolina. SpaceX's Just Read the Instructions, based on the Marmac 300 deck barge, in position for a landing test on Falcon 9 Flight 17 in April 2015. On 23 January 2015, during repairs to the ship following the unsuccessful first test, Musk announced that the ship was to be named Just Read the Instructions, with a sister ship planned for west coast launches to be named Of Course I Still Love You. On 29 January, SpaceX released a manipulated photo of the ship with the name illustrating how it would look once painted. Both ships are named after two General Contact Units, spaceships commanded by autonomous artificial intelligences, that appear in The Player of Games, a Culture novel by Iain M. Banks. The first Just Read the Instructions was retired in May 2015 after approximately six months of service in the Atlantic, and its duties were assumed by Of Course I Still Love You. The former ASDS was modified by removing the wing extensions that had extended the barge surface and the equipment (thrusters, cameras and communications gear) that had been added to refit it as an ASDS; these items were saved for future reuse.",
    "launches": [
      "5eb87ce8ffd86e000604b33c",
      "5eb87cecffd86e000604b33f"
    ],
    "id": "5e9e3032383ecb761634e7cb"
  },
  {
    "images": {
      "large": [
        "https://i.imgur.com/46y4O15.png"
      ]
    },
    "name": "JRTI",
    "full_name": "Just Read The Instructions",
    "status": "active",
    "type": "ASDS",
    "locality": "Port of Los Angeles",
    "region": "California",
    "latitude": 33.7291858,
    "longitude": -118.262015,
    "landing_attempts": 22,
    "landing_successes": 21,
    "wikipedia": "https://en.wikipedia.org/wiki/Autonomous_spaceport_drone_ship",
    "details": "The third ASDS barge, using the Marmac 303 hull, was built during 2015 in a Louisiana shipyard, and the barge transited the Panama Canal in June 2015 carrying its wing extensions as cargo on the deck because the ASDS, when complete, would be too wide to pass through the canal. The home port for the Marmac 303 is the Port of Los Angeles, at the AltaSea marine research and business campus in San Pedro's outer harbor. The landing platform and tender vessels began docking there in July 2015 in advance of the main construction of AltaSea which is scheduled for 2017. SpaceX announced that the Marmac 303 would be the second ASDS to be named Just Read the Instructions (JRtI) in January 2016, shortly before its first use as a landing platform for Falcon 9 Flight 21. On 17 January 2016, JRtI was put to first use in an attempt to recover a Falcon 9 first-stage booster from the Jason-3 mission from Vandenberg. The booster successfully landed on the deck; however, a lockout collet failed to engage on one of the legs causing the rocket to tip over, exploding on impact with the deck.[23] On January 14, 2017, SpaceX launched Falcon 9 Flight 29 from Vandenberg and landed the first stage on the JRtI that was located about 370 km (230 mi) downrange in the Pacific Ocean, making it the first successful landing in the Pacific.",
    "launches": [
      "5eb87cf0ffd86e000604b343",
      "5eb87cfdffd86e000604b34c",
      "5eb87d05ffd86e000604b354",
      "5eb87d08ffd86e000604b357",
      "5eb87d0affd86e000604b359",
      "5eb87d1fffd86e000604b36b",
      "5eb87d25ffd86e000604b370",
      "5eb87d28ffd86e000604b373",
      "5eb87d45ffd86e000604b387",
      "5eb87d4affd86e000604b38b",
      "5eb87d50ffd86e000604b394",
      "5ef6a2e70059c33cee4a8293",
      "5eb87d4dffd86e000604b38e",
      "5eb87d4bffd86e000604b38c",
      "5eb87d4fffd86e000604b393",
      "5fbfecce54ceb10a5664c80a",
      "600f9a718f798e2a4d5f979d",
      "605b4b6aaa5433645e37d03f",
      "6079bd399a06446e8c61bf77",
      "5fe3af6db3467846b3242160",
      "5eb87d4effd86e000604b390",
      "607a37565a906a44023e0866"
    ],
    "id": "5e9e3033383ecbb9e534e7cc"
  },
  {
    "images": {
      "large": [
        "https://i.imgur.com/PkrS8vQ.png"
      ]
    },
    "name": "ASOG",
    "full_name": "A Shortfall of Gravitas",
    "status": "active",
    "type": "ASDS",
    "locality": "Port Canaveral",
    "region": "Florida",
    "latitude": 28.4104,
    "longitude": -80.6188,
    "landing_attempts": 1,
    "landing_successes": 1,
    "wikipedia": "https://en.wikipedia.org/wiki/Autonomous_spaceport_drone_ship",
    "details": "The fourth ASDS barge was announced to be under construction in February 2018 and it will become the second active east coast-based ASDS. It will be homeported at Port Canaveral. This future simultaneously usable ASDS, along with OCISLY, is called A Shortfall of Gravitas (ASoG) and like the rest of the fleet, its naming is based on names used in the Culture series. The droneship is expected to be operational in mid-2019.",
    "launches": [
      "5fe3b11eb3467846b324216c"
    ],
    "id": "5e9e3033383ecb075134e7cd"
  }
]

export const LaunchPads = [
  {
    "images": {
      "large": [
        "https://i.imgur.com/7uXe1Kv.png"
      ]
    },
    "name": "VAFB SLC 3W",
    "full_name": "Vandenberg Space Force Base Space Launch Complex 3W",
    "locality": "Vandenberg Space Force Base",
    "region": "California",
    "latitude": 34.6440904,
    "longitude": -120.5931438,
    "launch_attempts": 0,
    "launch_successes": 0,
    "rockets": [
      "5e9d0d95eda69955f709d1eb"
    ],
    "timezone": "America/Los_Angeles",
    "launches": [],
    "status": "retired",
    "details": "SpaceX's original west coast launch pad for Falcon 1. It was used in a static fire test but was never employed for a launch, and was abandoned due to range scheduling conflicts arising from overflying other active pads.",
    "id": "5e9e4501f5090910d4566f83"
  },
  {
    "images": {
      "large": [
        "https://i.imgur.com/9oEMXwa.png"
      ]
    },
    "name": "CCSFS SLC 40",
    "full_name": "Cape Canaveral Space Force Station Space Launch Complex 40",
    "locality": "Cape Canaveral",
    "region": "Florida",
    "latitude": 28.5618571,
    "longitude": -80.577366,
    "launch_attempts": 75,
    "launch_successes": 73,
    "rockets": [
      "5e9d0d95eda69973a809d1ec"
    ],
    "timezone": "America/New_York",
    "launches": [
      "5eb87cddffd86e000604b32f",
      "5eb87cdeffd86e000604b330",
      "5eb87cdfffd86e000604b331",
      "5eb87ce0ffd86e000604b332",
      "5eb87ce1ffd86e000604b333",
      "5eb87ce2ffd86e000604b335",
      "5eb87ce3ffd86e000604b336",
      "5eb87ce4ffd86e000604b337",
      "5eb87ce4ffd86e000604b338",
      "5eb87ce5ffd86e000604b339",
      "5eb87ce6ffd86e000604b33a",
      "5eb87ce7ffd86e000604b33b",
      "5eb87ce8ffd86e000604b33c",
      "5eb87ceaffd86e000604b33d",
      "5eb87ceaffd86e000604b33e",
      "5eb87cecffd86e000604b33f",
      "5eb87cedffd86e000604b340",
      "5eb87ceeffd86e000604b341",
      "5eb87cefffd86e000604b342",
      "5eb87cf2ffd86e000604b344",
      "5eb87cf3ffd86e000604b345",
      "5eb87cf5ffd86e000604b346",
      "5eb87cf6ffd86e000604b347",
      "5eb87cf8ffd86e000604b348",
      "5eb87cf9ffd86e000604b349",
      "5eb87cfaffd86e000604b34a",
      "5eb87cfbffd86e000604b34b",
      "5eb87d0effd86e000604b35c",
      "5eb87d10ffd86e000604b35e",
      "5eb87d11ffd86e000604b35f",
      "5eb87d15ffd86e000604b362",
      "5eb87d16ffd86e000604b364",
      "5eb87d18ffd86e000604b365",
      "5eb87d1bffd86e000604b368",
      "5eb87d1cffd86e000604b369",
      "5eb87d1effd86e000604b36a",
      "5eb87d20ffd86e000604b36c",
      "5eb87d22ffd86e000604b36d",
      "5eb87d26ffd86e000604b371",
      "5eb87d27ffd86e000604b372",
      "5eb87d2affd86e000604b374",
      "5eb87d2effd86e000604b377",
      "5eb87d30ffd86e000604b378",
      "5eb87d36ffd86e000604b37b",
      "5eb87d37ffd86e000604b37c",
      "5eb87d39ffd86e000604b37d",
      "5eb87d39ffd86e000604b37e",
      "5eb87d3bffd86e000604b37f",
      "5eb87d3cffd86e000604b380",
      "5eb87d3fffd86e000604b382",
      "5eb87d41ffd86e000604b383",
      "5eb87d42ffd86e000604b384",
      "5eb87d45ffd86e000604b387",
      "5eb87d46ffd86e000604b389",
      "5eb87d4affd86e000604b38b",
      "5eb87d50ffd86e000604b394",
      "5ed981d91f30554030d45c2a",
      "5eb87d47ffd86e000604b38a",
      "5ef6a2e70059c33cee4a8293",
      "5eb87d4cffd86e000604b38d",
      "5fb95b3f3a88ae63c954603c",
      "5eb87d4bffd86e000604b38c",
      "5eb87d4fffd86e000604b393",
      "5fd386aa7faea57d297c86c1",
      "5ff6554f9257f579ee3a6c5f",
      "600f9a5e8f798e2a4d5f979c",
      "600f9a718f798e2a4d5f979d",
      "60428aafc041c16716f73cd7",
      "60428ac4c041c16716f73cd8",
      "605b4b6aaa5433645e37d03f",
      "6079bd1c9a06446e8c61bf76",
      "6079bd399a06446e8c61bf77",
      "5fe3af6db3467846b3242160",
      "5eb87d4effd86e000604b390",
      "600f9b6d8f798e2a4d5f979f"
    ],
    "status": "active",
    "details": "SpaceX's primary Falcon 9 pad, where all east coast Falcon 9s launched prior to the AMOS-6 anomaly. Previously used alongside SLC-41 to launch Titan rockets for the US Air Force, the pad was heavily damaged by the AMOS-6 anomaly in September 2016. It returned to flight with CRS-13 on December 15, 2017, boasting an upgraded throwback-style Transporter-Erector modeled after that at LC-39A.",
    "id": "5e9e4501f509094ba4566f84"
  },
  {
    "images": {
      "large": [
        "https://i.imgur.com/ZzTTC5p.png"
      ]
    },
    "name": "STLS",
    "full_name": "SpaceX South Texas Launch Site",
    "locality": "Boca Chica Village",
    "region": "Texas",
    "latitude": 25.9972641,
    "longitude": -97.1560845,
    "launch_attempts": 0,
    "launch_successes": 0,
    "rockets": [],
    "timezone": "America/Chicago",
    "launches": [],
    "status": "under construction",
    "details": "SpaceX's new private launch site currently under construction for suborbital test flights of Starship, and potentially orbital flights of the full super heavy stack (previously referred to as BFR) in the future. Currently planned to enter use with static fires and test hops of the Starhopper, with the first tethered hop successfully occurring in March 2019. It was previously going to be used for Falcon 9 and Falcon Heavy flights, but this no longer appears to be likely due to its construction timeline and existing launch sites being sufficient to handle present demand. Due to the Caribbean islands and off-shore oil wells, it will be limited to very few possible launch trajectories, and current Texas law only allows a limited number of beach closures per year for orbital launches.",
    "id": "5e9e4502f5090927f8566f85"
  },
  {
    "images": {
      "large": [
        "https://i.imgur.com/GGPgsVs.png"
      ]
    },
    "name": "Kwajalein Atoll",
    "full_name": "Kwajalein Atoll Omelek Island",
    "locality": "Omelek Island",
    "region": "Marshall Islands",
    "latitude": 9.0477206,
    "longitude": 167.7431292,
    "launch_attempts": 5,
    "launch_successes": 2,
    "rockets": [
      "5e9d0d95eda69955f709d1eb"
    ],
    "timezone": "Pacific/Kwajalein",
    "launches": [
      "5eb87cd9ffd86e000604b32a",
      "5eb87cdaffd86e000604b32b",
      "5eb87cdbffd86e000604b32c",
      "5eb87cdbffd86e000604b32d",
      "5eb87cdcffd86e000604b32e"
    ],
    "status": "retired",
    "details": "SpaceX's original pad, where all of the Falcon 1 flights occurred (from 2006 to 2009). It would have also been the launch site of the Falcon 1e and the Falcon 9, but it was abandoned as SpaceX ended the Falcon 1 program and decided against upgrading it to support Falcon 9, likely due to its remote location and ensuing logistics complexities.",
    "id": "5e9e4502f5090995de566f86"
  },
  {
    "images": {
      "large": [
        "https://i.imgur.com/asp5L08.png"
      ]
    },
    "name": "VAFB SLC 4E",
    "full_name": "Vandenberg Space Force Base Space Launch Complex 4E",
    "locality": "Vandenberg Space Force Base",
    "region": "California",
    "latitude": 34.632093,
    "longitude": -120.610829,
    "launch_attempts": 17,
    "launch_successes": 17,
    "rockets": [
      "5e9d0d95eda69973a809d1ec"
    ],
    "timezone": "America/Los_Angeles",
    "launches": [
      "5eb87ce1ffd86e000604b334",
      "5eb87cf0ffd86e000604b343",
      "5eb87cfdffd86e000604b34c",
      "5eb87d05ffd86e000604b354",
      "5eb87d08ffd86e000604b357",
      "5eb87d0affd86e000604b359",
      "5eb87d0fffd86e000604b35d",
      "5eb87d14ffd86e000604b361",
      "5eb87d16ffd86e000604b363",
      "5eb87d1affd86e000604b367",
      "5eb87d1fffd86e000604b36b",
      "5eb87d23ffd86e000604b36e",
      "5eb87d25ffd86e000604b370",
      "5eb87d28ffd86e000604b373",
      "5eb87d31ffd86e000604b379",
      "5ed983aa1f30554030d45c31",
      "60e3bf0d73359e1e20335c37"
    ],
    "status": "active",
    "details": "SpaceX's primary west coast launch pad for polar orbits and sun-synchronous orbits, primarily used for Iridium NEXT and scientific satellite launches. The pad was used for the debut of Falcon 9 v1.1 in the rocket's first ever non-dragon mission, CASSIOPE, in September 2013. It is SpaceX's only remaining pad with the old-style transporter/erector, which reclines prior to launch instead of using a throwback procedure. It is also capable of launching Falcon Heavy (although some pad modifications would be needed, but no west coast Falcon Heavy missions are currently planned).",
    "id": "5e9e4502f509092b78566f87"
  },
  {
    "images": {
      "large": [
        "https://i.imgur.com/1jwU0Pk.png"
      ]
    },
    "name": "KSC LC 39A",
    "full_name": "Kennedy Space Center Historic Launch Complex 39A",
    "locality": "Cape Canaveral",
    "region": "Florida",
    "latitude": 28.6080585,
    "longitude": -80.6039558,
    "launch_attempts": 39,
    "launch_successes": 39,
    "rockets": [
      "5e9d0d95eda69973a809d1ec",
      "5e9d0d95eda69974db09d1ed"
    ],
    "timezone": "America/New_York",
    "launches": [
      "5eb87cfeffd86e000604b34d",
      "5eb87cfeffd86e000604b34e",
      "5eb87d00ffd86e000604b34f",
      "5eb87d01ffd86e000604b350",
      "5eb87d01ffd86e000604b351",
      "5eb87d03ffd86e000604b352",
      "5eb87d04ffd86e000604b353",
      "5eb87d06ffd86e000604b355",
      "5eb87d07ffd86e000604b356",
      "5eb87d09ffd86e000604b358",
      "5eb87d0cffd86e000604b35a",
      "5eb87d0dffd86e000604b35b",
      "5eb87d13ffd86e000604b360",
      "5eb87d19ffd86e000604b366",
      "5eb87d24ffd86e000604b36f",
      "5eb87d2bffd86e000604b375",
      "5eb87d2dffd86e000604b376",
      "5eb87d35ffd86e000604b37a",
      "5eb87d3dffd86e000604b381",
      "5eb87d43ffd86e000604b385",
      "5eb87d44ffd86e000604b386",
      "5eb87d46ffd86e000604b388",
      "5ed9819a1f30554030d45c29",
      "5ef6a1e90059c33cee4a828a",
      "5ef6a2090059c33cee4a828b",
      "5ef6a2bf0059c33cee4a828c",
      "5eb87d4dffd86e000604b38e",
      "5eb87d4effd86e000604b391",
      "5f8399fb818d8b59f5740d43",
      "5fbfecce54ceb10a5664c80a",
      "5fbfecfe54ceb10a5664c80b",
      "600f9a8d8f798e2a4d5f979e",
      "5fe3af58b3467846b324215f",
      "605b4b7daa5433645e37d040",
      "605b4b95aa5433645e37d041",
      "5fe3af84b3467846b3242161",
      "5fe3b11eb3467846b324216c",
      "607a37565a906a44023e0866",
      "6161d2006db1a92bfba85356"
    ],
    "status": "active",
    "details": "NASA's historic pad that launched most of the Saturn V and Space Shuttle missions, including Apollo 11. SpaceX initially leased solely for Falcon Heavy and Crew Dragon launches, but the company has also used it for others as well following the damage to SLC-40 in the AMOS-6 explosion. After completing the necessary modifications, the first launch SpaceX performed on the pad was CRS-10 in February 2017. After SLC-40 was back online, 39A was upgraded to support Falcon Heavy and complete the removal of the shuttle-era Rotating Service Structure. More recently, a crew access arm and other safety equipment has been installed in order to launch commercial crew missions. 39A also occasionally launches other Falcon 9 missions between Falcon Heavy and Crew Dragon launches, depending on pad scheduling. The pad may also potentially be upgraded in the future for use with the BFR.",
    "id": "5e9e4502f509094188566f88"
  }
]

export const DemoLaunch = [
  {
    "fairings": null,
    "links": {
      "patch": {
        "small": "https://i.imgur.com/J1uM5nz.png",
        "large": "https://i.imgur.com/jYYTXwC.png"
      },
      "reddit": {
        "campaign": "https://www.reddit.com/r/spacex/comments/pc1fq7/inspiration4_launch_campaign_thread/",
        "launch": "https://www.reddit.com/r/spacex/comments/po651k/rspacex_inspiration4_launch_discussion_updates/",
        "media": null,
        "recovery": null
      },
      "flickr": {
        "small": [],
        "original": []
      },
      "presskit": null,
      "webcast": "https://youtu.be/3pv01sSq44w",
      "youtube_id": "3pv01sSq44w",
      "article": null,
      "wikipedia": "https://en.wikipedia.org/wiki/Inspiration4"
    },
    "static_fire_date_utc": "2021-09-13T07:07:00.000Z",
    "static_fire_date_unix": 1631516820,
    "net": false,
    "window": 18000,
    "rocket": "5e9d0d95eda69973a809d1ec",
    "success": true,
    "failures": [],
    "details": "Inspiration4 is the world’s first all-civilian mission to space. The mission will be commanded by Jared Isaacman, the 37-year-old founder and Chief Executive Officer of Shift4 Payments and an accomplished pilot and adventurer. Inspiration4 will leave Earth from Kennedy Space Center’s historic Launch Complex 39A, the embarkation point for Apollo and Space Shuttle missions, and travel across a low earth orbit on a multi-day journey that will continually eclipse more than 90% of the earth’s population. Named in recognition of the four-person crew that will raise awareness and funds for St. Jude Children’s Research Hospital, this milestone represents a new era for human spaceflight and exploration.",
    "crew": [
      "607a3a5f5a906a44023e0870",
      "607a3ab45a906a44023e0872",
      "607b48375a906a44023e08b8",
      "607b48da5a906a44023e08b9"
    ],
    "ships": [
      "5ea6ed2f080df4000697c910",
      "5ee68c683c228f36bd5809b5",
      "614251b711a64135defb3654"
    ],
    "capsules": [
      "5f6f99fddcfdf403df379709"
    ],
    "payloads": [
      "607a382f5a906a44023e0867"
    ],
    "launchpad": "5e9e4502f509094188566f88",
    "flight_number": 135,
    "name": "Inspiration4",
    "date_utc": "2021-09-16T00:02:00.000Z",
    "date_unix": 1631750520,
    "date_local": "2021-09-15T20:02:00-04:00",
    "date_precision": "hour",
    "upcoming": false,
    "cores": [
      {
        "core": "5f57c5440622a633027900a0",
        "flight": 3,
        "gridfins": true,
        "legs": true,
        "reused": true,
        "landing_attempt": true,
        "landing_success": true,
        "landing_type": "ASDS",
        "landpad": "5e9e3033383ecbb9e534e7cc"
      }
    ],
    "auto_update": true,
    "tbd": false,
    "launch_library_id": "621d64e6-0513-45dc-8ffa-c9fd56518398",
    "id": "607a37565a906a44023e0866"
  }
]